var ln = Object.defineProperty;
var an = (e, a, t) => a in e ? ln(e, a, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[a] = t;
var ge = (e, a, t) => (an(e, typeof a != "symbol" ? a + "" : a, t), t);
import { ref as P, computed as b, watch as G, onMounted as Te, openBlock as p, createElementBlock as T, normalizeClass as $, renderSlot as C, createCommentVNode as R, getCurrentInstance as je, createBlock as I, resolveDynamicComponent as J, withCtx as E, getCurrentScope as Cl, onScopeDispose as wl, effectScope as nn, unref as x, toRefs as rl, toRef as K, readonly as ot, customRef as on, isRef as xt, reactive as it, nextTick as pe, shallowRef as Sl, defineComponent as Z, watchEffect as sn, mergeProps as ae, toValue as ft, createTextVNode as q, toDisplayString as D, createElementVNode as N, Fragment as ee, renderList as se, shallowReadonly as Ie, useSlots as Fe, createVNode as fe, normalizeProps as we, Transition as Et, withDirectives as Be, vShow as $l, resolveComponent as xl, normalizeStyle as He, mergeModels as Ne, useModel as Nt, inject as Xe, vModelCheckbox as ul, provide as vt, vModelRadio as dl, vModelSelect as rn, Teleport as mt, guardReactiveProps as Pe, resolveDirective as un, onBeforeUnmount as Vl, onBeforeMount as dn, pushScopeId as cn, popScopeId as fn, withKeys as _e, withModifiers as Ge, useAttrs as vn, onUnmounted as Tl } from "vue";
const Ae = (e, a) => {
  const t = e.__vccOpts || e;
  for (const [l, n] of a)
    t[l] = n;
  return t;
}, mn = ["role"], gn = ["aria-label"], pn = {
  __name: "Alert",
  props: {
    /**
     * The label for the dismiss button.
     */
    dismissLabel: {
      type: String,
      default: "close"
    },
    /**
     * A boolean indicating whether the Alert is dismissible.
     */
    dismissible: {
      type: Boolean,
      default: !1
    },
    /**
     * A boolean to control the fade animation of the Alert.
     */
    fade: {
      type: Boolean,
      default: !1
    },
    /**
     * The initial visibility state of the Alert. It can be a boolean, number, or string.
     */
    show: {
      type: [Boolean, Number, String],
      default: null
    },
    /**
     * The visual variant of the Alert.
     */
    variant: {
      type: String,
      default: "info"
    },
    /**
     * The model value for controlling the visibility of the Alert.
     */
    modelValue: {
      type: [Boolean, Number, String],
      default: null
    }
  },
  emits: [
    "update:modelValue",
    "dismissed",
    "dismiss-count-down",
    "input"
  ],
  setup(e, { emit: a }) {
    const t = a, l = e, n = P(!1), o = P(0), i = P(!1), r = b(() => i.value !== !1 && i.value !== "false" && i.value !== 0), u = () => {
      n.value = !0, o.value = parseInt(i.value), o.value > 0 && s(), t("update:modelValue", n.value);
    }, f = () => {
      n.value = !1, o.value = 0, t("update:modelValue", n.value), t("dismissed");
    }, s = () => {
      const c = setInterval(() => {
        o.value -= 1, o.value <= 0 && (clearInterval(c), f()), t("dismiss-count-down", o.value);
      }, 1e3);
    }, m = () => {
      f();
    };
    G(r, (c) => {
      c ? u() : f();
    }), G(
      () => i.value,
      (c) => {
        t("input", c);
      }
    ), G(
      () => l.modelValue,
      () => {
        d();
      }
    ), G(
      () => l.show,
      () => {
        d();
      }
    );
    function d() {
      l.modelValue !== null && l.show !== null ? (console.warn(
        "You should use v-model or show prop, not both. v-model has higher priority."
      ), i.value = l.modelValue) : l.modelValue !== null ? i.value = l.modelValue : i.value = l.show;
    }
    return Te(() => {
      d();
    }), (c, v) => n.value ? (p(), T("div", {
      key: 0,
      class: $([
        "alert",
        "fade",
        "show",
        e.dismissible ? "alert-dismissible" : null,
        "alert-" + e.variant
      ]),
      role: e.dismissible ? "alert" : "alertdialog"
    }, [
      C(c.$slots, "default", {}, void 0, !0),
      e.dismissible ? (p(), T("button", {
        key: 0,
        type: "button",
        class: $([{ "btn-close": !c.$slots.dismiss }]),
        "aria-label": e.dismissLabel,
        role: "button",
        onClick: m
      }, [
        C(c.$slots, "dismiss", {}, void 0, !0)
      ], 10, gn)) : R("", !0)
    ], 10, mn)) : R("", !0);
  }
}, Fl = /* @__PURE__ */ Ae(pn, [["__scopeId", "data-v-a5b82ee5"]]), bn = {
  install: (e) => {
    e.component("BAlert", Fl);
  }
}, yn = {
  __name: "Badge",
  props: {
    pill: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    tag: {
      type: String,
      default: "span"
    },
    target: {
      type: String,
      default: "_self"
    },
    variant: {
      type: String,
      default: "secondary"
    },
    href: {
      type: String,
      default: null
    },
    to: {
      type: [Object, String],
      default: void 0
    },
    replace: {
      type: Boolean,
      default: !1
    },
    textIndicator: {
      type: Boolean,
      default: !1
    },
    dotIndicator: {
      type: Boolean,
      default: !1
    },
    rel: {
      type: String,
      default: null
    }
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    const t = je(), l = a, n = e, o = b(() => [
      "badge",
      `text-bg-${n.variant}`,
      n.pill ? "rounded-pill" : "",
      n.textIndicator ? "position-absolute top-0 start-100 translate-middle" : "",
      n.dotIndicator ? "position-absolute top-0 start-100 translate-middle p-2 border border-light rounded-circle" : "",
      n.href || n.to ? "text-decoration-none badge-link" : ""
    ]), i = b(() => {
      const f = "router-link", s = f.split("-").map((d) => d.charAt(0).toUpperCase() + d.slice(1)).join(""), m = (t == null ? void 0 : t.appContext.app.component(s)) !== void 0;
      return n.href || n.to !== void 0 && !m ? "a" : n.to !== void 0 && m ? f : n != null && n.tag ? n == null ? void 0 : n.tag : "span";
    }), r = b(() => {
      const f = "#";
      if (n.href)
        return n.href;
      if (n.to && typeof n.to == "string")
        return n.to || f;
      const { to: s } = n;
      if (s !== void 0 && "path" in s) {
        const m = s.path || "", d = s.query ? `?${Object.keys(s.query).map((v) => {
          var k;
          return `${v}=${(k = s.query) == null ? void 0 : k[v]}`;
        }).join("=")}` : "", c = !s.hash || s.hash.charAt(0) === "#" ? s.hash || "" : `#${s.hash}`;
        return `${m}${d}${c}` || f;
      }
      return null;
    });
    function u(f) {
      n.disabled || l("click", f);
    }
    return (f, s) => (p(), I(J(i.value), {
      class: $(o.value),
      disabled: e.disabled && !r.value ? e.disabled : null,
      href: r.value,
      to: e.to,
      rel: r.value ? e.rel : null,
      replace: !e.replace && i.value !== "router-link" ? null : e.replace,
      onClick: u
    }, {
      default: E(() => [
        C(f.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["class", "disabled", "href", "to", "rel", "replace"]));
  }
}, Al = /* @__PURE__ */ Ae(yn, [["__scopeId", "data-v-83d9dd81"]]), hn = {
  install: (e) => {
    e.component("BBadge", Al);
  }
};
function Oe(e) {
  return Cl() ? (wl(e), !0) : !1;
}
function Bn(e) {
  let a = !1, t;
  const l = nn(!0);
  return (...n) => (a || (t = l.run(() => e(...n)), a = !0), t);
}
function kn(e, a) {
  if (typeof Symbol < "u") {
    const t = { ...e };
    return Object.defineProperty(t, Symbol.iterator, {
      enumerable: !1,
      value() {
        let l = 0;
        return {
          next: () => ({
            value: a[l++],
            done: l > a.length
          })
        };
      }
    }), t;
  } else
    return Object.assign([...a], e);
}
function ie(e) {
  return typeof e == "function" ? e() : x(e);
}
function Cn(e) {
  if (!xt(e))
    return it(e);
  const a = new Proxy({}, {
    get(t, l, n) {
      return x(Reflect.get(e.value, l, n));
    },
    set(t, l, n) {
      return xt(e.value[l]) && !xt(n) ? e.value[l].value = n : e.value[l] = n, !0;
    },
    deleteProperty(t, l) {
      return Reflect.deleteProperty(e.value, l);
    },
    has(t, l) {
      return Reflect.has(e.value, l);
    },
    ownKeys() {
      return Object.keys(e.value);
    },
    getOwnPropertyDescriptor() {
      return {
        enumerable: !0,
        configurable: !0
      };
    }
  });
  return it(a);
}
function wn(e) {
  return Cn(b(e));
}
function Ol(e, ...a) {
  const t = a.flat(), l = t[0];
  return wn(() => Object.fromEntries(typeof l == "function" ? Object.entries(rl(e)).filter(([n, o]) => !l(ie(o), n)) : Object.entries(rl(e)).filter((n) => !t.includes(n[0]))));
}
const Il = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Sn = (e) => typeof e < "u", $n = (e) => e != null, xn = Object.prototype.toString, Vn = (e) => xn.call(e) === "[object Object]", Se = () => {
}, At = /* @__PURE__ */ Tn();
function Tn() {
  var e, a;
  return Il && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((a = window == null ? void 0 : window.navigator) == null ? void 0 : a.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function Fn(e) {
  const a = /* @__PURE__ */ Object.create(null);
  return (t) => a[t] || (a[t] = e(t));
}
const An = /-(\w)/g, On = Fn((e) => e.replace(An, (a, t) => t ? t.toUpperCase() : ""));
function In(e) {
  return e || je();
}
function Pn(...e) {
  if (e.length !== 1)
    return K(...e);
  const a = e[0];
  return typeof a == "function" ? ot(on(() => ({ get: a, set: Se }))) : P(a);
}
function Ln(e, a = !0, t) {
  const l = In(t);
  l ? Te(e, l) : a ? e() : pe(e);
}
function Le(e, a = {}) {
  const {
    method: t = "parseFloat",
    radix: l,
    nanToZero: n
  } = a;
  return b(() => {
    let o = ie(e);
    return typeof o == "string" && (o = Number[t](o, l)), n && Number.isNaN(o) && (o = 0), o;
  });
}
function Pl(e = {}) {
  const {
    inheritAttrs: a = !0
  } = e, t = Sl(), l = /* @__PURE__ */ Z({
    setup(o, { slots: i }) {
      return () => {
        t.value = i.default;
      };
    }
  }), n = /* @__PURE__ */ Z({
    inheritAttrs: a,
    setup(o, { attrs: i, slots: r }) {
      return () => {
        var u;
        if (!t.value && process.env.NODE_ENV !== "production")
          throw new Error("[VueUse] Failed to find the definition of reusable template");
        const f = (u = t.value) == null ? void 0 : u.call(t, { ...En(i), $slots: r });
        return a && (f == null ? void 0 : f.length) === 1 ? f[0] : f;
      };
    }
  });
  return kn(
    { define: l, reuse: n },
    [l, n]
  );
}
function En(e) {
  const a = {};
  for (const t in e)
    a[On(t)] = e[t];
  return a;
}
function ue(e) {
  var a;
  const t = ie(e);
  return (a = t == null ? void 0 : t.$el) != null ? a : t;
}
const ye = Il ? window : void 0;
function ce(...e) {
  let a, t, l, n;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([t, l, n] = e, a = ye) : [a, t, l, n] = e, !a)
    return Se;
  Array.isArray(t) || (t = [t]), Array.isArray(l) || (l = [l]);
  const o = [], i = () => {
    o.forEach((s) => s()), o.length = 0;
  }, r = (s, m, d, c) => (s.addEventListener(m, d, c), () => s.removeEventListener(m, d, c)), u = G(
    () => [ue(a), ie(n)],
    ([s, m]) => {
      if (i(), !s)
        return;
      const d = Vn(m) ? { ...m } : m;
      o.push(
        ...t.flatMap((c) => l.map((v) => r(s, c, v, d)))
      );
    },
    { immediate: !0, flush: "post" }
  ), f = () => {
    u(), i();
  };
  return Oe(f), f;
}
let cl = !1;
function Nn(e, a, t = {}) {
  const { window: l = ye, ignore: n = [], capture: o = !0, detectIframe: i = !1 } = t;
  if (!l)
    return;
  At && !cl && (cl = !0, Array.from(l.document.body.children).forEach((d) => d.addEventListener("click", Se)), l.document.documentElement.addEventListener("click", Se));
  let r = !0;
  const u = (d) => n.some((c) => {
    if (typeof c == "string")
      return Array.from(l.document.querySelectorAll(c)).some((v) => v === d.target || d.composedPath().includes(v));
    {
      const v = ue(c);
      return v && (d.target === v || d.composedPath().includes(v));
    }
  }), s = [
    ce(l, "click", (d) => {
      const c = ue(e);
      if (!(!c || c === d.target || d.composedPath().includes(c))) {
        if (d.detail === 0 && (r = !u(d)), !r) {
          r = !0;
          return;
        }
        a(d);
      }
    }, { passive: !0, capture: o }),
    ce(l, "pointerdown", (d) => {
      const c = ue(e);
      r = !u(d) && !!(c && !d.composedPath().includes(c));
    }, { passive: !0 }),
    i && ce(l, "blur", (d) => {
      setTimeout(() => {
        var c;
        const v = ue(e);
        ((c = l.document.activeElement) == null ? void 0 : c.tagName) === "IFRAME" && !(v != null && v.contains(l.document.activeElement)) && a(d);
      }, 0);
    })
  ].filter(Boolean);
  return () => s.forEach((d) => d());
}
function zn(e) {
  return typeof e == "function" ? e : typeof e == "string" ? (a) => a.key === e : Array.isArray(e) ? (a) => e.includes(a.key) : () => !0;
}
function Dn(...e) {
  let a, t, l = {};
  e.length === 3 ? (a = e[0], t = e[1], l = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (a = !0, t = e[0], l = e[1]) : (a = e[0], t = e[1]) : (a = !0, t = e[0]);
  const {
    target: n = ye,
    eventName: o = "keydown",
    passive: i = !1,
    dedupe: r = !1
  } = l, u = zn(a);
  return ce(n, o, (s) => {
    s.repeat && ie(r) || u(s) && t(s);
  }, i);
}
function Mn() {
  const e = P(!1);
  return je() && Te(() => {
    e.value = !0;
  }), e;
}
function zt(e) {
  const a = Mn();
  return b(() => (a.value, !!e()));
}
function Rn(e, a = {}) {
  const { window: t = ye } = a, l = zt(() => t && "matchMedia" in t && typeof t.matchMedia == "function");
  let n;
  const o = P(!1), i = (f) => {
    o.value = f.matches;
  }, r = () => {
    n && ("removeEventListener" in n ? n.removeEventListener("change", i) : n.removeListener(i));
  }, u = sn(() => {
    l.value && (r(), n = t.matchMedia(ie(e)), "addEventListener" in n ? n.addEventListener("change", i) : n.addListener(i), o.value = n.matches);
  });
  return Oe(() => {
    u(), r(), n = void 0;
  }), o;
}
function jn(e) {
  return JSON.parse(JSON.stringify(e));
}
const et = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, tt = "__vueuse_ssr_handlers__", Hn = /* @__PURE__ */ qn();
function qn() {
  return tt in et || (et[tt] = et[tt] || {}), et[tt];
}
function Gn(e, a) {
  return Hn[e] || a;
}
function Wn(e, a, t = {}) {
  const { window: l = ye, ...n } = t;
  let o;
  const i = zt(() => l && "MutationObserver" in l), r = () => {
    o && (o.disconnect(), o = void 0);
  }, u = G(
    () => ue(e),
    (m) => {
      r(), i.value && l && m && (o = new MutationObserver(a), o.observe(m, n));
    },
    { immediate: !0 }
  ), f = () => o == null ? void 0 : o.takeRecords(), s = () => {
    r(), u();
  };
  return Oe(s), {
    isSupported: i,
    stop: s,
    takeRecords: f
  };
}
function Un(e, a, t = {}) {
  const { window: l = ye, initialValue: n = "", observe: o = !1 } = t, i = P(n), r = b(() => {
    var f;
    return ue(a) || ((f = l == null ? void 0 : l.document) == null ? void 0 : f.documentElement);
  });
  function u() {
    var f;
    const s = ie(e), m = ie(r);
    if (m && l) {
      const d = (f = l.getComputedStyle(m).getPropertyValue(s)) == null ? void 0 : f.trim();
      i.value = d || n;
    }
  }
  return o && Wn(r, u, {
    attributeFilter: ["style", "class"],
    window: l
  }), G(
    [r, () => ie(e)],
    u,
    { immediate: !0 }
  ), G(
    i,
    (f) => {
      var s;
      (s = r.value) != null && s.style && r.value.style.setProperty(ie(e), f);
    }
  ), i;
}
function Xn(e, a = {}) {
  const {
    delayEnter: t = 0,
    delayLeave: l = 0,
    window: n = ye
  } = a, o = P(!1);
  let i;
  const r = (u) => {
    const f = u ? t : l;
    i && (clearTimeout(i), i = void 0), f ? i = setTimeout(() => o.value = u, f) : o.value = u;
  };
  return n && (ce(e, "mouseenter", () => r(!0), { passive: !0 }), ce(e, "mouseleave", () => r(!1), { passive: !0 })), o;
}
function Kn(e, a, t = {}) {
  const {
    root: l,
    rootMargin: n = "0px",
    threshold: o = 0.1,
    window: i = ye,
    immediate: r = !0
  } = t, u = zt(() => i && "IntersectionObserver" in i), f = b(() => {
    const v = ie(e);
    return (Array.isArray(v) ? v : [v]).map(ue).filter($n);
  });
  let s = Se;
  const m = P(r), d = u.value ? G(
    () => [f.value, ue(l), m.value],
    ([v, k]) => {
      if (s(), !m.value || !v.length)
        return;
      const y = new IntersectionObserver(
        a,
        {
          root: ue(k),
          rootMargin: n,
          threshold: o
        }
      );
      v.forEach((h) => h && y.observe(h)), s = () => {
        y.disconnect(), s = Se;
      };
    },
    { immediate: r, flush: "post" }
  ) : Se, c = () => {
    s(), d(), m.value = !1;
  };
  return Oe(c), {
    isSupported: u,
    isActive: m,
    pause() {
      s(), m.value = !1;
    },
    resume() {
      m.value = !0;
    },
    stop: c
  };
}
function We(e, a = {}) {
  const { initialValue: t = !1, focusVisible: l = !1 } = a, n = P(!1), o = b(() => ue(e));
  ce(o, "focus", (r) => {
    var u, f;
    (!l || (f = (u = r.target).matches) != null && f.call(u, ":focus-visible")) && (n.value = !0);
  }), ce(o, "blur", () => n.value = !1);
  const i = b({
    get: () => n.value,
    set(r) {
      var u, f;
      !r && n.value ? (u = o.value) == null || u.blur() : r && !n.value && ((f = o.value) == null || f.focus());
    }
  });
  return G(
    o,
    () => {
      i.value = t;
    },
    { immediate: !0, flush: "post" }
  ), { focused: i };
}
function Vt(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
function Ll(e) {
  const a = window.getComputedStyle(e);
  if (a.overflowX === "scroll" || a.overflowY === "scroll" || a.overflowX === "auto" && e.clientWidth < e.scrollWidth || a.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const t = e.parentNode;
    return !t || t.tagName === "BODY" ? !1 : Ll(t);
  }
}
function Yn(e) {
  const a = e || window.event, t = a.target;
  return Ll(t) ? !1 : a.touches.length > 1 ? !0 : (a.preventDefault && a.preventDefault(), !1);
}
const lt = /* @__PURE__ */ new WeakMap();
function Jn(e, a = !1) {
  const t = P(a);
  let l = null, n;
  G(Pn(e), (r) => {
    const u = Vt(ie(r));
    if (u) {
      const f = u;
      lt.get(f) || lt.set(f, n), t.value && (f.style.overflow = "hidden");
    }
  }, {
    immediate: !0
  });
  const o = () => {
    const r = Vt(ie(e));
    !r || t.value || (At && (l = ce(
      r,
      "touchmove",
      (u) => {
        Yn(u);
      },
      { passive: !1 }
    )), r.style.overflow = "hidden", t.value = !0);
  }, i = () => {
    var r;
    const u = Vt(ie(e));
    !u || !t.value || (At && (l == null || l()), u.style.overflow = (r = lt.get(u)) != null ? r : "", lt.delete(u), t.value = !1);
  };
  return Oe(i), b({
    get() {
      return t.value;
    },
    set(r) {
      r ? o() : i();
    }
  });
}
function ze(e, a, t, l = {}) {
  var n, o, i;
  const {
    clone: r = !1,
    passive: u = !1,
    eventName: f,
    deep: s = !1,
    defaultValue: m,
    shouldEmit: d
  } = l, c = je(), v = t || (c == null ? void 0 : c.emit) || ((n = c == null ? void 0 : c.$emit) == null ? void 0 : n.bind(c)) || ((i = (o = c == null ? void 0 : c.proxy) == null ? void 0 : o.$emit) == null ? void 0 : i.bind(c == null ? void 0 : c.proxy));
  let k = f;
  a || (a = "modelValue"), k = k || `update:${a.toString()}`;
  const y = (S) => r ? typeof r == "function" ? r(S) : jn(S) : S, h = () => Sn(e[a]) ? y(e[a]) : m, g = (S) => {
    d ? d(S) && v(k, S) : v(k, S);
  };
  if (u) {
    const S = h(), L = P(S);
    let F = !1;
    return G(
      () => e[a],
      (M) => {
        F || (F = !0, L.value = y(M), pe(() => F = !1));
      }
    ), G(
      L,
      (M) => {
        !F && (M !== e[a] || s) && g(M);
      },
      { deep: s }
    ), L;
  } else
    return b({
      get() {
        return h();
      },
      set(S) {
        g(S);
      }
    });
}
function Zn(e = {}) {
  const {
    window: a = ye,
    initialWidth: t = Number.POSITIVE_INFINITY,
    initialHeight: l = Number.POSITIVE_INFINITY,
    listenOrientation: n = !0,
    includeScrollbar: o = !0
  } = e, i = P(t), r = P(l), u = () => {
    a && (o ? (i.value = a.innerWidth, r.value = a.innerHeight) : (i.value = a.document.documentElement.clientWidth, r.value = a.document.documentElement.clientHeight));
  };
  if (u(), Ln(u), ce("resize", u, { passive: !0 }), n) {
    const f = Rn("(orientation: portrait)");
    G(f, () => u());
  }
  return { width: i, height: r };
}
const Qn = ["href", "target", "rel", "tabindex", "aria-disabled"], gt = /* @__PURE__ */ Z({
  __name: "Link",
  props: {
    custom: { type: Boolean },
    activeClass: {},
    exactActiveClass: {},
    ariaCurrentValue: {},
    to: {},
    replace: { type: Boolean },
    active: { type: Boolean },
    disabled: { type: Boolean },
    href: {},
    rel: {},
    target: { default: "_self" }
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    const t = e, l = a, n = Ol(
      t,
      "active",
      "disabled",
      "href",
      "rel",
      "target"
    ), o = b(() => !t.to || t.disabled), i = b(() => {
      if (t.rel)
        return t.rel;
      if (t.target === "_blank")
        return "noopener";
    }), r = b(() => t.disabled ? "-1" : void 0);
    function u(f) {
      t.disabled ? (f.preventDefault(), f.stopImmediatePropagation()) : (t.href === "#" && (f.preventDefault(), f.stopPropagation()), l("click", f));
    }
    return (f, s) => o.value ? (p(), T("a", {
      key: 0,
      class: $({ disabled: t.disabled, active: t.active }),
      href: t.href,
      target: t.target,
      rel: i.value,
      tabindex: r.value,
      "aria-disabled": t.disabled ? !0 : void 0,
      onClick: u
    }, [
      C(f.$slots, "default")
    ], 10, Qn)) : (p(), I(J("RouterLink"), ae({ key: 1 }, x(n), {
      class: { disabled: t.disabled, active: t.active },
      tabindex: r.value,
      "aria-disabled": t.disabled ? !0 : null,
      onClick: u
    }), {
      default: E(() => [
        C(f.$slots, "default")
      ]),
      _: 3
    }, 16, ["class", "tabindex", "aria-disabled"]));
  }
}), _n = (e) => typeof e == "boolean" || e === "" || e === "true" || e === "false", H = (e) => b(() => {
  const a = ft(e);
  return _n(a) ? typeof a == "boolean" ? a : a === "true" : a;
}), El = (e, a) => Object.keys(e).filter((t) => !a.map((l) => l.toString()).includes(t)).reduce(
  (t, l) => ({ ...t, [l]: e[l] }),
  {}
), eo = (e, a) => [...a].reduce(
  (t, l) => (t[l] = e[l], t),
  {}
), Dt = {
  __name: "BreadcrumbItem",
  props: {
    ariaCurrent: {
      type: String,
      default: "location"
    },
    text: {
      type: String,
      default: ""
    },
    active: {
      type: Boolean,
      default: !1
    },
    activeClass: {
      type: String,
      default: ""
    },
    append: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    event: {
      type: String,
      default: ""
    },
    exactActiveClass: {
      type: String,
      default: ""
    },
    href: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    opacity: {
      type: Number,
      default: 1
    },
    opacityHover: {
      type: Number,
      default: 1
    },
    rel: {
      type: String,
      default: ""
    },
    replace: {
      type: Boolean,
      default: !1
    },
    routerComponentName: {
      type: String,
      default: ""
    },
    routerTag: {
      type: String,
      default: ""
    },
    target: {
      type: String,
      default: ""
    },
    to: {
      type: [String, Object],
      default: ""
    },
    underlineOffset: {
      type: Number,
      default: 0
    },
    underlineOffsetHover: {
      type: Number,
      default: 0
    },
    underlineOpacity: {
      type: Number,
      default: 1
    },
    underlineOpacityHover: {
      type: Number,
      default: 1
    },
    underlineVariant: {
      type: String,
      default: ""
    },
    variant: {
      type: String,
      default: ""
    }
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    const t = e, l = a, n = H(() => t.active), o = H(() => t.disabled), i = b(() => ({
      active: n.value
    })), r = K(() => n.value ? "span" : gt), u = K(
      () => n.value ? t.ariaCurrent : void 0
    ), f = b(
      () => r.value !== "span" ? eo(t, [
        "active",
        "activeClass",
        "append",
        "disabled",
        "href",
        "rel",
        "replace",
        "routerComponentName",
        "target",
        "to",
        "variant",
        "opacity",
        "opacityHover",
        "underlineVariant",
        "underlineOffset",
        "underlineOffsetHover",
        "underlineOpacity",
        "underlineOpacityHover",
        "icon"
      ]) : {}
    ), s = (m) => {
      if (o.value || n.value) {
        m.preventDefault(), m.stopImmediatePropagation();
        return;
      }
      o.value || l("click", m);
    };
    return (m, d) => (p(), T("li", {
      class: $(["breadcrumb-item", i.value])
    }, [
      (p(), I(J(r.value), ae({ "aria-current": u.value }, f.value, { onClick: s }), {
        default: E(() => [
          C(m.$slots, "default", {}, () => [
            q(D(e.text), 1)
          ])
        ]),
        _: 3
      }, 16, ["aria-current"]))
    ], 2));
  }
}, to = { "aria-label": "breadcrumb" }, lo = { class: "breadcrumb" }, Nl = {
  __name: "Breadcrumb",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(e) {
    const a = e, t = it({
      items: []
    }), l = b(() => {
      const n = a.items || (t == null ? void 0 : t.items) || [];
      let o = !1;
      return n.map((r, u) => (typeof r == "string" && (r = { text: r }, u < n.length - 1 && (r.href = "#")), r.active && (o = !0), !r.active && !o && (r.active = u + 1 === n.length), r));
    });
    return (n, o) => (p(), T("nav", to, [
      N("ol", lo, [
        C(n.$slots, "prepend"),
        (p(!0), T(ee, null, se(l.value, (i, r) => (p(), I(Dt, ae({
          key: r,
          ref_for: !0
        }, i), {
          default: E(() => [
            q(D(i.text), 1)
          ]),
          _: 2
        }, 1040))), 128)),
        C(n.$slots, "default"),
        C(n.$slots, "append")
      ])
    ]));
  }
}, ao = {
  install: (e) => {
    e.component("BBreadcrumb", Nl), e.component("BBreadcrumbItem", Dt);
  }
}, st = {
  __name: "Button",
  props: {
    block: {
      type: Boolean,
      default: !1
    },
    active: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    href: {
      type: String,
      default: void 0
    },
    pill: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: void 0
    },
    squared: {
      type: Boolean,
      default: !1
    },
    tag: {
      type: String,
      default: "button"
    },
    to: {
      type: [Object, String],
      default: void 0
    },
    type: {
      type: String,
      default: "button"
    },
    variant: {
      type: String,
      default: "secondary"
    },
    pressed: {
      type: Boolean,
      default: null
    },
    target: {
      type: String,
      default: "_self"
    },
    // Add an accessible label for screen readers
    ariaLabel: {
      type: String,
      default: void 0
    },
    replace: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    const t = je(), l = a, n = e, o = b(() => {
      const m = "router-link", d = m.split("-").map((v) => v.charAt(0).toUpperCase() + v.slice(1)).join(""), c = (t == null ? void 0 : t.appContext.app.component(d)) !== void 0;
      return n.href || n.to !== null && n.to !== void 0 && !c ? "a" : n.to !== null && n.to !== void 0 && c ? m : n != null && n.tag ? n == null ? void 0 : n.tag : "button";
    }), i = b(() => {
      const m = (n == null ? void 0 : n.variant) || "secondary", d = n == null ? void 0 : n.size, c = n == null ? void 0 : n.pill, v = (n == null ? void 0 : n.squared) && !c, k = n == null ? void 0 : n.disabled, y = n == null ? void 0 : n.pressed, h = n == null ? void 0 : n.block;
      return [
        "btn",
        `btn-${m}`,
        d && `btn-${d}`,
        c && "rounded-pill",
        v && "rounded-0",
        k && "disabled",
        y && "active",
        h && "btn-block"
      ];
    }), r = b(() => n.type == "button" || n.type == "submit" || n.type == "reset" ? n.type : null), u = b(() => {
      const m = "#";
      if (n.href && n.href !== null)
        return n.href;
      if (n.to && typeof n.to == "string")
        return n.to || m;
      const { to: d } = n;
      if (d != null && typeof d == "object" && "path" in d) {
        const c = d.path || "", v = d.query ? `?${Object.keys(d.query).map((y) => {
          var h;
          return `${y}=${(h = d.query) == null ? void 0 : h[y]}`;
        }).join("=")}` : "", k = !d.hash || d.hash.charAt(0) === "#" ? d.hash || "" : `#${d.hash}`;
        return `${c}${v}${k}` || m;
      }
      return null;
    }), f = b(() => u.value !== null && u.value === n.href ? n.target : null);
    function s(m) {
      n.disabled || l("click", m);
    }
    return (m, d) => (p(), I(J(o.value), {
      type: r.value,
      class: $(i.value),
      href: u.value,
      disabled: e.disabled && !u.value ? e.disabled : null,
      "aria-disabled": e.disabled && u.value ? e.disabled : null,
      role: u.value ? "button" : null,
      target: f.value,
      "aria-pressed": e.pressed !== null ? e.pressed.toString() : null,
      "aria-label": e.ariaLabel,
      to: e.to,
      replace: !e.replace && o.value !== "router-link" ? null : e.replace,
      onClick: s
    }, {
      default: E(() => [
        C(m.$slots, "default")
      ]),
      _: 3
    }, 8, ["type", "class", "href", "disabled", "aria-disabled", "role", "target", "aria-pressed", "aria-label", "to", "replace"]));
  }
}, no = {
  install: (e) => {
    e.component("BButton", st);
  }
};
class Mt {
  constructor(a, t = {}) {
    ge(this, "cancelable", !0);
    ge(this, "componentId", null);
    ge(this, "_defaultPrevented", !1);
    ge(this, "eventType", "");
    ge(this, "nativeEvent", null);
    ge(this, "_preventDefault");
    ge(this, "relatedTarget", null);
    ge(this, "target", null);
    if (!a)
      throw new TypeError(
        `Failed to construct '${this.constructor.name}'. 1 argument required, ${arguments.length} given.`
      );
    Object.assign(this, Mt.Defaults, t, { eventType: a }), this._preventDefault = function() {
      this.cancelable && (this.defaultPrevented = !0);
    };
  }
  get defaultPrevented() {
    return this._defaultPrevented;
  }
  set defaultPrevented(a) {
    this._defaultPrevented = a;
  }
  get preventDefault() {
    return this._preventDefault;
  }
  set preventDefault(a) {
    this._preventDefault = a;
  }
  static get Defaults() {
    return {
      cancelable: !0,
      componentId: null,
      eventType: "",
      nativeEvent: null,
      relatedTarget: null,
      target: null
    };
  }
}
const fl = (e) => e && e.offsetHeight, rt = (e) => ((e == null ? void 0 : e()) ?? []).length === 0, at = (e, a) => {
  const t = Object.keys(e), l = Object.keys(a), n = t.filter((o) => l.includes(o));
  return n.length === 0 ? null : n.length === 1 ? n[0] : n;
}, oo = (e) => typeof e == "string" ? e : null, io = (e) => typeof e == "function" ? e() : null, Rt = (e) => {
  const a = document.getElementsByClassName(e);
  Array.from(a).forEach((l) => {
    l != null && l.parentElement && l.parentElement.removeChild(l);
  });
}, zl = Symbol("progress"), Dl = Symbol("tabs"), Ml = Symbol("bvn::modalManagerPlugin"), so = /\s+/, ro = /^#/, uo = /^#[A-Za-z]+[\w\-:.]*$/, vl = (e) => {
  if (e.includes("-"))
    return e.split("-").map((a) => a.charAt(0).toUpperCase() + a.slice(1)).join(" ");
  if (e.includes("_"))
    return e.split("_").map((a) => a.charAt(0).toUpperCase() + a.slice(1)).join(" ");
  if (e.match(/[A-Z]/)) {
    const a = e.replace(/([a-z])([A-Z])/g, "$1 $2");
    return a.charAt(0).toUpperCase() + a.slice(1);
  }
  return e.charAt(0).toUpperCase() + e.slice(1);
}, co = (e) => typeof e, fo = (e) => co(e) === "string" && e !== "", vo = (e, a) => {
  let t, l = e, n = e, o;
  const i = () => {
    o = Date.now(), t = setTimeout(() => {
      a();
    }, l);
  }, r = () => {
    clearTimeout(t), n -= Date.now() - o;
  }, u = () => {
    l = n, i();
  }, f = () => {
    clearTimeout(t), n = e, l = e, i();
  };
  return i(), {
    pauseTimer: r,
    resumeTimer: u,
    resetTimer: f
  };
}, mo = (e) => b(() => {
  const a = ft(e);
  return a ? `justify-content-${a}` : "";
}), pt = (e) => b(() => {
  let a = ft(e);
  return a = {
    ...a,
    variant: a.variant ?? null,
    bgVariant: a.bgVariant ?? null,
    textVariant: a.textVariant ?? null
  }, {
    [`text-bg-${a.variant}`]: a.variant !== null,
    [`text-${a.textVariant}`]: a.textVariant !== null && a.variant === null,
    [`bg-${a.bgVariant}`]: a.bgVariant !== null && a.variant === null
  };
}), go = (e = "") => `__BVID__${Math.random().toString().slice(2, 8)}___BV_${e}__`, Ot = (e, a) => b(() => ft(e) || go(a)), De = Math.min, $e = Math.max, ut = Math.round, nt = Math.floor, ke = (e) => ({
  x: e,
  y: e
}), po = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, bo = {
  start: "end",
  end: "start"
};
function It(e, a, t) {
  return $e(e, De(a, t));
}
function Ke(e, a) {
  return typeof e == "function" ? e(a) : e;
}
function xe(e) {
  return e.split("-")[0];
}
function Ye(e) {
  return e.split("-")[1];
}
function Rl(e) {
  return e === "x" ? "y" : "x";
}
function jt(e) {
  return e === "y" ? "height" : "width";
}
function bt(e) {
  return ["top", "bottom"].includes(xe(e)) ? "y" : "x";
}
function Ht(e) {
  return Rl(bt(e));
}
function yo(e, a, t) {
  t === void 0 && (t = !1);
  const l = Ye(e), n = Ht(e), o = jt(n);
  let i = n === "x" ? l === (t ? "end" : "start") ? "right" : "left" : l === "start" ? "bottom" : "top";
  return a.reference[o] > a.floating[o] && (i = dt(i)), [i, dt(i)];
}
function ho(e) {
  const a = dt(e);
  return [Pt(e), a, Pt(a)];
}
function Pt(e) {
  return e.replace(/start|end/g, (a) => bo[a]);
}
function Bo(e, a, t) {
  const l = ["left", "right"], n = ["right", "left"], o = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return t ? a ? n : l : a ? l : n;
    case "left":
    case "right":
      return a ? o : i;
    default:
      return [];
  }
}
function ko(e, a, t, l) {
  const n = Ye(e);
  let o = Bo(xe(e), t === "start", l);
  return n && (o = o.map((i) => i + "-" + n), a && (o = o.concat(o.map(Pt)))), o;
}
function dt(e) {
  return e.replace(/left|right|bottom|top/g, (a) => po[a]);
}
function Co(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function jl(e) {
  return typeof e != "number" ? Co(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function ct(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function ml(e, a, t) {
  let {
    reference: l,
    floating: n
  } = e;
  const o = bt(a), i = Ht(a), r = jt(i), u = xe(a), f = o === "y", s = l.x + l.width / 2 - n.width / 2, m = l.y + l.height / 2 - n.height / 2, d = l[r] / 2 - n[r] / 2;
  let c;
  switch (u) {
    case "top":
      c = {
        x: s,
        y: l.y - n.height
      };
      break;
    case "bottom":
      c = {
        x: s,
        y: l.y + l.height
      };
      break;
    case "right":
      c = {
        x: l.x + l.width,
        y: m
      };
      break;
    case "left":
      c = {
        x: l.x - n.width,
        y: m
      };
      break;
    default:
      c = {
        x: l.x,
        y: l.y
      };
  }
  switch (Ye(a)) {
    case "start":
      c[i] -= d * (t && f ? -1 : 1);
      break;
    case "end":
      c[i] += d * (t && f ? -1 : 1);
      break;
  }
  return c;
}
const wo = async (e, a, t) => {
  const {
    placement: l = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: i
  } = t, r = o.filter(Boolean), u = await (i.isRTL == null ? void 0 : i.isRTL(a));
  let f = await i.getElementRects({
    reference: e,
    floating: a,
    strategy: n
  }), {
    x: s,
    y: m
  } = ml(f, l, u), d = l, c = {}, v = 0;
  for (let k = 0; k < r.length; k++) {
    const {
      name: y,
      fn: h
    } = r[k], {
      x: g,
      y: S,
      data: L,
      reset: F
    } = await h({
      x: s,
      y: m,
      initialPlacement: l,
      placement: d,
      strategy: n,
      middlewareData: c,
      rects: f,
      platform: i,
      elements: {
        reference: e,
        floating: a
      }
    });
    if (s = g ?? s, m = S ?? m, c = {
      ...c,
      [y]: {
        ...c[y],
        ...L
      }
    }, F && v <= 50) {
      v++, typeof F == "object" && (F.placement && (d = F.placement), F.rects && (f = F.rects === !0 ? await i.getElementRects({
        reference: e,
        floating: a,
        strategy: n
      }) : F.rects), {
        x: s,
        y: m
      } = ml(f, d, u)), k = -1;
      continue;
    }
  }
  return {
    x: s,
    y: m,
    placement: d,
    strategy: n,
    middlewareData: c
  };
};
async function Hl(e, a) {
  var t;
  a === void 0 && (a = {});
  const {
    x: l,
    y: n,
    platform: o,
    rects: i,
    elements: r,
    strategy: u
  } = e, {
    boundary: f = "clippingAncestors",
    rootBoundary: s = "viewport",
    elementContext: m = "floating",
    altBoundary: d = !1,
    padding: c = 0
  } = Ke(a, e), v = jl(c), y = r[d ? m === "floating" ? "reference" : "floating" : m], h = ct(await o.getClippingRect({
    element: (t = await (o.isElement == null ? void 0 : o.isElement(y))) == null || t ? y : y.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(r.floating)),
    boundary: f,
    rootBoundary: s,
    strategy: u
  })), g = m === "floating" ? {
    ...i.floating,
    x: l,
    y: n
  } : i.reference, S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(r.floating)), L = await (o.isElement == null ? void 0 : o.isElement(S)) ? await (o.getScale == null ? void 0 : o.getScale(S)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, F = ct(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: g,
    offsetParent: S,
    strategy: u
  }) : g);
  return {
    top: (h.top - F.top + v.top) / L.y,
    bottom: (F.bottom - h.bottom + v.bottom) / L.y,
    left: (h.left - F.left + v.left) / L.x,
    right: (F.right - h.right + v.right) / L.x
  };
}
const So = (e) => ({
  name: "arrow",
  options: e,
  async fn(a) {
    const {
      x: t,
      y: l,
      placement: n,
      rects: o,
      platform: i,
      elements: r,
      middlewareData: u
    } = a, {
      element: f,
      padding: s = 0
    } = Ke(e, a) || {};
    if (f == null)
      return {};
    const m = jl(s), d = {
      x: t,
      y: l
    }, c = Ht(n), v = jt(c), k = await i.getDimensions(f), y = c === "y", h = y ? "top" : "left", g = y ? "bottom" : "right", S = y ? "clientHeight" : "clientWidth", L = o.reference[v] + o.reference[c] - d[c] - o.floating[v], F = d[c] - o.reference[c], M = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(f));
    let V = M ? M[S] : 0;
    (!V || !await (i.isElement == null ? void 0 : i.isElement(M))) && (V = r.floating[S] || o.floating[v]);
    const j = L / 2 - F / 2, W = V / 2 - k[v] / 2 - 1, te = De(m[h], W), ne = De(m[g], W), Q = te, oe = V - k[v] - ne, O = V / 2 - k[v] / 2 + j, B = It(Q, O, oe), w = !u.arrow && Ye(n) != null && O != B && o.reference[v] / 2 - (O < Q ? te : ne) - k[v] / 2 < 0, z = w ? O < Q ? O - Q : O - oe : 0;
    return {
      [c]: d[c] + z,
      data: {
        [c]: B,
        centerOffset: O - B - z,
        ...w && {
          alignmentOffset: z
        }
      },
      reset: w
    };
  }
}), yt = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(a) {
      var t, l;
      const {
        placement: n,
        middlewareData: o,
        rects: i,
        initialPlacement: r,
        platform: u,
        elements: f
      } = a, {
        mainAxis: s = !0,
        crossAxis: m = !0,
        fallbackPlacements: d,
        fallbackStrategy: c = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: k = !0,
        ...y
      } = Ke(e, a);
      if ((t = o.arrow) != null && t.alignmentOffset)
        return {};
      const h = xe(n), g = xe(r) === r, S = await (u.isRTL == null ? void 0 : u.isRTL(f.floating)), L = d || (g || !k ? [dt(r)] : ho(r));
      !d && v !== "none" && L.push(...ko(r, k, v, S));
      const F = [r, ...L], M = await Hl(a, y), V = [];
      let j = ((l = o.flip) == null ? void 0 : l.overflows) || [];
      if (s && V.push(M[h]), m) {
        const Q = yo(n, i, S);
        V.push(M[Q[0]], M[Q[1]]);
      }
      if (j = [...j, {
        placement: n,
        overflows: V
      }], !V.every((Q) => Q <= 0)) {
        var W, te;
        const Q = (((W = o.flip) == null ? void 0 : W.index) || 0) + 1, oe = F[Q];
        if (oe)
          return {
            data: {
              index: Q,
              overflows: j
            },
            reset: {
              placement: oe
            }
          };
        let O = (te = j.filter((B) => B.overflows[0] <= 0).sort((B, w) => B.overflows[1] - w.overflows[1])[0]) == null ? void 0 : te.placement;
        if (!O)
          switch (c) {
            case "bestFit": {
              var ne;
              const B = (ne = j.map((w) => [w.placement, w.overflows.filter((z) => z > 0).reduce((z, A) => z + A, 0)]).sort((w, z) => w[1] - z[1])[0]) == null ? void 0 : ne[0];
              B && (O = B);
              break;
            }
            case "initialPlacement":
              O = r;
              break;
          }
        if (n !== O)
          return {
            reset: {
              placement: O
            }
          };
      }
      return {};
    }
  };
};
async function $o(e, a) {
  const {
    placement: t,
    platform: l,
    elements: n
  } = e, o = await (l.isRTL == null ? void 0 : l.isRTL(n.floating)), i = xe(t), r = Ye(t), u = bt(t) === "y", f = ["left", "top"].includes(i) ? -1 : 1, s = o && u ? -1 : 1, m = Ke(a, e);
  let {
    mainAxis: d,
    crossAxis: c,
    alignmentAxis: v
  } = typeof m == "number" ? {
    mainAxis: m,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...m
  };
  return r && typeof v == "number" && (c = r === "end" ? v * -1 : v), u ? {
    x: c * s,
    y: d * f
  } : {
    x: d * f,
    y: c * s
  };
}
const ht = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(a) {
      var t, l;
      const {
        x: n,
        y: o,
        placement: i,
        middlewareData: r
      } = a, u = await $o(a, e);
      return i === ((t = r.offset) == null ? void 0 : t.placement) && (l = r.arrow) != null && l.alignmentOffset ? {} : {
        x: n + u.x,
        y: o + u.y,
        data: {
          ...u,
          placement: i
        }
      };
    }
  };
}, qt = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(a) {
      const {
        x: t,
        y: l,
        placement: n
      } = a, {
        mainAxis: o = !0,
        crossAxis: i = !1,
        limiter: r = {
          fn: (y) => {
            let {
              x: h,
              y: g
            } = y;
            return {
              x: h,
              y: g
            };
          }
        },
        ...u
      } = Ke(e, a), f = {
        x: t,
        y: l
      }, s = await Hl(a, u), m = bt(xe(n)), d = Rl(m);
      let c = f[d], v = f[m];
      if (o) {
        const y = d === "y" ? "top" : "left", h = d === "y" ? "bottom" : "right", g = c + s[y], S = c - s[h];
        c = It(g, c, S);
      }
      if (i) {
        const y = m === "y" ? "top" : "left", h = m === "y" ? "bottom" : "right", g = v + s[y], S = v - s[h];
        v = It(g, v, S);
      }
      const k = r.fn({
        ...a,
        [d]: c,
        [m]: v
      });
      return {
        ...k,
        data: {
          x: k.x - t,
          y: k.y - l
        }
      };
    }
  };
};
function Ce(e) {
  return ql(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function re(e) {
  var a;
  return (e == null || (a = e.ownerDocument) == null ? void 0 : a.defaultView) || window;
}
function he(e) {
  var a;
  return (a = (ql(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : a.documentElement;
}
function ql(e) {
  return e instanceof Node || e instanceof re(e).Node;
}
function be(e) {
  return e instanceof Element || e instanceof re(e).Element;
}
function ve(e) {
  return e instanceof HTMLElement || e instanceof re(e).HTMLElement;
}
function gl(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof re(e).ShadowRoot;
}
function Je(e) {
  const {
    overflow: a,
    overflowX: t,
    overflowY: l,
    display: n
  } = de(e);
  return /auto|scroll|overlay|hidden|clip/.test(a + l + t) && !["inline", "contents"].includes(n);
}
function xo(e) {
  return ["table", "td", "th"].includes(Ce(e));
}
function Gt(e) {
  const a = Wt(), t = de(e);
  return t.transform !== "none" || t.perspective !== "none" || (t.containerType ? t.containerType !== "normal" : !1) || !a && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !a && (t.filter ? t.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((l) => (t.willChange || "").includes(l)) || ["paint", "layout", "strict", "content"].some((l) => (t.contain || "").includes(l));
}
function Vo(e) {
  let a = Me(e);
  for (; ve(a) && !Bt(a); ) {
    if (Gt(a))
      return a;
    a = Me(a);
  }
  return null;
}
function Wt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Bt(e) {
  return ["html", "body", "#document"].includes(Ce(e));
}
function de(e) {
  return re(e).getComputedStyle(e);
}
function kt(e) {
  return be(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function Me(e) {
  if (Ce(e) === "html")
    return e;
  const a = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    gl(e) && e.host || // Fallback.
    he(e)
  );
  return gl(a) ? a.host : a;
}
function Gl(e) {
  const a = Me(e);
  return Bt(a) ? e.ownerDocument ? e.ownerDocument.body : e.body : ve(a) && Je(a) ? a : Gl(a);
}
function Ue(e, a, t) {
  var l;
  a === void 0 && (a = []), t === void 0 && (t = !0);
  const n = Gl(e), o = n === ((l = e.ownerDocument) == null ? void 0 : l.body), i = re(n);
  return o ? a.concat(i, i.visualViewport || [], Je(n) ? n : [], i.frameElement && t ? Ue(i.frameElement) : []) : a.concat(n, Ue(n, [], t));
}
function Wl(e) {
  const a = de(e);
  let t = parseFloat(a.width) || 0, l = parseFloat(a.height) || 0;
  const n = ve(e), o = n ? e.offsetWidth : t, i = n ? e.offsetHeight : l, r = ut(t) !== o || ut(l) !== i;
  return r && (t = o, l = i), {
    width: t,
    height: l,
    $: r
  };
}
function Ut(e) {
  return be(e) ? e : e.contextElement;
}
function Ee(e) {
  const a = Ut(e);
  if (!ve(a))
    return ke(1);
  const t = a.getBoundingClientRect(), {
    width: l,
    height: n,
    $: o
  } = Wl(a);
  let i = (o ? ut(t.width) : t.width) / l, r = (o ? ut(t.height) : t.height) / n;
  return (!i || !Number.isFinite(i)) && (i = 1), (!r || !Number.isFinite(r)) && (r = 1), {
    x: i,
    y: r
  };
}
const To = /* @__PURE__ */ ke(0);
function Ul(e) {
  const a = re(e);
  return !Wt() || !a.visualViewport ? To : {
    x: a.visualViewport.offsetLeft,
    y: a.visualViewport.offsetTop
  };
}
function Fo(e, a, t) {
  return a === void 0 && (a = !1), !t || a && t !== re(e) ? !1 : a;
}
function Ve(e, a, t, l) {
  a === void 0 && (a = !1), t === void 0 && (t = !1);
  const n = e.getBoundingClientRect(), o = Ut(e);
  let i = ke(1);
  a && (l ? be(l) && (i = Ee(l)) : i = Ee(e));
  const r = Fo(o, t, l) ? Ul(o) : ke(0);
  let u = (n.left + r.x) / i.x, f = (n.top + r.y) / i.y, s = n.width / i.x, m = n.height / i.y;
  if (o) {
    const d = re(o), c = l && be(l) ? re(l) : l;
    let v = d.frameElement;
    for (; v && l && c !== d; ) {
      const k = Ee(v), y = v.getBoundingClientRect(), h = de(v), g = y.left + (v.clientLeft + parseFloat(h.paddingLeft)) * k.x, S = y.top + (v.clientTop + parseFloat(h.paddingTop)) * k.y;
      u *= k.x, f *= k.y, s *= k.x, m *= k.y, u += g, f += S, v = re(v).frameElement;
    }
  }
  return ct({
    width: s,
    height: m,
    x: u,
    y: f
  });
}
function Ao(e) {
  let {
    rect: a,
    offsetParent: t,
    strategy: l
  } = e;
  const n = ve(t), o = he(t);
  if (t === o)
    return a;
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  }, r = ke(1);
  const u = ke(0);
  if ((n || !n && l !== "fixed") && ((Ce(t) !== "body" || Je(o)) && (i = kt(t)), ve(t))) {
    const f = Ve(t);
    r = Ee(t), u.x = f.x + t.clientLeft, u.y = f.y + t.clientTop;
  }
  return {
    width: a.width * r.x,
    height: a.height * r.y,
    x: a.x * r.x - i.scrollLeft * r.x + u.x,
    y: a.y * r.y - i.scrollTop * r.y + u.y
  };
}
function Oo(e) {
  return Array.from(e.getClientRects());
}
function Xl(e) {
  return Ve(he(e)).left + kt(e).scrollLeft;
}
function Io(e) {
  const a = he(e), t = kt(e), l = e.ownerDocument.body, n = $e(a.scrollWidth, a.clientWidth, l.scrollWidth, l.clientWidth), o = $e(a.scrollHeight, a.clientHeight, l.scrollHeight, l.clientHeight);
  let i = -t.scrollLeft + Xl(e);
  const r = -t.scrollTop;
  return de(l).direction === "rtl" && (i += $e(a.clientWidth, l.clientWidth) - n), {
    width: n,
    height: o,
    x: i,
    y: r
  };
}
function Po(e, a) {
  const t = re(e), l = he(e), n = t.visualViewport;
  let o = l.clientWidth, i = l.clientHeight, r = 0, u = 0;
  if (n) {
    o = n.width, i = n.height;
    const f = Wt();
    (!f || f && a === "fixed") && (r = n.offsetLeft, u = n.offsetTop);
  }
  return {
    width: o,
    height: i,
    x: r,
    y: u
  };
}
function Lo(e, a) {
  const t = Ve(e, !0, a === "fixed"), l = t.top + e.clientTop, n = t.left + e.clientLeft, o = ve(e) ? Ee(e) : ke(1), i = e.clientWidth * o.x, r = e.clientHeight * o.y, u = n * o.x, f = l * o.y;
  return {
    width: i,
    height: r,
    x: u,
    y: f
  };
}
function pl(e, a, t) {
  let l;
  if (a === "viewport")
    l = Po(e, t);
  else if (a === "document")
    l = Io(he(e));
  else if (be(a))
    l = Lo(a, t);
  else {
    const n = Ul(e);
    l = {
      ...a,
      x: a.x - n.x,
      y: a.y - n.y
    };
  }
  return ct(l);
}
function Kl(e, a) {
  const t = Me(e);
  return t === a || !be(t) || Bt(t) ? !1 : de(t).position === "fixed" || Kl(t, a);
}
function Eo(e, a) {
  const t = a.get(e);
  if (t)
    return t;
  let l = Ue(e, [], !1).filter((r) => be(r) && Ce(r) !== "body"), n = null;
  const o = de(e).position === "fixed";
  let i = o ? Me(e) : e;
  for (; be(i) && !Bt(i); ) {
    const r = de(i), u = Gt(i);
    !u && r.position === "fixed" && (n = null), (o ? !u && !n : !u && r.position === "static" && !!n && ["absolute", "fixed"].includes(n.position) || Je(i) && !u && Kl(e, i)) ? l = l.filter((s) => s !== i) : n = r, i = Me(i);
  }
  return a.set(e, l), l;
}
function No(e) {
  let {
    element: a,
    boundary: t,
    rootBoundary: l,
    strategy: n
  } = e;
  const i = [...t === "clippingAncestors" ? Eo(a, this._c) : [].concat(t), l], r = i[0], u = i.reduce((f, s) => {
    const m = pl(a, s, n);
    return f.top = $e(m.top, f.top), f.right = De(m.right, f.right), f.bottom = De(m.bottom, f.bottom), f.left = $e(m.left, f.left), f;
  }, pl(a, r, n));
  return {
    width: u.right - u.left,
    height: u.bottom - u.top,
    x: u.left,
    y: u.top
  };
}
function zo(e) {
  return Wl(e);
}
function Do(e, a, t) {
  const l = ve(a), n = he(a), o = t === "fixed", i = Ve(e, !0, o, a);
  let r = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = ke(0);
  if (l || !l && !o)
    if ((Ce(a) !== "body" || Je(n)) && (r = kt(a)), l) {
      const f = Ve(a, !0, o, a);
      u.x = f.x + a.clientLeft, u.y = f.y + a.clientTop;
    } else
      n && (u.x = Xl(n));
  return {
    x: i.left + r.scrollLeft - u.x,
    y: i.top + r.scrollTop - u.y,
    width: i.width,
    height: i.height
  };
}
function bl(e, a) {
  return !ve(e) || de(e).position === "fixed" ? null : a ? a(e) : e.offsetParent;
}
function Yl(e, a) {
  const t = re(e);
  if (!ve(e))
    return t;
  let l = bl(e, a);
  for (; l && xo(l) && de(l).position === "static"; )
    l = bl(l, a);
  return l && (Ce(l) === "html" || Ce(l) === "body" && de(l).position === "static" && !Gt(l)) ? t : l || Vo(e) || t;
}
const Mo = async function(e) {
  let {
    reference: a,
    floating: t,
    strategy: l
  } = e;
  const n = this.getOffsetParent || Yl, o = this.getDimensions;
  return {
    reference: Do(a, await n(t), l),
    floating: {
      x: 0,
      y: 0,
      ...await o(t)
    }
  };
};
function Ro(e) {
  return de(e).direction === "rtl";
}
const jo = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ao,
  getDocumentElement: he,
  getClippingRect: No,
  getOffsetParent: Yl,
  getElementRects: Mo,
  getClientRects: Oo,
  getDimensions: zo,
  getScale: Ee,
  isElement: be,
  isRTL: Ro
};
function Ho(e, a) {
  let t = null, l;
  const n = he(e);
  function o() {
    clearTimeout(l), t && t.disconnect(), t = null;
  }
  function i(r, u) {
    r === void 0 && (r = !1), u === void 0 && (u = 1), o();
    const {
      left: f,
      top: s,
      width: m,
      height: d
    } = e.getBoundingClientRect();
    if (r || a(), !m || !d)
      return;
    const c = nt(s), v = nt(n.clientWidth - (f + m)), k = nt(n.clientHeight - (s + d)), y = nt(f), g = {
      rootMargin: -c + "px " + -v + "px " + -k + "px " + -y + "px",
      threshold: $e(0, De(1, u)) || 1
    };
    let S = !0;
    function L(F) {
      const M = F[0].intersectionRatio;
      if (M !== u) {
        if (!S)
          return i();
        M ? i(!1, M) : l = setTimeout(() => {
          i(!1, 1e-7);
        }, 100);
      }
      S = !1;
    }
    try {
      t = new IntersectionObserver(L, {
        ...g,
        // Handle <iframe>s
        root: n.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(L, g);
    }
    t.observe(e);
  }
  return i(!0), o;
}
function qo(e, a, t, l) {
  l === void 0 && (l = {});
  const {
    ancestorScroll: n = !0,
    ancestorResize: o = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: r = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = l, f = Ut(e), s = n || o ? [...f ? Ue(f) : [], ...Ue(a)] : [];
  s.forEach((h) => {
    n && h.addEventListener("scroll", t, {
      passive: !0
    }), o && h.addEventListener("resize", t);
  });
  const m = f && r ? Ho(f, t) : null;
  let d = -1, c = null;
  i && (c = new ResizeObserver((h) => {
    let [g] = h;
    g && g.target === f && c && (c.unobserve(a), cancelAnimationFrame(d), d = requestAnimationFrame(() => {
      c && c.observe(a);
    })), t();
  }), f && !u && c.observe(f), c.observe(a));
  let v, k = u ? Ve(e) : null;
  u && y();
  function y() {
    const h = Ve(e);
    k && (h.x !== k.x || h.y !== k.y || h.width !== k.width || h.height !== k.height) && t(), k = h, v = requestAnimationFrame(y);
  }
  return t(), () => {
    s.forEach((h) => {
      n && h.removeEventListener("scroll", t), o && h.removeEventListener("resize", t);
    }), m && m(), c && c.disconnect(), c = null, u && cancelAnimationFrame(v);
  };
}
const Ct = (e, a, t) => {
  const l = /* @__PURE__ */ new Map(), n = {
    platform: jo,
    ...t
  }, o = {
    ...n.platform,
    _c: l
  };
  return wo(e, a, {
    ...n,
    platform: o
  });
};
function Lt(e) {
  var a;
  return (a = e == null ? void 0 : e.$el) != null ? a : e;
}
function Xt(e) {
  return {
    name: "arrow",
    options: e,
    fn(a) {
      const t = Lt(x(e.element));
      return t == null ? {} : So({
        element: t,
        padding: e.padding
      }).fn(a);
    }
  };
}
function Jl(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function yl(e, a) {
  const t = Jl(e);
  return Math.round(a * t) / t;
}
function Go(e, a, t) {
  t === void 0 && (t = {});
  const l = t.whileElementsMounted, n = b(() => {
    var V;
    return (V = x(t.open)) != null ? V : !0;
  }), o = b(() => x(t.middleware)), i = b(() => {
    var V;
    return (V = x(t.placement)) != null ? V : "bottom";
  }), r = b(() => {
    var V;
    return (V = x(t.strategy)) != null ? V : "absolute";
  }), u = b(() => {
    var V;
    return (V = x(t.transform)) != null ? V : !0;
  }), f = b(() => Lt(e.value)), s = b(() => Lt(a.value)), m = P(0), d = P(0), c = P(r.value), v = P(i.value), k = Sl({}), y = P(!1), h = b(() => {
    const V = {
      position: c.value,
      left: "0",
      top: "0"
    };
    if (!s.value)
      return V;
    const j = yl(s.value, m.value), W = yl(s.value, d.value);
    return u.value ? {
      ...V,
      transform: "translate(" + j + "px, " + W + "px)",
      ...Jl(s.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: c.value,
      left: j + "px",
      top: W + "px"
    };
  });
  let g;
  function S() {
    f.value == null || s.value == null || Ct(f.value, s.value, {
      middleware: o.value,
      placement: i.value,
      strategy: r.value
    }).then((V) => {
      m.value = V.x, d.value = V.y, c.value = V.strategy, v.value = V.placement, k.value = V.middlewareData, y.value = !0;
    });
  }
  function L() {
    typeof g == "function" && (g(), g = void 0);
  }
  function F() {
    if (L(), l === void 0) {
      S();
      return;
    }
    if (f.value != null && s.value != null) {
      g = l(f.value, s.value, S);
      return;
    }
  }
  function M() {
    n.value || (y.value = !1);
  }
  return G([o, i, r], S, {
    flush: "sync"
  }), G([f, s], F, {
    flush: "sync"
  }), G(n, M, {
    flush: "sync"
  }), Cl() && wl(L), {
    x: Ie(m),
    y: Ie(d),
    strategy: Ie(c),
    placement: Ie(v),
    middlewareData: Ie(k),
    isPositioned: Ie(y),
    floatingStyles: h,
    update: S
  };
}
let Y = null;
function Zl(e, a, t, l) {
  const n = { hover: !0, focus: !0, click: !0 }, o = {
    top: !0,
    bottom: !0,
    left: !0,
    right: !0,
    "top-end": !0,
    "bottom-end": !0,
    "bottom-start": !0,
    "top-start": !0,
    "left-start": !0,
    "left-end": !0,
    "right-start": !0,
    "right-end": !0
  }, i = {
    primary: !0,
    secondary: !0,
    success: !0,
    danger: !0,
    warning: !0,
    info: !0,
    light: !0,
    dark: !0
  }, r = { html: !0 }, { value: u, modifiers: f } = a, { props: s } = t, m = at(n, f) || (u == null ? void 0 : u.trigger) || ["hover", "focus"], d = at(o, f) || (u == null ? void 0 : u.placement) || "top", c = at(i, f) || (u == null ? void 0 : u.variant) || "", v = at(r, f) || (u == null ? void 0 : u.html) || !1, k = (s == null ? void 0 : s.title) || oo(s == null ? void 0 : s.title) || io(s == null ? void 0 : s.title) || void 0, y = (u == null ? void 0 : u.disabled) || (s == null ? void 0 : s.disabled) || !1, h = (u == null ? void 0 : u.customClass) || "";
  function g() {
    if (Y = document.createElement("div"), Y.className = `${l} fade bg-${c} ${h}`, Y.tabIndex = -1, Y.id = (s == null ? void 0 : s.id) || `${l}-${Math.random().toString(36).substring(2, 11)}`, Y.setAttribute("role", `${l}`), l === "popover") {
      const j = document.createElement("h3");
      j.className = "popover-header", k && (j.innerText = k, Y.appendChild(j));
      const W = document.createElement("div");
      W.className = "popover-body", u && (v ? W.innerHTML = u : W.innerText = u, Y.appendChild(W));
    }
    l === "tooltip" && (v ? Y.innerHTML = k : Y.innerText = k);
    const V = document.createElement("div");
    V.className = `arrow bg-${c}`, Y.appendChild(V), document.body.appendChild(Y), e.popupInstance = Ct(e, Y, {
      placement: d,
      middleware: [
        ht(6),
        yt(),
        qt({ padding: 5 }),
        Xt({ element: V })
      ]
    }).then(({ x: j, y: W, placement: te, middlewareData: ne }) => {
      Object.assign(Y.style, {
        left: `${j}px`,
        top: `${W}px`
      });
      const { x: Q, y: oe } = ne.arrow, O = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right"
      }[te.split("-")[0]];
      Object.assign(V.style, {
        left: Q != null ? `${Q}px` : "",
        top: oe != null ? `${oe}px` : "",
        right: "",
        bottom: "",
        [O]: "-4px"
      }), V.classList.add(te);
    }), e.setAttribute("aria-describedby", Y.id), e.setAttribute("id", Y.id), e.removeAttribute("title"), k && e.setAttribute("data-original-title", k), Y.classList.add("show");
  }
  const S = () => {
    y || g();
  }, L = (V) => {
    var j;
    (j = V == null ? void 0 : V.target) != null && j.id && document.querySelector(`div#${V.target.id}`) ? (document.querySelector(`div#${V.target.id}`).remove(), Y = null) : (Y.remove(), Y = null);
  }, F = (V) => {
    V.stopPropagation(), Y && Y.id === V.target.id || Y && Y.id === e.id || V.target.id && document.querySelector(`div#${V.target.id}`) ? L(V) : (Y && Y.id !== V.target.id && L(), S());
  }, M = (V) => {
    Y && V.target.id !== Y.id && L(Y.id);
  };
  m.includes("hover") && (window.matchMedia("(hover: hover)").matches ? (e.addEventListener("mouseenter", S), e.addEventListener("mouseleave", L)) : (e.addEventListener("click", F), document.addEventListener("click", M))), m.includes("click") && (e.addEventListener("click", F), document.addEventListener("click", M)), m.includes("focus") && (e.addEventListener("focus", S), e.addEventListener("blur", () => Rt(l)));
}
function Ql(e) {
  const a = H(() => e.blank), t = H(() => e.block), l = H(() => e.center), n = H(() => e.fluid), o = H(() => e.fluidGrow), i = H(() => e.start), r = H(() => e.end), u = H(() => e.thumbnail), f = Le(() => e.height ?? NaN), s = Le(() => e.width ?? NaN), m = b(
    () => typeof e.srcset == "string" ? e.srcset.split(",").filter((g) => g).join(",") : Array.isArray(e.srcset) ? e.srcset.filter((g) => g).join(",") : void 0
  ), d = b(
    () => typeof e.sizes == "string" ? e.sizes.split(",").filter((g) => g).join(",") : Array.isArray(e.sizes) ? e.sizes.filter((g) => g).join(",") : void 0
  ), c = b(() => {
    const g = Number.isNaN(s.value) ? void 0 : s.value, S = Number.isNaN(f.value) ? void 0 : f.value;
    if (a.value) {
      if (g !== void 0 && S === void 0)
        return { height: g, width: g };
      if (g === void 0 && S !== void 0)
        return { height: S, width: S };
      if (g === void 0 && S === void 0)
        return { height: 1, width: 1 };
    }
    return {
      width: g,
      height: S
    };
  }), v = K(
    () => h(
      c.value.width,
      c.value.height,
      e.blankColor
    )
  ), k = b(() => [
    {
      rounded: !!e.rounded,
      [`rounded-${e.rounded}`]: fo(e.rounded),
      "img-thumbnail": u.value,
      "img-fluid": n.value || o.value,
      "w-100": o.value,
      [`${y.value}`]: y.value !== void 0,
      "d-block": t.value || l.value
    }
  ]), y = K(
    () => i.value ? "float-start" : r.value ? "float-end" : l.value ? "mx-auto" : void 0
  ), h = (g, S, L) => `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`<svg width="${g}" height="${S}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${g} ${S}" preserveAspectRatio="none">
      <rect width="100%" height="100%" style="fill:${L};"></rect>
      </svg>`)}`;
  return {
    blankBoolean: a,
    computedBlankImgSrc: v,
    computedClasses: k,
    computedDimentions: c,
    computedSizes: d,
    computedSrcset: m
  };
}
const Wo = ["src", "width", "height", "srcset", "sizes"], Kt = /* @__PURE__ */ Z({
  __name: "Image",
  props: {
    blank: { type: [Boolean, String], default: !1 },
    blankColor: { default: "transparent" },
    block: { type: [Boolean, String], default: !1 },
    center: { type: [Boolean, String], default: !1 },
    end: { type: [Boolean, String], default: !1 },
    fluid: { type: [Boolean, String], default: !1 },
    fluidGrow: { type: [Boolean, String], default: !1 },
    height: { default: void 0 },
    sizes: { default: void 0 },
    src: { default: void 0 },
    srcset: { default: void 0 },
    start: { type: [Boolean, String], default: !1 },
    thumbnail: { type: [Boolean, String], default: !1 },
    width: { default: void 0 },
    rounded: { type: [Boolean, String], default: !1 }
  },
  setup(e) {
    const a = e, {
      blankBoolean: t,
      computedBlankImgSrc: l,
      computedClasses: n,
      computedDimentions: o,
      computedSizes: i,
      computedSrcset: r
    } = Ql(a);
    return (u, f) => (p(), T("img", ae(u.$attrs, {
      class: x(n),
      src: x(t) ? x(l) : u.src,
      width: x(o).width || void 0,
      height: x(o).height || void 0,
      srcset: x(t) ? void 0 : x(r),
      sizes: x(t) ? void 0 : x(i)
    }), null, 16, Wo));
  }
}), Yt = /* @__PURE__ */ Z({
  __name: "CardImg",
  props: {
    bottom: { type: [Boolean, String], default: !1 },
    top: { type: [Boolean, String], default: !1 },
    blank: { type: [Boolean, String], default: void 0 },
    blankColor: { default: void 0 },
    block: { type: [Boolean, String], default: void 0 },
    center: { type: [Boolean, String], default: void 0 },
    end: { type: [Boolean, String], default: void 0 },
    fluid: { type: [Boolean, String], default: void 0 },
    fluidGrow: { type: [Boolean, String], default: void 0 },
    height: { default: void 0 },
    sizes: { default: void 0 },
    src: { default: void 0 },
    srcset: { default: void 0 },
    start: { type: [Boolean, String], default: void 0 },
    thumbnail: { type: [Boolean, String], default: void 0 },
    width: { default: void 0 },
    rounded: { type: [Boolean, String], default: void 0 }
  },
  setup(e) {
    const a = e, t = H(() => a.bottom), l = H(() => a.end), n = H(() => a.start), o = H(() => a.top), i = K(
      () => o.value ? "card-img-top" : l.value ? "card-img-right" : t.value ? "card-img-bottom" : n.value ? "card-img-left" : "card-img"
    ), r = b(
      () => El(a, ["bottom", "top", "end", "start"])
    );
    return (u, f) => (p(), I(Kt, ae(r.value, { class: i.value }), null, 16, ["class"]));
  }
}), Uo = ["innerHTML"], wt = /* @__PURE__ */ Z({
  __name: "CardHeadFoot",
  props: {
    borderVariant: { default: null },
    html: { default: void 0 },
    tag: { default: "div" },
    text: { default: void 0 },
    variant: { default: null },
    bgVariant: { default: null },
    textVariant: { default: null }
  },
  setup(e) {
    const a = e, t = pt(a), l = b(() => [
      t.value,
      {
        [`border-${a.borderVariant}`]: a.borderVariant !== null
      }
    ]);
    return (n, o) => (p(), I(J(n.tag), {
      class: $(l.value)
    }, {
      default: E(() => [
        n.html ? (p(), T("div", {
          key: 0,
          innerHTML: n.html
        }, null, 8, Uo)) : C(n.$slots, "default", { key: 1 }, () => [
          q(D(n.text), 1)
        ])
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Jt = /* @__PURE__ */ Z({
  __name: "CardHeader",
  props: {
    borderVariant: { default: void 0 },
    html: { default: void 0 },
    tag: { default: "div" },
    text: { default: void 0 },
    variant: { default: void 0 },
    bgVariant: { default: void 0 },
    textVariant: { default: void 0 }
  },
  setup(e) {
    const a = e;
    return (t, l) => (p(), I(wt, ae({ class: "card-header" }, a), {
      default: E(() => [
        C(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), Zt = /* @__PURE__ */ Z({
  __name: "CardTitle",
  props: {
    tag: { default: "h4" },
    text: { default: void 0 }
  },
  setup(e) {
    return (a, t) => (p(), I(J(a.tag), { class: "card-title" }, {
      default: E(() => [
        C(a.$slots, "default", {}, () => [
          q(D(a.text), 1)
        ])
      ]),
      _: 3
    }));
  }
}), Qt = /* @__PURE__ */ Z({
  __name: "CardSubtitle",
  props: {
    text: { default: void 0 },
    tag: { default: "h6" },
    textVariant: { default: "body-secondary" }
  },
  setup(e) {
    const a = e, t = b(() => ({
      [`text-${a.textVariant}`]: a.textVariant !== null
    }));
    return (l, n) => (p(), I(J(l.tag), {
      class: $(["card-subtitle mb-2", t.value])
    }, {
      default: E(() => [
        C(l.$slots, "default", {}, () => [
          q(D(l.text), 1)
        ])
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), _t = /* @__PURE__ */ Z({
  __name: "CardBody",
  props: {
    overlay: { type: [Boolean, String], default: !1 },
    subtitle: { default: void 0 },
    subtitleTag: { default: "h4" },
    subtitleTextVariant: { default: void 0 },
    tag: { default: "div" },
    text: { default: void 0 },
    title: { default: void 0 },
    titleTag: { default: "h4" },
    variant: { default: null },
    bgVariant: { default: null },
    textVariant: { default: null }
  },
  setup(e) {
    const a = e, t = Fe(), l = H(() => a.overlay), n = pt(a), o = K(() => !rt(t.title)), i = K(() => !rt(t.subtitle)), r = b(() => [
      n.value,
      {
        "card-img-overlay": l.value
      }
    ]);
    return (u, f) => (p(), I(J(u.tag), {
      class: $(["card-body", r.value])
    }, {
      default: E(() => [
        u.title || o.value ? (p(), I(Zt, {
          key: 0,
          tag: u.titleTag
        }, {
          default: E(() => [
            C(u.$slots, "title", {}, () => [
              q(D(u.title), 1)
            ])
          ]),
          _: 3
        }, 8, ["tag"])) : R("", !0),
        u.subtitle || i.value ? (p(), I(Qt, {
          key: 1,
          tag: u.subtitleTag,
          "text-variant": u.subtitleTextVariant
        }, {
          default: E(() => [
            C(u.$slots, "subtitle", {}, () => [
              q(D(u.subtitle), 1)
            ])
          ]),
          _: 3
        }, 8, ["tag", "text-variant"])) : R("", !0),
        C(u.$slots, "default", {}, () => [
          q(D(u.text), 1)
        ])
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), el = /* @__PURE__ */ Z({
  __name: "CardFooter",
  props: {
    borderVariant: { default: void 0 },
    html: { default: void 0 },
    tag: { default: "div" },
    text: { default: void 0 },
    variant: { default: void 0 },
    bgVariant: { default: void 0 },
    textVariant: { default: void 0 }
  },
  setup(e) {
    const a = e;
    return (t, l) => (p(), I(wt, ae({ class: "card-footer" }, a), {
      default: E(() => [
        C(t.$slots, "default", {}, () => [
          q(D(t.text), 1)
        ])
      ]),
      _: 3
    }, 16));
  }
}), _l = /* @__PURE__ */ Z({
  __name: "Card",
  props: {
    align: { default: void 0 },
    bodyBgVariant: { default: void 0 },
    bodyClass: { default: void 0 },
    bodyTag: { default: "div" },
    bodyText: { default: "" },
    bodyTextVariant: { default: void 0 },
    borderVariant: { default: null },
    footer: { default: void 0 },
    footerBgVariant: { default: void 0 },
    footerBorderVariant: { default: void 0 },
    footerClass: { default: void 0 },
    footerHtml: { default: "" },
    footerTag: { default: "div" },
    footerTextVariant: { default: void 0 },
    footerVariant: { default: null },
    header: { default: void 0 },
    headerBgVariant: { default: void 0 },
    headerBorderVariant: { default: void 0 },
    headerClass: { default: void 0 },
    headerHtml: { default: "" },
    headerTag: { default: "div" },
    headerTextVariant: { default: void 0 },
    headerVariant: { default: null },
    imgAlt: { default: void 0 },
    imgBottom: { type: [Boolean, String], default: !1 },
    imgEnd: { type: [Boolean, String], default: !1 },
    imgHeight: { default: void 0 },
    imgSrc: { default: void 0 },
    imgStart: { type: [Boolean, String], default: !1 },
    imgTop: { type: [Boolean, String], default: !1 },
    imgWidth: { default: void 0 },
    noBody: { type: [Boolean, String], default: !1 },
    overlay: { type: [Boolean, String], default: !1 },
    subtitle: { default: void 0 },
    subtitleTag: { default: "h6" },
    subtitleTextVariant: { default: "body-secondary" },
    tag: { default: "div" },
    title: { default: void 0 },
    titleTag: { default: "h4" },
    variant: { default: null },
    bgVariant: { default: null },
    textVariant: { default: null }
  },
  setup(e) {
    const a = e, t = Fe(), l = H(() => a.imgBottom), n = H(() => a.imgEnd), o = H(() => a.imgStart), i = H(() => a.noBody), r = K(() => !rt(t.header)), u = K(() => !rt(t.footer)), f = pt(a), s = b(() => [
      f.value,
      {
        [`text-${a.align}`]: a.align !== void 0,
        [`border-${a.borderVariant}`]: a.borderVariant !== null,
        "flex-row": o.value,
        "flex-row-reverse": n.value
      }
    ]), m = b(() => ({
      src: a.imgSrc,
      alt: a.imgAlt,
      height: a.imgHeight,
      width: a.imgWidth,
      bottom: a.imgBottom,
      end: a.imgEnd,
      start: a.imgStart,
      top: a.imgTop
    })), d = Pl();
    return (c, v) => (p(), I(J(c.tag), {
      class: $(["card", s.value])
    }, {
      default: E(() => [
        fe(x(d).define, null, {
          default: E(() => [
            C(c.$slots, "img", {}, () => [
              c.imgSrc ? (p(), I(Yt, we(ae({ key: 0 }, m.value)), null, 16)) : R("", !0)
            ])
          ]),
          _: 3
        }),
        x(l) ? R("", !0) : (p(), I(x(d).reuse, { key: 0 })),
        c.header || r.value || c.headerHtml ? (p(), I(Jt, {
          key: 1,
          "bg-variant": c.headerBgVariant,
          variant: c.headerVariant,
          "border-variant": c.headerBorderVariant,
          html: c.headerHtml,
          tag: c.headerTag,
          "text-variant": c.headerTextVariant,
          class: $(c.headerClass)
        }, {
          default: E(() => [
            C(c.$slots, "header", {}, () => [
              q(D(c.header), 1)
            ])
          ]),
          _: 3
        }, 8, ["bg-variant", "variant", "border-variant", "html", "tag", "text-variant", "class"])) : R("", !0),
        x(i) ? C(c.$slots, "default", { key: 3 }, () => [
          q(D(c.bodyText), 1)
        ]) : (p(), I(_t, {
          key: 2,
          overlay: c.overlay,
          "bg-variant": c.bodyBgVariant,
          tag: c.bodyTag,
          "text-variant": c.bodyTextVariant,
          subtitle: c.subtitle,
          "subtitle-tag": c.subtitleTag,
          "subtitle-text-variant": c.subtitleTextVariant,
          title: c.title,
          "title-tag": c.titleTag,
          class: $(c.bodyClass)
        }, {
          default: E(() => [
            C(c.$slots, "default", {}, () => [
              q(D(c.bodyText), 1)
            ])
          ]),
          _: 3
        }, 8, ["overlay", "bg-variant", "tag", "text-variant", "subtitle", "subtitle-tag", "subtitle-text-variant", "title", "title-tag", "class"])),
        c.footer || u.value || c.footerHtml ? (p(), I(el, {
          key: 4,
          "bg-variant": c.footerBgVariant,
          "border-variant": c.footerBorderVariant,
          variant: c.footerVariant,
          html: c.footerHtml,
          tag: c.footerTag,
          "text-variant": c.footerTextVariant,
          class: $(c.footerClass)
        }, {
          default: E(() => [
            C(c.$slots, "footer", {}, () => [
              q(D(c.footer), 1)
            ])
          ]),
          _: 3
        }, 8, ["bg-variant", "border-variant", "variant", "html", "tag", "text-variant", "class"])) : R("", !0),
        x(l) ? (p(), I(x(d).reuse, { key: 5 })) : R("", !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Xo = ["src", "width", "height", "srcset", "sizes"], tl = /* @__PURE__ */ Z({
  __name: "ImageLazy",
  props: {
    blank: { type: [Boolean, String], default: !1 },
    blankColor: { default: "transparent" },
    block: { type: [Boolean, String], default: !1 },
    center: { type: [Boolean, String], default: !1 },
    end: { type: [Boolean, String], default: !1 },
    fluid: { type: [Boolean, String], default: !1 },
    fluidGrow: { type: [Boolean, String], default: !1 },
    height: { default: void 0 },
    sizes: { default: void 0 },
    src: { default: void 0 },
    srcset: { default: void 0 },
    start: { type: [Boolean, String], default: !1 },
    thumbnail: { type: [Boolean, String], default: !1 },
    width: { default: void 0 },
    rounded: { type: [Boolean, String], default: !1 }
  },
  setup(e) {
    const a = e, t = P(null), l = P(!1), {
      blankBoolean: n,
      computedBlankImgSrc: o,
      computedClasses: i,
      computedDimentions: r,
      computedSizes: u,
      computedSrcset: f
    } = Ql(a);
    return Kn(t, ([{ isIntersecting: s }]) => {
      l.value = s;
    }), (s, m) => (p(), T("img", ae({
      ref_key: "target",
      ref: t
    }, s.$attrs, {
      class: x(i),
      src: !x(n) && l.value ? s.src : x(o),
      width: x(r).width || void 0,
      height: x(r).height || void 0,
      srcset: !x(n) && l.value ? x(f) : void 0,
      sizes: x(n) ? void 0 : x(u)
    }), null, 16, Xo));
  }
}), ea = /* @__PURE__ */ Z({
  __name: "CardImgLazy",
  props: {
    bottom: { type: [Boolean, String], default: !1 },
    top: { type: [Boolean, String], default: !1 },
    blank: { type: [Boolean, String], default: void 0 },
    blankColor: { default: void 0 },
    block: { type: [Boolean, String], default: void 0 },
    center: { type: [Boolean, String], default: void 0 },
    end: { type: [Boolean, String], default: void 0 },
    fluid: { type: [Boolean, String], default: void 0 },
    fluidGrow: { type: [Boolean, String], default: void 0 },
    height: { default: void 0 },
    sizes: { default: void 0 },
    src: { default: void 0 },
    srcset: { default: void 0 },
    start: { type: [Boolean, String], default: void 0 },
    thumbnail: { type: [Boolean, String], default: void 0 },
    width: { default: void 0 },
    rounded: { type: [Boolean, String], default: void 0 }
  },
  setup(e) {
    const a = e, t = H(() => a.bottom), l = H(() => a.end), n = H(() => a.start), o = H(() => a.top), i = K(
      () => o.value ? "card-img-top" : l.value ? "card-img-right" : t.value ? "card-img-bottom" : n.value ? "card-img-left" : "card-img"
    ), r = b(
      () => El(a, ["bottom", "top", "end", "start"])
    );
    return (u, f) => (p(), I(tl, ae(r.value, { class: i.value }), null, 16, ["class"]));
  }
}), ta = /* @__PURE__ */ Z({
  __name: "CardText",
  props: {
    tag: { default: "p" },
    text: { default: void 0 }
  },
  setup(e) {
    return (a, t) => (p(), I(J(a.tag), { class: "card-text" }, {
      default: E(() => [
        C(a.$slots, "default", {}, () => [
          q(D(a.text), 1)
        ])
      ]),
      _: 3
    }));
  }
}), la = /* @__PURE__ */ Z({
  __name: "CardGroup",
  props: {
    columns: { type: [Boolean, String], default: !1 },
    deck: { type: [Boolean, String], default: !1 },
    tag: { default: "div" }
  },
  setup(e) {
    const a = e, t = H(() => a.columns), l = H(() => a.deck), n = b(() => l.value ? "card-deck" : t.value ? "card-columns" : "card-group");
    return (o, i) => (p(), I(J(o.tag), {
      class: $(n.value)
    }, {
      default: E(() => [
        C(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Ko = {
  install: (e) => {
    e.component("BCard", _l), e.component("BCardBody", _t), e.component("BCardFooter", el), e.component("BCardHeader", Jt), e.component("BCardImg", Yt), e.component("BCardImgLazy", ea), e.component("BCardHeadFoot", wt), e.component("BCardSubTitle", Qt), e.component("BCardText", ta), e.component("BCardTitle", Zt), e.component("BCardGroup", la);
  }
}, aa = /* @__PURE__ */ Z({
  inheritAttrs: !1,
  __name: "Collapse",
  props: {
    modelValue: { type: Boolean, default: !1 },
    appear: { type: Boolean, default: !1 },
    id: { default: void 0 },
    isNav: { type: Boolean, default: !1 },
    tag: { default: "div" },
    visible: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "hidden", "hide", "show", "shown"],
  setup(e, { emit: a }) {
    const t = e, l = a, n = ze(t, "modelValue", l, { passive: !0 }), o = K(t.visible);
    o.value && (n.value = !0), G(o, (c) => {
      n.value = c;
    });
    const i = P(!1);
    function r(c) {
      c.style.height = "0", requestAnimationFrame(() => {
        fl(c), c.style.height = `${c.scrollHeight}px`;
      }), i.value = !0, l("show");
    }
    function u(c) {
      c.style.height = "", i.value = !1, l("shown");
    }
    function f(c) {
      c.style.height = "auto", c.style.display = "block", c.style.height = `${c.getBoundingClientRect().height}px`, fl(c), c.style.height = "0", i.value = !0, l("hide");
    }
    function s(c) {
      c.style.height = "", i.value = !1, l("hidden");
    }
    function m() {
      n.value = !1;
    }
    const d = P(null);
    return ce(d, "bv-toggle", () => {
      n.value = !n.value;
    }), (c, v) => (p(), I(Et, {
      css: !0,
      "enter-active-class": "collapsing",
      "enter-to-class": "collapse show",
      "leave-active-class": "collapsing",
      "leave-to-class": "collapse",
      appear: t.appear,
      onEnter: v[0] || (v[0] = (k) => r(k)),
      onAfterEnter: v[1] || (v[1] = (k) => u(k)),
      onLeave: v[2] || (v[2] = (k) => f(k)),
      onAfterLeave: v[3] || (v[3] = (k) => s(k))
    }, {
      default: E(() => [
        Be((p(), I(J(t.tag), ae({
          id: t.id,
          ref_key: "collapseEl",
          ref: d,
          class: {
            "navbar-collapse": t.isNav,
            collapse: !i.value,
            show: x(n) && !i.value
          },
          "is-nav": t.isNav
        }, c.$attrs), {
          default: E(() => [
            C(c.$slots, "default", {
              visible: x(n),
              close: m
            })
          ]),
          _: 3
        }, 16, ["id", "class", "is-nav"])), [
          [$l, x(n)]
        ])
      ]),
      _: 3
    }, 8, ["appear"]));
  }
}), Yo = (e, a) => {
  var r;
  const { modifiers: t, arg: l, value: n } = e, o = Object.keys(t || {}), i = typeof n == "string" ? n.split(so) : n;
  if (a.tagName.toLowerCase() === "a") {
    const u = ((r = a.attributes.getNamedItem("href")) == null ? void 0 : r.value) || "";
    uo.test(u) && o.push(u.replace(ro, ""));
  }
  return Array.prototype.concat.apply([], [l, i]).forEach((u) => typeof u == "string" && o.push(u)), o.filter((u, f, s) => u && s.indexOf(u) === f);
}, Jo = (e, a) => {
  e.forEach((t) => {
    const l = document.getElementById(t);
    l !== null && l.dispatchEvent(new Event("bv-toggle"));
  }), setTimeout(() => na(e, a), 50);
}, na = (e, a) => {
  let t = !1;
  e.forEach((l) => {
    const n = document.getElementById(l);
    n != null && n.classList.contains("show") && (t = !0), n != null && n.classList.contains("closing") && (t = !1);
  }), a.setAttribute("aria-expanded", t ? "true" : "false"), a.classList.remove(t ? "collapsed" : "not-collapsed"), a.classList.add(t ? "not-collapsed" : "collapsed");
}, hl = (e, a) => {
  const t = Yo(a, e);
  t.length !== 0 && (e.__toggle && e.removeEventListener("click", e.__toggle), e.__toggle = () => Jo(t, e), e.addEventListener("click", e.__toggle), e.setAttribute("aria-controls", t.join(" ")), na(t, e));
}, oa = {
  mounted: hl,
  updated: hl,
  unmounted(e) {
    e.removeEventListener("click", e.__toggle), e.removeAttribute("aria-controls"), e.removeAttribute("aria-expanded");
  }
}, Zo = {
  install: (e) => {
    e.directive("BToggle", oa);
  }
}, ia = {
  install: (e) => {
    e.use(Zo), e.component("BCollapse", aa);
  }
}, sa = /* @__PURE__ */ Z({
  inheritAttrs: !1,
  __name: "DropdownItem",
  props: {
    custom: { type: Boolean },
    activeClass: {},
    exactActiveClass: {},
    ariaCurrentValue: {},
    to: {},
    replace: { type: Boolean },
    active: { type: Boolean },
    disabled: { type: Boolean },
    href: {},
    rel: {},
    target: {},
    linkClass: {},
    variant: {}
  },
  setup(e) {
    const a = e;
    return (t, l) => {
      const n = xl("b-link");
      return p(), T("li", {
        role: "presentation",
        class: $(t.$attrs.class),
        style: He(t.$attrs.style || void 0)
      }, [
        fe(n, ae({
          class: ["dropdown-item", [
            a.linkClass,
            {
              [`text-${a.variant}`]: a.variant && !(a.active || a.disabled)
            }
          ]],
          role: "menuitem"
        }, t.$attrs), {
          default: E(() => [
            C(t.$slots, "default")
          ]),
          _: 3
        }, 16, ["class"])
      ], 6);
    };
  }
}), Qo = {
  install: (e) => {
    e.component("BDropdownItem", sa);
  }
}, _o = ["id", "novalidate"], ra = {
  __name: "Form",
  props: {
    id: {
      type: String,
      default: void 0
    },
    novalidate: {
      type: Boolean,
      default: !1
    },
    validated: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["submit"],
  setup(e, { emit: a }) {
    const t = a, l = (n) => {
      t("submit", n);
    };
    return (n, o) => (p(), T("form", {
      id: e.id,
      class: $({ "was-validated": e.validated }),
      novalidate: e.novalidate,
      onSubmit: l
    }, [
      C(n.$slots, "default")
    ], 42, _o));
  }
}, ua = {
  __name: "FormInvalidFeedback",
  props: {
    ariaLive: {
      type: String,
      default: "polite"
    },
    forceShow: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      default: ""
    },
    role: {
      type: String,
      default: ""
    },
    state: {
      type: Boolean,
      default: null
    },
    tag: {
      type: String,
      default: "div"
    },
    tooltip: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (a, t) => e.state === !1 ? (p(), I(J(e.tag), {
      key: 0,
      id: e.id,
      role: e.role,
      "aria-live": e.ariaLive,
      class: $({
        "invalid-feedback": !e.tooltip,
        "invalid-tooltip": e.tooltip
      })
    }, {
      default: E(() => [
        C(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "role", "aria-live", "class"])) : R("", !0);
  }
}, da = {
  __name: "FormValidFeedback",
  props: {
    ariaLive: {
      type: String,
      default: "polite"
    },
    forceShow: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      default: ""
    },
    role: {
      type: String,
      default: ""
    },
    state: {
      type: Boolean,
      default: null
    },
    tag: {
      type: String,
      default: "div"
    },
    tooltip: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (a, t) => (p(), I(J(e.tag), {
      id: e.id,
      role: e.role,
      "aria-live": e.ariaLive,
      class: $({
        "d-none": !e.forceShow && (e.state === null || !e.state),
        "valid-feedback": !e.tooltip,
        "valid-tooltip": e.tooltip
      })
    }, {
      default: E(() => [
        C(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "role", "aria-live", "class"]));
  }
}, ca = {
  __name: "FormText",
  props: {
    id: {
      type: String,
      default: void 0
    },
    inline: {
      type: Boolean,
      default: !1
    },
    tag: {
      type: String,
      default: "small"
    },
    textVariant: {
      type: String,
      default: "body-secondary"
    }
  },
  setup(e) {
    return (a, t) => (p(), I(J(e.tag), {
      id: e.id,
      class: $([
        "form-text",
        "text-" + e.textVariant,
        { "form-text-inline": e.inline }
      ])
    }, {
      default: E(() => [
        C(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "class"]));
  }
}, ei = ["id"], ti = ["value", "disabled"], fa = {
  __name: "FormDatalist",
  props: {
    id: {
      type: String,
      default: void 0
    },
    disabledField: {
      type: String,
      default: "disabled"
    },
    options: {
      type: [Array, Object],
      default: () => []
    },
    textField: {
      type: String,
      default: "text"
    },
    valueField: {
      type: String,
      default: "value"
    }
  },
  setup(e) {
    const a = e, t = (o) => o[a.valueField] === void 0 ? o : o === null || o[a.valueField] === null ? "" : o[a.valueField], l = (o) => o[a.textField] === void 0 ? o : o[a.textField], n = (o) => o[a.disabledField] === void 0 ? !1 : o[a.disabledField];
    return (o, i) => (p(), T("datalist", { id: e.id }, [
      o.$slots.default ? R("", !0) : (p(!0), T(ee, { key: 0 }, se(e.options, (r) => (p(), T("option", {
        key: t(r),
        value: t(r),
        disabled: n(r)
      }, D(l(r)), 9, ti))), 128)),
      C(o.$slots, "default")
    ], 8, ei));
  }
}, va = {
  install: (e) => {
    e.component("BForm", ra), e.component("BFormInvalidFeedback", ua), e.component("BFormValidFeedback", da), e.component("BFormText", ca), e.component("BFormDatalist", fa);
  }
}, li = ["for"], ai = ["aria-live"], ni = {
  key: 0,
  class: "valid-feedback d-block"
}, oi = {
  key: 1,
  class: "invalid-feedback d-block"
}, ii = {
  key: 1,
  class: "form-text text-body-secondary"
}, ma = {
  __name: "FormGroup",
  props: {
    description: {
      type: String,
      default: void 0
    },
    disabled: Boolean,
    feedbackAriaLive: {
      type: String,
      default: "assertive"
    },
    id: {
      type: String,
      default: void 0
    },
    invalidFeedback: {
      type: String,
      default: void 0
    },
    label: {
      type: String,
      default: void 0
    },
    labelAlign: {
      type: String,
      default: void 0
    },
    labelClass: {
      type: [Array, Object, String],
      default: void 0
    },
    labelFor: {
      type: String,
      default: void 0
    },
    labelSize: {
      type: String,
      default: void 0
    },
    labelSrOnly: Boolean,
    state: {
      type: Boolean,
      default: null
    },
    tooltip: Boolean,
    validFeedback: {
      type: String,
      default: void 0
    },
    validated: Boolean,
    labelAlignLg: {
      type: String,
      default: void 0
    },
    labelAlignMd: {
      type: String,
      default: void 0
    },
    labelAlignSm: {
      type: String,
      default: void 0
    },
    labelAlignXl: {
      type: String,
      default: void 0
    },
    labelCols: {
      type: [Boolean, Number, String],
      default: void 0
    },
    labelColsLg: {
      type: [Boolean, Number, String],
      default: void 0
    },
    labelColsMd: {
      type: [Boolean, Number, String],
      default: void 0
    },
    labelColsSm: {
      type: [Boolean, Number, String],
      default: void 0
    },
    labelColsXl: {
      type: [Boolean, Number, String],
      default: void 0
    },
    contentCols: {
      type: [Boolean, Number, String],
      default: void 0
    },
    contentColsLg: {
      type: [Boolean, Number, String],
      default: void 0
    },
    contentColsMd: {
      type: [Boolean, Number, String],
      default: void 0
    },
    contentColsSm: {
      type: [Boolean, Number, String],
      default: void 0
    },
    contentColsXl: {
      type: [Boolean, Number, String],
      default: void 0
    }
  },
  setup(e) {
    const a = Fe(), t = e, l = b(() => {
      const d = {};
      return t.labelAlign && (d[`text-${t.labelAlign}`] = !0), t.labelAlignLg && (d[`text-lg-${t.labelAlignLg}`] = !0), t.labelAlignMd && (d[`text-md-${t.labelAlignMd}`] = !0), t.labelAlignSm && (d[`text-sm-${t.labelAlignSm}`] = !0), t.labelAlignXl && (d[`text-xl-${t.labelAlignXl}`] = !0), d;
    }), n = b(() => {
      const d = {};
      return (t.labelCols || t.contentCols) && (d.col = !0), t.labelColsLg && (typeof t.labelColsLg == "string" || typeof t.labelColsLg == "number" ? d[`col-lg-${t.labelColsLg}`] = !0 : d["col-lg"] = !0), t.labelColsMd && (typeof t.labelColsMd == "string" || typeof t.labelColsMd == "number" ? d[`col-md-${t.labelColsMd}`] = !0 : d["col-md"] = !0), t.labelColsSm && (typeof t.labelColsSm == "string" || typeof t.labelColsSm == "number" ? d[`col-sm-${t.labelColsSm}`] = !0 : d["col-sm"] = !0), t.labelColsXl && (typeof t.labelColsXl == "string" || typeof t.labelColsXl == "number" ? d[`col-xl-${t.labelColsXl}`] = !0 : d["col-xl"] = !0), d;
    }), o = b(() => {
      const d = {};
      return (t.contentCols || t.labelCols) && (d.col = !0), t.contentColsLg && (typeof t.contentColsLg == "string" || typeof t.contentColsLg == "number" ? d[`col-lg-${t.contentColsLg}`] = !0 : d["col-lg"] = !0), t.contentColsMd && (typeof t.contentColsMd == "string" || typeof t.contentColsMd == "number" ? d[`col-md-${t.contentColsMd}`] = !0 : d["col-md"] = !0), t.contentColsSm && (typeof t.contentColsSm == "string" || typeof t.contentColsSm == "number" ? d[`col-sm-${t.contentColsSm}`] = !0 : d["col-sm"] = !0), t.contentColsXl && (typeof t.contentColsXl == "string" || typeof t.contentColsXl == "number" ? d[`col-xl-${t.contentColsXl}`] = !0 : d["col-xl"] = !0), d;
    }), i = b(() => {
      if (t.state !== null)
        return t.state === !0;
    }), r = b(() => {
      if (t.state !== null)
        return t.state === !1;
    }), u = b(() => {
      if (t.state !== null)
        return t.invalidFeedback || a["invalid-feedback"] || t.validFeedback || a["valid-feedback"];
    }), f = b(() => t.labelFor ? "div" : "fieldset"), s = b(() => t.contentCols || t.contentColsLg || t.contentColsMd || t.contentColsSm || t.contentColsXl || t.labelCols || t.labelColsLg || t.labelColsMd || t.labelColsSm || t.labelColsXl), m = b(() => t.labelSize ? `col-form-label col-form-label-${t.labelSize}` : "form-label");
    return (d, c) => (p(), I(J(f.value), {
      id: e.id,
      class: $([
        "form-group",
        { "was-validated": e.validated, "has-validation": e.validated },
        { "is-valid": e.state === !0 },
        { "is-invalid": e.state === !1 },
        { row: s.value }
      ]),
      disabled: !e.labelFor && e.disabled || void 0,
      role: "group"
    }, {
      default: E(() => [
        e.labelFor && e.label ? (p(), T("label", {
          key: 0,
          for: e.labelFor,
          class: $([
            n.value,
            e.labelClass,
            l.value,
            m.value,
            { "visually-hidden": e.labelSrOnly },
            { "d-block": !s.value }
          ])
        }, [
          C(d.$slots, "label", {}, () => [
            q(D(e.label), 1)
          ])
        ], 10, li)) : !e.labelFor && e.label ? (p(), T("legend", {
          key: 1,
          class: $(["d-block", [
            n.value,
            e.labelClass,
            l.value,
            m.value,
            { "visually-hidden": e.labelSrOnly }
          ]])
        }, [
          C(d.$slots, "label", {}, () => [
            q(D(e.label), 1)
          ])
        ], 2)) : R("", !0),
        N("div", {
          class: $(o.value)
        }, [
          C(d.$slots, "default"),
          u.value ? (p(), T("div", {
            key: 0,
            "aria-live": e.feedbackAriaLive,
            role: "alert"
          }, [
            i.value ? (p(), T("div", ni, [
              C(d.$slots, "valid-feedback", {}, () => [
                q(D(e.validFeedback), 1)
              ])
            ])) : R("", !0),
            r.value ? (p(), T("div", oi, [
              C(d.$slots, "invalid-feedback", {}, () => [
                q(D(e.invalidFeedback), 1)
              ])
            ])) : R("", !0)
          ], 8, ai)) : R("", !0),
          e.description ? (p(), T("small", ii, [
            C(d.$slots, "description", {}, () => [
              q(D(e.description), 1)
            ])
          ])) : R("", !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["id", "class", "disabled"]));
  }
}, ga = {
  install: (e) => {
    e.component("BFormGroup", ma);
  }
}, si = ["id", "value", "type", "aria-invalid", "autocomplete", "autofocus", "disabled", "form", "list", "max", "min", "name", "placeholder", "required", "step", "readonly"], pa = /* @__PURE__ */ Z({
  __name: "FormInput",
  props: /* @__PURE__ */ Ne({
    ariaInvalid: { default: void 0 },
    autocomplete: { default: void 0 },
    autofocus: { type: Boolean },
    disabled: { type: Boolean },
    form: { default: void 0 },
    id: { default: void 0 },
    max: { default: void 0 },
    min: { default: void 0 },
    name: { default: void 0 },
    placeholder: { default: void 0 },
    readonly: { type: Boolean },
    required: { type: Boolean },
    size: { default: void 0 },
    step: { default: void 0 },
    type: { default: "text" },
    number: { type: Boolean, default: !1 },
    formatter: { type: Function, default: void 0 },
    lazy: { type: Boolean },
    lazyFormatter: { type: Boolean },
    list: { default: void 0 },
    plaintext: { type: Boolean },
    state: { type: Boolean, default: void 0 },
    trim: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ne(["input", "blur", "change"], ["update:modelValue"]),
  setup(e, { expose: a, emit: t }) {
    const l = P(null), n = e, o = Nt(e, "modelValue"), i = t, r = b(() => ({
      "is-valid": n.state === !0,
      "is-invalid": n.state === !1,
      "form-control-plaintext": n.plaintext,
      "form-range": n.type === "range",
      "form-control": n.type !== "range" && !n.plaintext,
      "form-control-lg": n.size === "lg" && n.type !== "range",
      "form-control-sm": n.size === "sm" && n.type !== "range"
    }));
    function u(v, k, y = !1) {
      return n.formatter && (!n.lazyFormatter || y) ? n.formatter(v, k) : v;
    }
    function f(v) {
      return v = v ? v.toString() : "", n.trim && (v = v.trim()), n.number && (v = parseFloat(v)), v;
    }
    function s(v, k = !1) {
      n.lazy && !k || (v = f(v), v !== o.value ? o.value = v : n.formatter && l.value && v !== l.value.value && (l.value.value = v.toString()));
    }
    const m = (v) => {
      const { value: k } = v.target, y = u(k, v, !0);
      s(y, !0), i("blur", v);
    }, d = (v) => {
      const { value: k } = v.target, y = u(k, v, !0);
      s(y, !0), i("change", v);
    }, c = (v) => {
      const { value: k } = v.target, y = u(k, v);
      s(y), i("input", v);
    };
    return a({ input: l }), (v, k) => (p(), T("input", {
      id: v.id,
      ref_key: "input",
      ref: l,
      value: e.modelValue,
      type: v.type,
      "aria-invalid": v.state === !1 || v.ariaInvalid,
      autocomplete: v.autocomplete,
      autofocus: v.autofocus,
      disabled: v.disabled,
      form: v.form,
      list: v.list,
      max: v.max,
      min: v.min,
      name: v.name,
      placeholder: v.placeholder,
      required: v.required,
      step: v.step,
      class: $(r.value),
      readonly: v.readonly || v.plaintext,
      onBlur: m,
      onChange: d,
      onInput: c
    }, null, 42, si));
  }
}), ba = {
  install: (e) => {
    e.component("BFormInput", pa);
  }
}, Re = {
  __name: "FormInputGroupText",
  props: {
    tag: {
      type: String,
      default: "div"
    }
  },
  setup(e) {
    return (a, t) => (p(), I(J(e.tag), { class: "input-group-text" }, {
      default: E(() => [
        C(a.$slots, "default")
      ]),
      _: 3
    }));
  }
}, ll = {
  __name: "FormInputGroupAppend",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    isText: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      default: void 0
    }
  },
  setup(e) {
    return (a, t) => (p(), I(J(e.tag), {
      id: e.id,
      class: "input-group-append"
    }, {
      default: E(() => [
        e.isText ? (p(), I(Re, { key: 0 }, {
          default: E(() => [
            C(a.$slots, "default")
          ]),
          _: 3
        })) : C(a.$slots, "default", { key: 1 })
      ]),
      _: 3
    }, 8, ["id"]));
  }
}, al = {
  __name: "FormInputGroupPrepend",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    isText: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      default: void 0
    }
  },
  setup(e) {
    return (a, t) => (p(), I(J(e.tag), {
      id: e.id,
      class: "input-group-prepend"
    }, {
      default: E(() => [
        e.isText ? (p(), I(Re, { key: 0 }, {
          default: E(() => [
            C(a.$slots, "default")
          ]),
          _: 3
        })) : C(a.$slots, "default", { key: 1 })
      ]),
      _: 3
    }, 8, ["id"]));
  }
}, ya = {
  __name: "FormInputGroup",
  props: {
    append: {
      type: String,
      default: void 0
    },
    id: {
      type: String,
      default: void 0
    },
    prepend: {
      type: String,
      default: void 0
    },
    size: {
      type: String,
      default: ""
      // Default size is 'md'
    },
    tag: {
      type: String,
      default: "div"
      // Default tag is 'div'
    }
  },
  setup(e) {
    const a = e, t = b(() => a.size ? `input-group-${a.size}` : "");
    return (l, n) => (p(), I(J(e.tag), {
      id: e.id,
      class: $(["input-group", t.value])
    }, {
      default: E(() => [
        e.prepend ? (p(), I(al, { key: 0 }, {
          default: E(() => [
            fe(Re, null, {
              default: E(() => [
                q(D(e.prepend), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : R("", !0),
        C(l.$slots, "prepend"),
        C(l.$slots, "default"),
        C(l.$slots, "append"),
        e.append ? (p(), I(ll, { key: 1 }, {
          default: E(() => [
            fe(Re, null, {
              default: E(() => [
                q(D(e.append), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : R("", !0)
      ]),
      _: 3
    }, 8, ["id", "class"]));
  }
}, ha = {
  install: (e) => {
    e.component("BInputGroup", ya), e.component("BInputGroupText", Re), e.component("BInputGroupAppend", ll), e.component("BInputGroupPrepend", al);
  }
}, ri = ["id", "aria-invalid", "autocomplete", "autofocus", "disabled", "form", "name", "placeholder", "readonly", "required", "rows", "size", "wrap", "value"], Ba = {
  __name: "FormTextarea",
  props: {
    ariaInvalid: {
      type: [Boolean, String],
      default: void 0
    },
    autocomplete: {
      type: String,
      default: void 0
    },
    autofocus: Boolean,
    disabled: Boolean,
    form: {
      type: String,
      default: void 0
    },
    formatter: {
      type: Function,
      default: null
    },
    id: {
      type: String,
      default: void 0
    },
    lazy: {
      type: Boolean,
      default: !1
    },
    lazyFormatter: {
      type: Boolean,
      default: !1
    },
    maxSize: {
      type: [Number, String],
      default: null
    },
    name: {
      type: String,
      default: void 0
    },
    noResize: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: void 0
    },
    readonly: Boolean,
    required: Boolean,
    rows: {
      type: [Number, String],
      default: void 0
    },
    size: {
      type: String,
      default: "md"
    },
    wrap: {
      type: String,
      default: "soft"
    },
    modelValue: {
      type: [Number, String],
      default: ""
    },
    plaintext: {
      type: Boolean,
      default: !1
    },
    state: {
      type: Boolean,
      default: null
    },
    trim: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["input", "blur", "change", "update:modelValue"],
  setup(e, { expose: a, emit: t }) {
    const l = P(null), n = e, o = t, i = b(() => ({
      resize: n.noResize || n.maxSize ? "none" : null
    })), r = b(() => ({
      "is-valid": n.state === !0,
      "is-invalid": n.state === !1,
      "form-control-plaintext": n.plaintext,
      "form-control": n.type !== "range" && !n.plaintext,
      "form-control-lg": n.size === "lg" && n.type !== "range",
      "form-control-sm": n.size === "sm" && n.type !== "range"
    })), u = (m) => {
      let d = m.target.value;
      n.formatter && n.lazyFormatter && (d = n.formatter(d)), n.trim && (d = d.trim()), (n.lazy || n.lazyFormatter) && o("update:modelValue", d), o("blur", m);
    }, f = (m) => {
      let d = m.target.value;
      n.formatter && !n.lazyFormatter && (d = n.formatter(d)), n.trim && (d = d.trim()), (n.lazy || n.lazyFormatter) && o("update:modelValue", d), o("change", m);
    }, s = (m) => {
      let d = m.target.value;
      n.formatter && !n.lazyFormatter && !n.lazy && (d = n.formatter(d)), n.trim && (d = d.trim()), n.lazy || o("update:modelValue", d), o("input", m);
    };
    return a({ textarea: l }), (m, d) => (p(), T("textarea", {
      id: e.id,
      ref_key: "textarea",
      ref: l,
      "aria-invalid": e.state === !1 || e.ariaInvalid,
      autocomplete: e.autocomplete,
      autofocus: e.autofocus,
      disabled: e.disabled,
      form: e.form,
      name: e.name,
      placeholder: e.placeholder,
      readonly: e.readonly || e.plaintext,
      required: e.required,
      rows: e.rows,
      size: e.size,
      wrap: e.wrap,
      value: e.modelValue,
      style: He(i.value),
      class: $(r.value),
      onBlur: u,
      onInput: s,
      onChange: f
    }, null, 46, ri));
  }
}, ka = {
  install: (e) => {
    e.component("BFormTextarea", Ba);
  }
}, ui = ["id", "autofocus", "aria-label", "aria-labelledby", "disabled", "form", "name", "value", "true-value", "false-value"], di = ["for"], ci = ["id", "autofocus", "aria-label", "aria-labelledby", "disabled", "form", "name", "value", "true-value", "false-value"], fi = ["for"], nl = {
  __name: "FormCheckbox",
  props: {
    ariaLabel: {
      type: String,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number, Boolean, Object, Array],
      default: !0
    },
    form: {
      type: String,
      default: null
    },
    state: {
      type: Boolean,
      default: null
    },
    switch: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      default: void 0
    },
    plain: {
      type: Boolean,
      default: !1
    },
    inline: {
      type: Boolean,
      default: !1
    },
    button: {
      type: Boolean,
      default: !1
    },
    buttonVariant: {
      type: String,
      default: null
    },
    modelValue: {
      type: [String, Number, Boolean, Object, Array],
      default: void 0
    },
    uncheckedValue: {
      type: [String, Number, Boolean, Object, Array],
      default: !1
    },
    size: {
      type: String,
      default: void 0
    },
    required: {
      type: Boolean,
      default: void 0
    }
  },
  emits: ["update:modelValue", "change", "input"],
  setup(e, { expose: a, emit: t }) {
    const l = Xe("checkboxGroupState", null), n = P(null), o = t, i = e, r = b(() => i.button || (l == null ? void 0 : l.buttons)), u = b(() => i.plain || l != null && l.plain ? "form-check-label" : [
      "form-check-label",
      {
        "form-check-label-inline": i.inline || (l == null ? void 0 : l.inline)
      }
    ]), f = b(() => i.plain || l != null && l.plain ? "form-check-label" : [
      "btn",
      {
        "btn-secondary": !i.buttonVariant && !(l != null && l.buttonVariant.value),
        [`btn-${i.buttonVariant || (l == null ? void 0 : l.buttonVariant.value)}`]: i.buttonVariant || (l == null ? void 0 : l.buttonVariant.value),
        [`btn-${i.size || (l == null ? void 0 : l.size.value)}`]: i.size || (l == null ? void 0 : l.size.value)
      }
    ]), s = b(() => i.plain || l != null && l.plain ? "form-check-input" : {
      "is-valid": i.state === !0 || (l == null ? void 0 : l.state.value) === !0,
      "is-invalid": i.state === !1 || (l == null ? void 0 : l.state.value) === !1,
      "form-check-input": !i.button || !(l != null && l.buttons)
    }), m = b(() => ({
      "btn-check": i.button || (l == null ? void 0 : l.buttons)
    })), d = b(() => i.plain || l != null && l.plain ? [
      "form-check",
      {
        "form-check-inline": i.inline || (l == null ? void 0 : l.inline),
        "is-invalid": i.state === !1 || (l == null ? void 0 : l.state.value) === !1,
        "is-valid": i.state === !0 || (l == null ? void 0 : l.state.value) === !0
      }
    ] : [
      "form-check",
      {
        "form-switch": (i.switch || (l == null ? void 0 : l.switch)) && (!i.button || !(l != null && l.buttons)),
        "form-check-inline": i.inline || (l == null ? void 0 : l.inline),
        "btn-group": i.button || (l == null ? void 0 : l.buttons),
        [`btn-group-${i.buttonVariant || (l == null ? void 0 : l.buttonVariant.value)}`]: i.buttonVariant && i.button || (l == null ? void 0 : l.buttonVariant.value) && (l == null ? void 0 : l.buttons),
        [`form-control-${i.size || (l == null ? void 0 : l.size.value)}`]: i.size || (l == null ? void 0 : l.size.value),
        "is-invalid": i.state === !1 || (l == null ? void 0 : l.state.value) === !1,
        "is-valid": i.state === !0 || (l == null ? void 0 : l.state.value) === !0
      }
    ]), c = b({
      get: () => i.modelValue || (l == null ? void 0 : l.modelValue.value),
      set: (y) => {
        if (y !== void 0) {
          if (l !== null && Array.isArray(y)) {
            l.modelValue.value = y;
            return;
          }
          o("update:modelValue", y);
        }
      }
    }), v = () => {
      i.modelValue !== void 0 && (o("input", i.modelValue), o("update:modelValue", i.modelValue));
    }, k = () => {
      i.modelValue !== void 0 && o("change", i.modelValue);
    };
    return a({ input: n }), (y, h) => {
      var g, S, L, F, M, V;
      return r.value ? (p(), T(ee, { key: 1 }, [
        Be(N("input", {
          id: e.id,
          ref_key: "input",
          ref: n,
          "onUpdate:modelValue": h[1] || (h[1] = (j) => c.value = j),
          type: "checkbox",
          autofocus: e.autofocus,
          "aria-label": e.ariaLabel,
          "aria-labelledby": e.ariaLabelledby,
          disabled: e.disabled || ((F = x(l)) == null ? void 0 : F.disabled),
          form: e.form || ((M = x(l)) == null ? void 0 : M.form),
          name: e.name || ((V = x(l)) == null ? void 0 : V.name),
          value: e.value,
          "true-value": e.value,
          class: $(m.value),
          "false-value": e.uncheckedValue,
          onInput: v,
          onChange: k
        }, null, 42, ci), [
          [ul, c.value]
        ]),
        N("label", {
          class: $(f.value),
          for: e.id
        }, [
          C(y.$slots, "default")
        ], 10, fi)
      ], 64)) : (p(), T("div", {
        key: 0,
        class: $(d.value)
      }, [
        Be(N("input", {
          id: e.id,
          ref_key: "input",
          ref: n,
          "onUpdate:modelValue": h[0] || (h[0] = (j) => c.value = j),
          type: "checkbox",
          autofocus: e.autofocus,
          "aria-label": e.ariaLabel,
          "aria-labelledby": e.ariaLabelledby,
          disabled: e.disabled || ((g = x(l)) == null ? void 0 : g.disabled),
          form: e.form || ((S = x(l)) == null ? void 0 : S.form),
          name: e.name || ((L = x(l)) == null ? void 0 : L.name),
          value: e.value,
          "true-value": e.value,
          class: $(s.value),
          "false-value": e.uncheckedValue,
          onInput: v,
          onChange: k
        }, null, 42, ui), [
          [ul, c.value]
        ]),
        N("label", {
          class: $(u.value),
          for: e.id
        }, [
          C(y.$slots, "default")
        ], 10, di)
      ], 2));
    };
  }
}, vi = ["id", "aria-invalid", "autofocus", "form", "name", "required"], Ca = {
  __name: "FormCheckboxGroup",
  props: {
    ariaInvalid: {
      type: [Boolean, String],
      default: !1
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    buttonVariant: {
      type: String,
      default: "secondary"
    },
    buttons: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      type: [String, Number, Boolean, Object, Array],
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    disabledField: {
      type: String,
      default: "disabled"
    },
    form: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    options: {
      type: [Array, Object],
      default: () => []
    },
    plain: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: void 0
    },
    stacked: {
      type: Boolean,
      default: !1
    },
    state: {
      type: Boolean,
      default: null
    },
    switches: {
      type: Boolean,
      default: !1
    },
    textField: {
      type: String,
      default: "text"
    },
    validated: {
      type: Boolean,
      default: !1
    },
    valueField: {
      type: String,
      default: "value"
    }
  },
  emits: ["change", "update:modelValue", "input"],
  setup(e, { emit: a }) {
    const t = e, l = a, n = (d) => {
      l("change", d);
    }, o = (d) => {
      l("update:modelValue", d);
    }, i = b({
      get: () => t.modelValue,
      set: (d) => {
        l("input", d), l("update:modelValue", d), pe(() => {
          l("change", d);
        });
      }
    });
    vt("checkboxGroupState", {
      modelValue: i,
      buttonVariant: K(() => t.buttonVariant),
      disabled: t.disabled,
      form: t.form,
      name: t.name,
      buttons: t.buttons,
      switch: t.switches,
      state: K(() => t.state),
      plain: t.plain,
      size: K(() => t.size),
      inline: !t.stacked,
      required: t.required
    });
    const r = b(() => ({
      "btn-group": t.buttons && !t.stacked,
      "btn-group-vertical": t.buttons && t.stacked,
      "form-checkbox": !t.buttons,
      "form-checkbox-plain": t.plain,
      "form-checkbox-stacked": t.stacked && !t.buttons,
      "was-validate": t.validated,
      [`btn-${t.buttonVariant}`]: t.buttonVariant && t.buttons,
      [`form-checkbox-${t.size}`]: t.size,
      "is-valid": t.state === !0,
      "is-invalid": t.state === !1
    })), u = b(() => t.ariaInvalid === !1 || t.ariaInvalid === "false" || t.ariaInvalid === "0" ? !1 : t.ariaInvalid === !0 || t.ariaInvalid === "true" || t.ariaInvalid === "1" ? !0 : t.state === !0 ? !1 : t.state === !1 ? !0 : null), f = (d) => d[t.valueField], s = (d) => d[t.textField], m = (d) => d[t.disabledField];
    return (d, c) => (p(), T("div", {
      id: e.id,
      class: $(r.value),
      "aria-invalid": u.value,
      autofocus: e.autofocus,
      form: e.form,
      name: e.name,
      required: e.required,
      role: "checkboxgroup",
      tabindex: "-1"
    }, [
      C(d.$slots, "first"),
      e.options.length ? (p(!0), T(ee, { key: 0 }, se(e.options, (v, k) => (p(), I(nl, {
        id: `${e.id}_${k}`,
        key: k,
        modelValue: i.value,
        "onUpdate:modelValue": [
          c[0] || (c[0] = (y) => i.value = y),
          o
        ],
        value: f(v),
        disabled: m(v),
        name: e.name,
        required: e.required,
        onChange: n
      }, {
        default: E(() => [
          q(D(s(v)), 1)
        ]),
        _: 2
      }, 1032, ["id", "modelValue", "value", "disabled", "name", "required"]))), 128)) : R("", !0),
      C(d.$slots, "default")
    ], 10, vi));
  }
}, wa = {
  install: (e) => {
    e.component("BFormCheckbox", nl), e.component("BFormCheckboxGroup", Ca);
  }
}, mi = ["id", "autofocus", "aria-label", "aria-labelledby", "autocomplete", "disabled", "checked", "form", "name", "value"], gi = ["for"], pi = ["id", "autofocus", "aria-label", "aria-labelledby", "autocomplete", "disabled", "checked", "form", "name", "value"], bi = ["for"], ol = {
  __name: "FormRadio",
  props: {
    ariaLabel: {
      type: String,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    checked: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number, Boolean, Object, Array],
      default: null
    },
    form: {
      type: String,
      default: null
    },
    state: {
      type: Boolean,
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      default: null
    },
    plain: {
      type: Boolean,
      default: !1
    },
    inline: {
      type: Boolean,
      default: !1
    },
    button: {
      type: Boolean,
      default: !1
    },
    buttonVariant: {
      type: String,
      default: null
    },
    modelValue: {
      type: [String, Number, Boolean, Object, Array],
      default: null
    },
    size: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "change", "input"],
  setup(e, { expose: a, emit: t }) {
    const l = Xe("radioGroupState", null), n = t, o = P(null), i = e, r = b(() => i.button || (l == null ? void 0 : l.buttons)), u = b(() => i.plain || l != null && l.plain ? "form-check-label" : [
      "form-check-label",
      {
        "form-check-label-inline": i.inline || (l == null ? void 0 : l.inline)
      }
    ]), f = b(() => i.plain || l != null && l.plain ? "form-check-label" : [
      "btn",
      {
        "btn-secondary": !i.buttonVariant && !(l != null && l.buttonVariant.value),
        [`btn-${i.buttonVariant || (l == null ? void 0 : l.buttonVariant.value)}`]: i.buttonVariant || (l == null ? void 0 : l.buttonVariant.value),
        [`btn-${i.size || (l == null ? void 0 : l.size.value)}`]: i.size || (l == null ? void 0 : l.size.value)
      }
    ]), s = b(() => i.plain || l != null && l.plain ? "form-check-input" : {
      "is-valid": i.state === !0 || (l == null ? void 0 : l.state.value) === !0,
      "is-invalid": i.state === !1 || (l == null ? void 0 : l.state.value) === !1,
      "form-check-input": !i.button || !(l != null && l.buttons)
    }), m = b(() => ({
      "btn-check": i.button || (l == null ? void 0 : l.buttons)
    })), d = b(() => i.plain || l != null && l.plain ? [
      "form-check",
      {
        "form-check-inline": i.inline || (l == null ? void 0 : l.inline),
        "is-invalid": i.state === !1 || (l == null ? void 0 : l.state.value) === !1,
        "is-valid": i.state === !0 || (l == null ? void 0 : l.state.value) === !0
      }
    ] : [
      "form-check",
      {
        "form-check-inline": i.inline || (l == null ? void 0 : l.inline),
        "btn-group": i.button || (l == null ? void 0 : l.buttons),
        [`btn-group-${i.buttonVariant || (l == null ? void 0 : l.buttonVariant.value)}`]: i.buttonVariant && i.button || (l == null ? void 0 : l.buttonVariant.value) && (l == null ? void 0 : l.buttons),
        [`form-control-${i.size || (l == null ? void 0 : l.size.value)}`]: i.size || (l == null ? void 0 : l.size.value),
        "is-invalid": i.state === !1 || (l == null ? void 0 : l.state.value) === !1,
        "is-valid": i.state === !0 || (l == null ? void 0 : l.state.value) === !0
      }
    ]), c = b(() => i.value === null ? null : typeof i.value == "object" ? i.value.value : i.value), v = b({
      get: () => l !== null ? JSON.stringify(l.modelValue.value) === JSON.stringify(i.value) : JSON.stringify(i.modelValue) === JSON.stringify(i.value),
      set: (h) => {
        const g = h || h === "" || h === 0 || JSON.stringify(h) === JSON.stringify(i.value) ? i.value : !1;
        n("input", g), n("update:modelValue", g), pe(() => {
          n("change", g);
        }), l !== null && l.set(i.value);
      }
    }), k = () => {
      n("input", c.value), n("update:modelValue", c.value);
    }, y = () => {
      n("change", c.value);
    };
    return a({ input: o }), (h, g) => {
      var S, L, F, M, V, j;
      return r.value ? (p(), T(ee, { key: 1 }, [
        Be(N("input", {
          id: e.id,
          ref_key: "input",
          ref: o,
          "onUpdate:modelValue": g[1] || (g[1] = (W) => v.value = W),
          type: "radio",
          autofocus: e.autofocus,
          "aria-label": e.ariaLabel,
          "aria-labelledby": e.ariaLabelledby,
          autocomplete: e.autocomplete,
          disabled: e.disabled || ((M = x(l)) == null ? void 0 : M.disabled),
          checked: v.value,
          form: e.form || ((V = x(l)) == null ? void 0 : V.form),
          name: e.name || ((j = x(l)) == null ? void 0 : j.name),
          value: c.value,
          class: $(m.value),
          onInput: k,
          onChange: y
        }, null, 42, pi), [
          [dl, v.value]
        ]),
        N("label", {
          class: $(f.value),
          for: e.id
        }, [
          C(h.$slots, "default")
        ], 10, bi)
      ], 64)) : (p(), T("div", {
        key: 0,
        class: $(d.value)
      }, [
        Be(N("input", {
          id: e.id,
          ref_key: "input",
          ref: o,
          "onUpdate:modelValue": g[0] || (g[0] = (W) => v.value = W),
          type: "radio",
          autofocus: e.autofocus,
          "aria-label": e.ariaLabel,
          "aria-labelledby": e.ariaLabelledby,
          autocomplete: e.autocomplete,
          disabled: e.disabled || ((S = x(l)) == null ? void 0 : S.disabled),
          checked: v.value,
          form: e.form || ((L = x(l)) == null ? void 0 : L.form),
          name: e.name || ((F = x(l)) == null ? void 0 : F.name),
          value: c.value,
          class: $(s.value),
          onInput: k,
          onChange: y
        }, null, 42, mi), [
          [dl, v.value]
        ]),
        N("label", {
          class: $(u.value),
          for: e.id
        }, [
          C(h.$slots, "default")
        ], 10, gi)
      ], 2));
    };
  }
}, yi = ["id", "aria-invalid", "autofocus", "form", "name", "required"], Sa = {
  __name: "FormRadioGroup",
  props: {
    ariaInvalid: {
      type: [Boolean, String],
      default: null
    },
    autofocus: {
      type: Boolean,
      default: null
    },
    buttonVariant: {
      type: String,
      default: null
    },
    buttons: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      type: [String, Number, Boolean, Object, Array],
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    disabledField: {
      type: String,
      default: "disabled"
    },
    form: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    options: {
      type: [Array, Object],
      default: () => []
    },
    plain: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: void 0
    },
    stacked: {
      type: Boolean,
      default: !1
    },
    state: {
      type: Boolean,
      default: null
    },
    textField: {
      type: String,
      default: "text"
    },
    validated: {
      type: Boolean,
      default: !1
    },
    valueField: {
      type: String,
      default: "value"
    }
  },
  emits: ["change", "update:modelValue", "input"],
  setup(e, { emit: a }) {
    const t = e, l = a, n = (m) => {
      l("change", m);
    }, o = (m) => {
      l("update:modelValue", m);
    }, i = b({
      get: () => t.modelValue,
      set: (m) => {
        l("input", m), l("update:modelValue", m), pe(() => {
          l("change", m);
        });
      }
    });
    vt("radioGroupState", {
      set: (m) => {
        l("input", m), l("update:modelValue", m), pe(() => {
          l("change", m);
        });
      },
      modelValue: ot(i),
      buttonVariant: K(() => t.buttonVariant),
      disabled: t.disabled,
      form: t.form,
      name: t.name,
      buttons: t.buttons,
      state: K(() => t.state),
      plain: t.plain,
      size: K(() => t.size),
      inline: !t.stacked,
      required: t.required
    });
    const r = b(() => ({
      "btn-group": t.buttons && !t.stacked,
      "btn-group-vertical": t.buttons && t.stacked,
      "form-radio": !t.buttons,
      "form-radio-plain": t.plain,
      "form-radio-stacked": t.stacked && !t.buttons,
      "was-validate": t.validated,
      [`btn-${t.buttonVariant}`]: t.buttonVariant && t.buttons,
      [`form-radio-${t.size}`]: t.size,
      "is-valid": t.state === !0,
      "is-invalid": t.state === !1
    })), u = (m) => m[t.valueField] === void 0 ? m : m === null || m[t.valueField] === null ? "" : m[t.valueField], f = (m) => m[t.textField] === void 0 ? m : m[t.textField], s = (m) => m[t.disabledField] === void 0 ? !1 : m[t.disabledField];
    return (m, d) => (p(), T("div", {
      id: e.id,
      class: $(r.value),
      "aria-invalid": e.state === !1 || e.ariaInvalid,
      autofocus: e.autofocus,
      form: e.form,
      name: e.name,
      required: e.required,
      role: "radiogroup",
      tabindex: "-1"
    }, [
      C(m.$slots, "first"),
      e.options.length ? (p(!0), T(ee, { key: 0 }, se(e.options, (c, v) => (p(), I(ol, {
        id: `${e.id}_${v}`,
        key: v,
        value: u(c),
        disabled: s(c),
        name: e.name,
        required: e.required,
        checked: u(c) === i.value,
        onChange: n,
        "onUpdate:modelValue": o
      }, {
        default: E(() => [
          q(D(f(c)), 1)
        ]),
        _: 2
      }, 1032, ["id", "value", "disabled", "name", "required", "checked"]))), 128)) : R("", !0),
      C(m.$slots, "default")
    ], 10, yi));
  }
}, $a = {
  install: (e) => {
    e.component("BFormRadio", ol), e.component("BFormRadioGroup", Sa);
  }
}, hi = ["disabled", "value"], St = {
  __name: "FormSelectOption",
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    value: {
      type: null,
      default: null
    }
  },
  setup(e) {
    const a = e, t = b(() => a.value === "" ? null : a.value);
    return (l, n) => (p(), T("option", {
      disabled: e.disabled,
      value: t.value
    }, [
      C(l.$slots, "default")
    ], 8, hi));
  }
}, Bi = ["label"], il = {
  __name: "FormSelectOptionGroup",
  props: {
    disabledField: {
      type: String,
      default: "disabled"
    },
    label: {
      type: String,
      required: !0
    },
    options: {
      type: [Array, Object],
      default: () => []
    },
    textField: {
      type: String,
      default: "text"
    },
    valueField: {
      type: String,
      default: "value"
    }
  },
  setup(e) {
    const a = e, t = (i) => i[a.valueField], l = (i) => i[a.valueField], n = (i) => i[a.textField], o = (i) => i[a.disabledField];
    return (i, r) => (p(), T("optgroup", { label: e.label }, [
      C(i.$slots, "first"),
      C(i.$slots, "default"),
      !i.$slots.default && e.options.length ? (p(!0), T(ee, { key: 0 }, se(e.options, (u) => (p(), I(St, {
        key: t(u),
        value: l(u),
        disabled: o(u)
      }, {
        default: E(() => [
          q(D(n(u)), 1)
        ]),
        _: 2
      }, 1032, ["value", "disabled"]))), 128)) : R("", !0)
    ], 8, Bi));
  }
}, ki = ["id", "name", "form", "aria-invalid", "autofocus", "disabled", "required", "size", "multiple"], xa = {
  __name: "FormSelect",
  props: /* @__PURE__ */ Ne({
    id: {
      type: String,
      default: void 0
    },
    name: {
      type: String,
      default: void 0
    },
    form: {
      type: String,
      default: void 0
    },
    ariaInvalid: {
      type: [Boolean, String],
      default: void 0
    },
    autofocus: Boolean,
    disabled: Boolean,
    required: Boolean,
    plain: Boolean,
    multiple: Boolean,
    state: {
      type: Boolean,
      default: null
    },
    size: {
      type: String,
      default: void 0
    },
    selectSize: {
      type: Number,
      default: 0
    },
    options: {
      type: [Array, Object],
      default: void 0
    },
    optionsField: {
      type: String,
      default: "options"
    },
    valueField: {
      type: String,
      default: "value"
    },
    labelField: {
      type: String,
      default: "label"
    },
    textField: {
      type: String,
      default: "text"
    },
    disabledField: {
      type: String,
      default: "disabled"
    }
  }, {
    modelValue: {
      default: null,
      type: [String, Number, Array, Object, Boolean]
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ne(["change", "input"], ["update:modelValue"]),
  setup(e, { emit: a }) {
    const t = e, l = a, n = Nt(e, "modelValue"), o = (v) => v[t.valueField], i = (v) => v[t.valueField] === void 0 && v.options === void 0 ? v : v === null || v[t.valueField] === null ? "" : v[t.valueField], r = (v) => v[t.textField] === void 0 && v.options === void 0 ? v : v[t.textField], u = (v) => v[t.disabledField] === void 0 ? !1 : v[t.disabledField], f = (v) => v[t.labelField] === void 0 ? v.label : v[t.labelField], s = (v) => v[t.optionsField], m = (v) => {
      l("change", v.target.value);
    }, d = (v) => {
      l("input", v.target.value);
    }, c = b(() => ({
      "form-select": !t.plain,
      "form-control": t.plain,
      "is-invalid": t.state === !1,
      "is-valid": t.state === !0,
      "form-select-sm": t.size === "sm",
      "form-select-lg": t.size === "lg"
    }));
    return (v, k) => Be((p(), T("select", {
      id: e.id,
      "onUpdate:modelValue": k[0] || (k[0] = (y) => n.value = y),
      name: e.name,
      form: e.form,
      "aria-invalid": e.ariaInvalid,
      autofocus: e.autofocus,
      disabled: e.disabled,
      required: e.required,
      class: $(c.value),
      size: e.selectSize || null,
      multiple: e.multiple || null,
      onChange: m,
      onInput: d
    }, [
      C(v.$slots, "first"),
      (p(!0), T(ee, null, se(e.options, (y) => (p(), T(ee, {
        key: o(y)
      }, [
        r(y) ? (p(), I(St, {
          key: 0,
          value: i(y),
          disabled: u(y)
        }, {
          default: E(() => [
            q(D(r(y)), 1)
          ]),
          _: 2
        }, 1032, ["value", "disabled"])) : R("", !0),
        y.options ? (p(), T(ee, { key: 1 }, [
          s(y).length ? (p(), I(il, {
            key: 0,
            label: f(y),
            options: s(y),
            "value-field": e.valueField,
            "text-field": e.textField,
            "disabled-field": e.disabledField
          }, null, 8, ["label", "options", "value-field", "text-field", "disabled-field"])) : R("", !0)
        ], 64)) : R("", !0)
      ], 64))), 128)),
      C(v.$slots, "default")
    ], 42, ki)), [
      [rn, n.value]
    ]);
  }
}, Va = {
  install: (e) => {
    e.component("BFormSelect", xa), e.component("BFormSelectOption", St), e.component("BFormSelectOptionGroup", il);
  }
}, Ci = ["for"], wi = ["id", "form", "name", "multiple", "disabled", "capture", "accept", "required", "aria-required", "directory", "webkitdirectory"], Si = ["for", "data-browse"], $i = {
  key: 0,
  class: "d-block custom-file-text"
}, xi = {
  key: 1,
  class: "d-block custom-file-text"
}, Vi = ["for"], Ti = ["id", "form", "name", "multiple", "disabled", "capture", "accept", "required", "aria-required", "directory", "webkitdirectory"], Ta = /* @__PURE__ */ Object.assign({
  inheritAttrs: !1
}, {
  __name: "FormFile",
  props: {
    accept: {
      type: String,
      default: ""
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    browseText: {
      type: String,
      default: "Browse"
    },
    capture: {
      type: Boolean,
      default: void 0
    },
    directory: {
      type: Boolean,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    dropPlaceholder: {
      type: String,
      default: "Drop files here"
    },
    fileNameFormatter: {
      type: Function,
      default: void 0
    },
    form: {
      type: String,
      default: void 0
    },
    id: {
      type: String,
      default: void 0
    },
    label: {
      type: String,
      default: ""
    },
    labelClass: {
      type: [String, Array, Object],
      default: void 0
    },
    modelValue: {
      type: [File, Array],
      default: null
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      default: void 0
    },
    noDrop: {
      type: Boolean,
      default: !1
    },
    noDropPlaceholder: {
      type: String,
      default: "No file drop allowed"
    },
    noTraverse: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: "No file chosen"
    },
    plain: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: void 0
    },
    state: {
      type: Boolean,
      default: null
    }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { expose: a, emit: t }) {
    const l = P(!1), n = Fe(), o = e, i = t, r = ze(o, "modelValue", i), u = b(
      () => o.id || `input-file-${Math.random().toString(36).substring(2, 11)}`
    ), f = P(null), s = P(null), { focused: m } = We(f, { initialValue: o.autofocus }), d = b(
      () => typeof o.accept == "string" ? o.accept : o.accept.join(",")
    ), c = b(() => [
      {
        "is-valid": o.state === !0,
        "is-invalid": o.state === !1,
        [`form-control-${o.size}`]: o.size !== void 0
      }
    ]), v = (F) => {
      o.plain || y(), k(), i("change", F);
    }, k = () => {
      var M, V;
      const F = ((M = f.value) == null ? void 0 : M.files) === null || ((V = f.value) == null ? void 0 : V.files) === void 0 ? null : [...f.value.files];
      r.value = F === null ? null : o.multiple === !0 ? F : F[0];
    }, y = () => {
      var M, V;
      const F = ((M = f.value) == null ? void 0 : M.files) === null || ((V = f.value) == null ? void 0 : V.files) === void 0 ? null : [...f.value.files];
      s.value = F === null || F.length === 0 ? null : o.multiple === !0 ? `${F.length} ${F.length === 1 ? "file" : "files"}` : F[0].name;
    }, h = (F) => {
      o.noDrop === !0 && F.preventDefault(), l.value = !1;
    }, g = (F) => {
      o.noDrop === !0 && F.preventDefault(), l.value = !0;
    }, S = (F) => {
      o.noDrop === !0 && F.preventDefault(), l.value = !1;
    }, L = () => {
      f.value.value = null;
    };
    return G(r, (F) => {
      F === null && f.value !== null && (f.value = null, s.value = null), F !== null && o.fileNameFormatter !== void 0 && o.fileNameFormatter(F);
    }), a({
      blur: () => {
        m.value = !1;
      },
      element: f,
      focus: () => {
        m.value = !0;
      },
      reset: L
    }), (F, M) => e.plain ? (p(), T(ee, { key: 1 }, [
      x(n).label || e.label ? (p(), T("label", {
        key: 0,
        for: u.value,
        class: $(["form-label", e.labelClass])
      }, [
        C(F.$slots, "label", {}, () => [
          q(D(e.label), 1)
        ])
      ], 10, Vi)) : R("", !0),
      N("input", ae({ id: u.value }, F.$attrs, {
        ref_key: "input",
        ref: f,
        type: "file",
        class: ["form-control", c.value],
        form: e.form,
        name: e.name,
        multiple: e.multiple,
        disabled: e.disabled,
        capture: o.capture,
        accept: d.value || void 0,
        required: e.required || void 0,
        "aria-required": e.required || void 0,
        directory: e.directory,
        webkitdirectory: e.directory,
        onChange: v,
        onDrop: h
      }), null, 16, Ti)
    ], 64)) : (p(), T(ee, { key: 0 }, [
      x(n).label || e.label ? (p(), T("label", {
        key: 0,
        for: u.value,
        class: $(["form-label", e.labelClass])
      }, [
        C(F.$slots, "label", {}, () => [
          q(D(e.label), 1)
        ])
      ], 10, Ci)) : R("", !0),
      N("div", {
        class: "custom-file",
        onDragover: g,
        onDragleave: S
      }, [
        N("input", ae({ id: u.value }, F.$attrs, {
          ref_key: "input",
          ref: f,
          type: "file",
          class: ["form-control custom-file-input", c.value],
          form: e.form,
          name: e.name,
          multiple: e.multiple,
          disabled: e.disabled,
          capture: o.capture,
          accept: d.value || void 0,
          required: e.required || void 0,
          "aria-required": e.required || void 0,
          directory: e.directory,
          webkitdirectory: e.directory,
          onChange: v,
          onDrop: h,
          onDragleave: S
        }), null, 16, wi),
        N("label", {
          for: u.value,
          class: "custom-file-label",
          "data-browse": e.browseText
        }, [
          l.value ? (p(), T("span", $i, D(e.noDrop ? e.noDropPlaceholder : e.dropPlaceholder), 1)) : (p(), T("span", xi, D(s.value === null ? e.placeholder : s.value), 1))
        ], 8, Si)
      ], 32)
    ], 64));
  }
}), Fa = {
  install: (e) => {
    e.component("BFormFile", Ta);
  }
}, Fi = {
  install: (e) => {
    e.use(va), e.use(ga), e.use(ba), e.use(ha), e.use(ka), e.use(wa), e.use($a), e.use(Va), e.use(Fa);
  }
}, Ai = {
  install: (e) => {
    e.component("BImg", Kt), e.component("BImgLazy", tl);
  }
}, Oi = {
  install: (e) => {
    e.component("BLink", gt);
  }
}, Tt = "modal-open", Ii = () => {
  const e = Xe(Ml), a = (l) => {
    e == null || e.removeStack(l), e == null || e.removeRegistry(l), e != null && e.countStack.value || t("body", "class", "");
  }, t = Gn(
    "updateHTMLAttrs",
    (l, n, o) => {
      const i = typeof l == "string" ? window == null ? void 0 : window.document.querySelector(l) : ue(l);
      i && (n === "class" ? i.classList.toggle(Tt, o === Tt) : i.setAttribute(n, o));
    }
  );
  return Oe(() => {
    e != null && e.countStack.value || t("body", "class", "");
  }), G(
    () => e == null ? void 0 : e.countStack.value,
    (l) => {
      l !== void 0 && t("body", "class", l > 0 ? Tt : "");
    }
  ), {
    ...e,
    dispose: a
  };
}, Pi = (e, a) => {
  const { pushRegistry: t, pushStack: l, removeStack: n, stack: o, dispose: i, countStack: r } = Ii(), u = je();
  if (!u || u.type.__name !== "Modal")
    throw new Error("useModalManager can only be used in a Modal component");
  t == null || t(u), Oe(() => {
    i(u);
  });
  const f = (d, c) => {
    d ? l == null || l(u) : c && !d && (n == null || n(u));
  };
  f(a, a), G(e, f);
  const s = b(() => o == null ? void 0 : o.value.findIndex(
    (d) => {
      var c, v;
      return ((c = d.exposed) == null ? void 0 : c.id) === ((v = u.exposed) == null ? void 0 : v.id);
    }
  )), m = b(
    () => (o == null ? void 0 : o.value.filter(
      (d) => {
        var c, v;
        return ((c = d.exposed) == null ? void 0 : c.id) !== ((v = u.exposed) == null ? void 0 : v.id);
      }
    )) ?? []
  );
  return {
    activePosition: s,
    activeModalCount: r,
    stackWithoutSelf: m
  };
}, Li = (e, a) => {
  const t = ot(K(e)), l = ot(K(a)), n = K(() => !l.value);
  Te(() => {
    const o = Jn(
      document.body,
      t.value && n.value
    );
    G(
      o,
      (i) => {
        console.log(i);
      },
      { immediate: !0 }
    ), G(
      [t, n],
      ([i, r]) => {
        o.value = i && r;
      }
    );
  });
}, Ei = ["id", "aria-labelledby"], Ni = ["disabled", "aria-label"], zi = /* @__PURE__ */ Z({
  inheritAttrs: !1,
  __name: "Modal",
  props: /* @__PURE__ */ Ne({
    id: {
      type: String,
      default: void 0
    },
    title: {
      type: String,
      default: void 0
    },
    busy: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "md"
    },
    centered: {
      type: Boolean,
      default: !1
    },
    dialogClass: {
      type: [String, Array, Object],
      default: null
    },
    contentClass: {
      type: [String, Array, Object],
      default: null
    },
    okTitle: {
      type: String,
      default: "OK"
    },
    okVariant: {
      type: String,
      default: "primary"
    },
    okDisabled: {
      type: Boolean,
      default: !1
    },
    okOnly: {
      type: Boolean,
      default: !1
    },
    cancelTitle: {
      type: String,
      default: "Cancel"
    },
    cancelVariant: {
      type: String,
      default: "secondary"
    },
    cancelDisabled: {
      type: Boolean,
      default: !1
    },
    hideFooter: {
      type: Boolean,
      default: !1
    },
    hideHeader: {
      type: Boolean,
      default: !1
    },
    static: {
      type: Boolean,
      default: !1
    },
    scrollable: {
      type: Boolean,
      default: !1
    },
    titleTag: {
      type: String,
      default: "h5"
    },
    hideBackdrop: {
      type: Boolean,
      default: !1
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: !1
    },
    noCloseOnEsc: {
      type: Boolean,
      default: !1
    },
    autoFocus: {
      type: Boolean,
      default: !0
    },
    autoFocusButton: {
      type: String,
      default: void 0,
      validator: (e) => ["ok", "cancel", "close"].includes(e)
    },
    modalClass: {
      type: [String, Array, Object],
      default: null
    },
    // body
    bodyClass: {
      type: [String, Array, Object],
      default: null
    },
    bodyBgVariant: {
      type: String,
      default: void 0
    },
    bodyTextVariant: {
      type: String,
      default: void 0
    },
    // header
    headerTag: {
      type: String,
      default: "header"
    },
    headerClass: {
      type: [String, Array, Object],
      default: null
    },
    headerBgVariant: {
      type: String,
      default: void 0
    },
    headerBorderVariant: {
      type: String,
      default: void 0
    },
    headerTextVariant: {
      type: String,
      default: void 0
    },
    headerCloseLabel: {
      type: String,
      default: "Close"
    },
    headerCloseVariant: {
      type: String,
      default: void 0
    },
    hideHeaderClose: {
      type: Boolean,
      default: !1
    },
    // footer
    footerTag: {
      type: String,
      default: "footer"
    },
    footerClass: {
      type: [String, Array, Object],
      default: null
    },
    footerTextVariant: {
      type: String,
      default: "body-secondary"
    },
    footerBgVariant: {
      type: String,
      default: void 0
    },
    footerBorderVariant: {
      type: String,
      default: void 0
    },
    buttonSize: {
      type: String,
      default: "md"
    },
    lazy: {
      type: Boolean,
      default: !1
    },
    bodyScrolling: {
      type: Boolean,
      default: !1
    }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ne([
    "ok",
    "cancel",
    "close",
    "hide",
    "hidden",
    "show",
    "shown",
    "show-prevented",
    "hide-prevented"
  ], ["update:modelValue"]),
  setup(e, { expose: a, emit: t }) {
    const l = P(null), n = P(null), o = P(null), i = P(null), r = P(!1), u = P(!1), f = t, s = e, m = Nt(e, "modelValue"), d = it({
      cancel: () => U("cancel"),
      close: () => U("close"),
      hide: U,
      ok: () => U("ok"),
      visible: m.value
    }), c = b(() => s.title && s.titleTag ? s.titleTag : s.title && !s.titleTag ? "h5" : null), v = b(() => [
      s == null ? void 0 : s.modalClass,
      {
        show: r.value
      }
    ]), k = b(() => [s == null ? void 0 : s.contentClass]), y = b(() => {
      const X = s == null ? void 0 : s.scrollable, _ = s == null ? void 0 : s.centered, me = s == null ? void 0 : s.size;
      return [
        s == null ? void 0 : s.dialogClass,
        `modal-${me}`,
        X && "modal-dialog-scrollable",
        _ && "modal-dialog-centered"
      ];
    }), h = b(() => {
      const X = s == null ? void 0 : s.bodyBgVariant, _ = s == null ? void 0 : s.bodyClass, me = s == null ? void 0 : s.bodyTextVariant;
      return [
        X && `bg-${X}`,
        me && `text-${me}`,
        _
      ];
    }), g = b(() => {
      const X = s == null ? void 0 : s.headerBgVariant, _ = s == null ? void 0 : s.headerBorderVariant, me = s == null ? void 0 : s.headerTextVariant, qe = s == null ? void 0 : s.headerClass;
      return [
        X && `bg-${X}`,
        _ && `border-${_}`,
        me && `text-${me}`,
        qe
      ];
    }), S = b(() => {
      const X = s == null ? void 0 : s.footerBgVariant, _ = s == null ? void 0 : s.footerBorderVariant, me = s == null ? void 0 : s.footerClass, qe = s == null ? void 0 : s.footerTextVariant;
      return [
        X && `bg-${X}`,
        _ && `border-${_}`,
        qe && `text-${qe}`,
        me
      ];
    }), L = Ot(s.id, "modal"), F = b(() => s.id ? `${s.id}-title` : null), M = b(() => s.id ? `${s.id}-cancel` : null), V = b(() => s.id ? `${s.id}-ok` : null), { activePosition: j, activeModalCount: W } = Pi(
      r,
      m.value
    ), te = Un("--bs-modal-zindex", l, {
      initialValue: "1055"
    }), ne = b(() => ({
      "z-index": r.value || u.value ? Number(te.value) - (((W == null ? void 0 : W.value) ?? 0) - ((j == null ? void 0 : j.value) ?? 0)) : Number(te.value)
    }));
    function Q(X, _ = {}) {
      return new CustomEvent(X, {
        cancelable: !1,
        ..._
      });
    }
    function oe() {
      s.noCloseOnBackdrop || s.busy || U("backdrop");
    }
    function O() {
      s.noCloseOnEsc || s.busy || U("esc");
    }
    function B() {
      s.hideFooter || U("ok");
    }
    function w() {
      s.hideFooter || U("cancel");
    }
    function z() {
      U("close");
    }
    G(m, (X, _) => {
      X !== _ && (X === !0 ? A() : U());
    });
    function A(X = "") {
      const _ = Q("show", {
        cancelable: !0,
        detail: {
          trigger: X,
          target: l.value,
          componentId: s.id || null
        }
      });
      if (f("show", _), _.defaultPrevented) {
        m.value = !1, f("show-prevented");
        return;
      }
      m.value = !0;
    }
    function U(X = "") {
      const _ = Q("hide", {
        cancelable: !0,
        detail: {
          trigger: X,
          target: l.value,
          componentId: s.id || null
        }
      });
      if (X === "ok" || X === "cancel" ? f(X, _) : ["close", "backdrop", "esc"].includes(X) && f("close", _), f("hide", _), _.defaultPrevented) {
        f("hide-prevented"), m.value || (m.value = !0);
        return;
      }
      m.value && (m.value = !1);
    }
    function le() {
      A();
    }
    function Qe() {
      r.value = !0, Za(), f("shown", Q("shown"));
    }
    function $t() {
      r.value = !1, u.value = !0;
    }
    function Ja() {
      f("hidden", Q("hidden")), u.value = !1;
    }
    function Za() {
      s.autoFocus !== !1 && (s.autoFocusButton === "ok" ? _a.value = !0 : s.autoFocusButton === "close" ? tn.value = !0 : s.autoFocusButton === "cancel" ? en.value = !0 : Qa.value = !0);
    }
    Dn(
      "Escape",
      () => {
        O();
      },
      { target: l }
    ), Li(m, () => s.bodyScrolling);
    const { focused: Qa } = We(l, {
      initialValue: m.value && s.autoFocusButton === void 0
    }), { focused: _a } = We(n, {
      initialValue: m.value && s.autoFocusButton === "ok"
    }), { focused: en } = We(o, {
      initialValue: m.value && s.autoFocusButton === "cancel"
    }), { focused: tn } = We(i, {
      initialValue: m.value && s.autoFocusButton === "close"
    });
    return a({ show: A, hide: U, id: L.value }), (X, _) => (p(), I(mt, {
      to: "body",
      disabled: s.static
    }, [
      fe(Et, {
        appear: m.value,
        onBeforeEnter: le,
        onAfterEnter: Qe,
        onLeave: $t,
        onAfterLeave: Ja
      }, {
        default: E(() => [
          m.value || s.static && !s.lazy ? Be((p(), T("div", {
            key: 0,
            id: x(L),
            ref_key: "modal",
            ref: l,
            class: $(["modal fade", v.value]),
            tabindex: "-1",
            "aria-labelledby": e.title,
            role: "dialog",
            style: He(ne.value)
          }, [
            N("div", {
              class: $(["modal-dialog", y.value])
            }, [
              N("div", {
                class: $(["modal-content", k.value])
              }, [
                e.hideHeader ? R("", !0) : (p(), I(J(e.headerTag), {
                  key: 0,
                  class: $(["modal-header", g.value])
                }, {
                  default: E(() => [
                    C(X.$slots, "modal-header", we(Pe(d)), () => [
                      C(X.$slots, "modal-title", we(Pe(d)), () => [
                        e.title ? (p(), I(J(c.value), {
                          key: 0,
                          id: F.value
                        }, {
                          default: E(() => [
                            q(D(e.title), 1)
                          ]),
                          _: 1
                        }, 8, ["id"])) : R("", !0)
                      ], !0),
                      e.hideHeaderClose ? R("", !0) : (p(), T("button", {
                        key: 0,
                        ref_key: "closeButton",
                        ref: i,
                        disabled: e.busy,
                        type: "button",
                        class: $(["btn-close", e.headerCloseVariant]),
                        "aria-label": e.headerCloseLabel,
                        onClick: z
                      }, null, 10, Ni))
                    ], !0)
                  ]),
                  _: 3
                }, 8, ["class"])),
                N("div", {
                  class: $(["modal-body", h.value])
                }, [
                  C(X.$slots, "default", we(Pe(d)), void 0, !0)
                ], 2),
                e.hideFooter ? R("", !0) : (p(), I(J(e.footerTag), {
                  key: 1,
                  class: $(["modal-footer", S.value])
                }, {
                  default: E(() => [
                    C(X.$slots, "modal-footer", we(Pe(d)), () => [
                      C(X.$slots, "cancel", we(Pe(d)), () => [
                        e.okOnly ? R("", !0) : (p(), I(st, {
                          key: 0,
                          id: M.value,
                          ref_key: "cancelButton",
                          ref: o,
                          size: e.buttonSize,
                          variant: e.cancelVariant,
                          disabled: e.cancelDisabled || e.busy,
                          onClick: w
                        }, {
                          default: E(() => [
                            q(D(e.cancelTitle), 1)
                          ]),
                          _: 1
                        }, 8, ["id", "size", "variant", "disabled"]))
                      ], !0),
                      C(X.$slots, "ok", we(Pe(d)), () => [
                        fe(st, {
                          id: V.value,
                          ref_key: "okButton",
                          ref: n,
                          variant: e.okVariant,
                          size: e.buttonSize,
                          disabled: e.okDisabled || e.busy,
                          onClick: B
                        }, {
                          default: E(() => [
                            q(D(e.okTitle), 1)
                          ]),
                          _: 1
                        }, 8, ["id", "variant", "size", "disabled"])
                      ], !0)
                    ], !0)
                  ]),
                  _: 3
                }, 8, ["class"]))
              ], 2)
            ], 2),
            m.value && !e.hideBackdrop ? (p(), T("div", {
              key: 0,
              class: "modal-backdrop fade show",
              onClick: oe
            })) : R("", !0)
          ], 14, Ei)), [
            [$l, m.value]
          ]) : R("", !0)
        ]),
        _: 3
      }, 8, ["appear"])
    ], 8, ["disabled"]));
  }
}), Aa = /* @__PURE__ */ Ae(zi, [["__scopeId", "data-v-66fe6762"]]), Oa = {
  install(e) {
    const a = P(/* @__PURE__ */ new Map()), t = b(() => a.value.size), l = b(() => [...a.value.values()].pop()), n = (f) => {
      a.value.set(f.uid, f);
    }, o = (f) => {
      a.value.delete(f.uid);
    }, i = P(/* @__PURE__ */ new Map()), r = (f) => {
      i.value.set(f.uid, f);
    }, u = (f) => {
      i.value.delete(f.uid);
    };
    e.provide(Ml, {
      stack: b(() => [...a.value.values()]),
      countStack: t,
      lastStack: l,
      registry: b(() => [...i.value.values()]),
      pushStack: n,
      removeStack: o,
      pushRegistry: r,
      removeRegistry: u
    });
  }
}, Bl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  modalManagerPlugin: Oa
}, Symbol.toStringTag, { value: "Module" })), Di = {
  install: (e) => {
    e.component("BModal", Aa), e.use(Oa);
  }
}, Mi = { class: "nav-item" }, Ia = /* @__PURE__ */ Z({
  __name: "NavItem",
  props: {
    custom: { type: Boolean },
    activeClass: {},
    exactActiveClass: {},
    ariaCurrentValue: {},
    to: {},
    replace: { type: Boolean },
    active: { type: Boolean },
    disabled: { type: Boolean },
    href: {},
    rel: {},
    target: {},
    linkAttrs: {},
    linkClasses: {}
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    const t = e, l = a;
    function n(o) {
      t.disabled || l("click", o);
    }
    return (o, i) => (p(), T("li", Mi, [
      fe(gt, ae({
        class: ["nav-link", t.linkClasses],
        attrs: t.linkAttrs
      }, x(Ol)(t, "linkAttrs", "linkClasses"), { onClick: n }), {
        default: E(() => [
          C(o.$slots, "default")
        ]),
        _: 3
      }, 16, ["class", "attrs"])
    ]));
  }
}), Ri = { class: "nav-item dropdown" }, ji = ["role"], Pa = /* @__PURE__ */ Z({
  __name: "NavItemDropdown",
  props: {
    boundary: { default: "clippingAncestors" },
    modelValue: { type: Boolean },
    text: { default: void 0 },
    disabled: { type: Boolean },
    noCaret: { type: Boolean },
    noFlip: { type: Boolean, default: !1 },
    toggleClass: { default: void 0 },
    menuClass: { default: void 0 },
    role: { default: "menu" },
    dropleft: { type: Boolean },
    dropright: { type: Boolean },
    dropup: { type: Boolean },
    right: { type: Boolean },
    offset: { default: 0 }
  },
  emits: ["update:modelValue", "shown", "toggle", "hidden"],
  setup(e, { emit: a }) {
    const t = e, l = a, n = ze(t, "modelValue", l, { passive: !0 }), o = P(null), i = P(null), r = b(() => {
      const y = t.dropup ? "top" : t.dropleft ? "left" : t.dropright ? "right" : "bottom", h = t.right ? "end" : null;
      return `${y}${h ? `-${h}` : ""}`;
    }), u = b(
      () => t.boundary === "document" || t.boundary === "viewport" ? void 0 : t.boundary
    ), f = b(
      () => t.boundary === "document" || t.boundary === "viewport" ? t.boundary : void 0
    ), s = b(() => {
      const y = [ht(Number(t.offset))];
      return t.noFlip === !1 && y.push(
        yt({
          boundary: u.value,
          rootBoundary: f.value
        })
      ), y;
    }), { floatingStyles: m, update: d } = Go(o, i, {
      placement: r.value,
      middleware: s.value,
      whileElementsMounted: qo
    });
    function c() {
      l("toggle"), v();
    }
    function v() {
      n.value = !n.value, n.value ? l("shown") : l("hidden");
    }
    G(n, () => {
      d();
    }), Nn(i, () => {
      n.value && v();
    });
    function k() {
      n.value && v();
    }
    return (y, h) => {
      const g = xl("b-link");
      return p(), T("li", Ri, [
        fe(g, {
          ref_key: "toggle",
          ref: o,
          class: $(["nav-link dropdown-toggle", [
            t.toggleClass,
            {
              "dropdown-toggle-no-caret": t.noCaret,
              show: x(n)
            }
          ]]),
          href: "#",
          role: "button",
          "aria-haspopup": "menu",
          "aria-expanded": x(n),
          disabled: t.disabled,
          onClick: c
        }, {
          default: E(() => [
            C(y.$slots, "button-content", {}, () => [
              q(D(t.text), 1)
            ])
          ]),
          _: 3
        }, 8, ["class", "aria-expanded", "disabled"]),
        x(n) ? (p(), T("ul", {
          key: 0,
          ref_key: "menu",
          ref: i,
          class: $(["dropdown-menu show", t.menuClass]),
          style: He(x(m)),
          role: t.role,
          onClick: k
        }, [
          C(y.$slots, "default")
        ], 14, ji)) : R("", !0)
      ]);
    };
  }
}), La = {
  install: (e) => {
    e.component("BNavItem", Ia), e.component("BNavItemDropdown", Pa);
  }
}, Ea = {
  __name: "Navbar",
  props: {
    fixed: {
      type: String,
      default: void 0
    },
    print: {
      type: Boolean,
      default: !1
    },
    sticky: {
      type: Boolean,
      default: !1
    },
    tag: {
      type: String,
      default: "nav"
    },
    toggleable: {
      type: [Boolean, String],
      default: !1
    },
    type: {
      type: String,
      default: "light"
    },
    variant: {
      type: String,
      default: void 0
    }
  },
  setup(e) {
    const a = e, t = b(() => {
      if (a.toggleable === !1)
        return "navbar-expand";
      if (a.toggleable && typeof a.toggleable == "string" && a.toggleable !== "xs")
        return `navbar-expand-${a.toggleable}`;
    }), l = b(() => a.tag === "nav" ? null : "navigation");
    return (n, o) => (p(), I(J(a.tag), {
      role: l.value,
      class: $(["navbar", [
        {
          "d-print": a.print,
          "sticky-top": a.sticky,
          [`navbar-${a.type}`]: a.type,
          [`bg-${e.variant}`]: a.variant,
          [`fixed-${a.fixed}`]: a.fixed
        },
        t.value
      ]])
    }, {
      default: E(() => [
        C(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["role", "class"]));
  }
}, Na = {
  __name: "NavbarNav",
  props: {
    align: {
      type: String,
      default: void 0
    },
    fill: {
      type: Boolean,
      default: !1
    },
    justified: {
      type: Boolean,
      default: !1
    },
    small: {
      type: Boolean,
      default: !1
    },
    tag: {
      type: String,
      default: "ul"
    }
  },
  setup(e) {
    const a = e, t = b(() => a.align === "left" ? "start" : a.align === "right" ? "end" : a.align);
    return (l, n) => (p(), I(J(e.tag), {
      class: $(["navbar-nav", {
        "nav-fill": a.fill,
        "nav-justified": a.justified,
        [`justify-content-${t.value}`]: a.align,
        small: a.small
      }])
    }, {
      default: E(() => [
        C(l.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}, Hi = ["disabled", "aria-label"], qi = /* @__PURE__ */ N("span", { class: "navbar-toggler-icon" }, null, -1), za = /* @__PURE__ */ Z({
  __name: "NavbarToggle",
  props: {
    disabled: { type: Boolean, default: !1 },
    label: { default: "Toggle navigation" },
    target: { default: void 0 }
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    const t = e, l = a;
    function n(o) {
      t.disabled || l("click", o);
    }
    return (o, i) => {
      const r = un("b-toggle");
      return Be((p(), T("button", {
        class: $(["navbar-toggler", { disabled: t.disabled }]),
        disabled: t.disabled,
        "aria-label": t.label,
        type: "button",
        onClick: n
      }, [
        C(o.$slots, "default", {}, () => [
          qi
        ])
      ], 10, Hi)), [
        [r, t.disabled ? void 0 : o.target]
      ]);
    };
  }
}), Gi = {
  install: (e) => {
    e.use(La), e.use(ia), e.component("BNavbar", Ea), e.component("BNavbarNav", Na), e.component("BNavbarToggle", za);
  }
}, Wi = { key: 0 }, Ui = ["aria-label"], Xi = ["aria-label", "aria-controls"], Ki = ["aria-label", "aria-controls"], Yi = ["aria-label", "aria-controls", "aria-checked", "aria-posinset", "aria-setsize", "onClick"], Ji = ["aria-controls"], Zi = ["aria-label", "aria-controls"], Qi = ["aria-label", "aria-controls"], _i = {
  __name: "Pagination",
  props: {
    align: {
      type: String,
      default: "left",
      validator: (e) => ["left", "center", "right"].includes(e)
    },
    ariaControls: {
      type: String,
      default: null
    },
    modelValue: {
      type: [Boolean, Number, String],
      default: null
    },
    totalRows: {
      type: Number,
      required: !0
    },
    size: {
      type: String,
      default: "md",
      validator: (e) => ["sm", "md", "lg"].includes(e)
    },
    perPage: {
      type: Number,
      default: 20
    },
    limit: {
      type: [Number, String],
      default: 5
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    prevText: {
      type: String,
      default: "‹"
    },
    prevClass: {
      type: [Array, String, Object],
      default: null
    },
    nextText: {
      type: String,
      default: "›"
    },
    nextClass: {
      type: [Array, String, Object],
      default: null
    },
    firstText: {
      type: String,
      default: "«"
    },
    firstClass: {
      type: [Array, String, Object],
      default: null
    },
    lastText: {
      type: String,
      default: "»"
    },
    lastClass: {
      type: [Array, String, Object],
      default: null
    },
    ariaLabel: {
      type: String,
      default: "Pagination"
    },
    labelPage: {
      type: String,
      default: "Go to page"
    },
    labelFirstPage: {
      type: String,
      default: "Go to first page"
    },
    labelLastPage: {
      type: String,
      default: "Go to last page"
    },
    labelPrevPage: {
      type: String,
      default: "Go to previous page"
    },
    labelNextPage: {
      type: String,
      default: "Go to next page"
    },
    ellipsisText: {
      type: String,
      default: "…"
    },
    ellipsisClass: {
      type: [Array, String, Object],
      default: null
    },
    pageClass: {
      type: [Array, String, Object],
      default: null
    },
    hideGotoEndButtons: {
      type: Boolean,
      default: !1
    },
    hideEllipsis: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "change", "input", "page-click"],
  setup(e, { emit: a }) {
    const { width: t } = Zn(), l = a, n = e, o = ze(n, "modelValue", l), i = b(() => n.disabled), r = b(() => Math.ceil(n.totalRows / n.perPage)), u = b(() => [
      "pagination",
      `justify-content-${f.value}`,
      s.value
    ]), f = b(() => n.align === "left" ? "start" : n.align === "right" ? "end" : "center"), s = b(() => `pagination-${n.size}`), m = b(() => {
      const y = Number(n.limit);
      let h;
      o.value === 1 && n.limit >= 5 ? h = y - 1 : o.value >= 2 && n.limit >= 5 ? h = y - 2 : t.value < 576 && n.limit > 3 ? h = 3 : h = y;
      const g = Math.max(1, o.value - Math.floor(h / 2)), S = Math.min(r.value, g + h - 1), L = [];
      for (let F = g; F <= S; F++)
        L.push(F);
      return g > 1 && L.unshift(n.ellipsisText), S < r.value && L.push(n.ellipsisText), L.length === 0 && L.push(1), L;
    });
    function d(y) {
      const h = k("page-click", { cancelable: !0 });
      if (!i.value && y !== o.value && y >= 1 && y <= r.value) {
        if (l("page-click", { event: h, page: y }), h.defaultPrevented)
          return;
        o.value = y, l("change", y), l("input", y);
      }
    }
    function c() {
      d(o.value - 1);
    }
    function v() {
      d(o.value + 1);
    }
    function k(y, h = {}) {
      return new CustomEvent(y, {
        cancelable: !1,
        ...h
      });
    }
    return (y, h) => e.perPage !== 0 ? (p(), T("nav", Wi, [
      N("ul", {
        class: $(["pagination", u.value]),
        "aria-label": e.ariaLabel
      }, [
        e.hideGotoEndButtons ? R("", !0) : (p(), T("li", {
          key: 0,
          role: "presentation",
          class: $(["page-item", { disabled: i.value || x(o) === 1 }])
        }, [
          N("button", {
            role: "menuitem",
            type: "button",
            tabindex: "-1",
            class: $(["page-link first-pagination-link", e.firstClass]),
            "aria-label": e.labelFirstPage,
            "aria-controls": e.ariaControls,
            onClick: h[0] || (h[0] = (g) => d(1))
          }, [
            C(y.$slots, "first-text", {
              disabled: i.value || x(o) === 1,
              index: 0,
              page: 1
            }, () => [
              q(D(e.firstText), 1)
            ], !0)
          ], 10, Xi)
        ], 2)),
        N("li", {
          class: $(["page-item", { disabled: i.value || x(o) === 1 }])
        }, [
          N("button", {
            role: "menuitem",
            type: "button",
            tabindex: "-1",
            class: $(["page-link prev-pagination-link", e.prevClass]),
            "aria-label": e.labelPrevPage,
            "aria-controls": e.ariaControls,
            onClick: h[1] || (h[1] = (g) => c())
          }, [
            C(y.$slots, "prev-text", {
              disabled: i.value || x(o) === 1,
              index: x(o) <= 2 ? 0 : x(o) - 2,
              page: x(o) - 1
            }, () => [
              q(D(e.prevText), 1)
            ], !0)
          ], 10, Ki)
        ], 2),
        (p(!0), T(ee, null, se(m.value, (g) => (p(), T("li", {
          key: g,
          class: $(["page-item", { active: x(o) === g }])
        }, [
          g !== e.ellipsisText ? (p(), T("button", {
            key: 0,
            role: "menuitem",
            type: "button",
            tabindex: "-1",
            "aria-label": `${e.labelPage} ${g}`,
            "aria-controls": e.ariaControls,
            "aria-checked": x(o) === g || null,
            "aria-posinset": g,
            "aria-setsize": e.limit,
            class: $(["page-link", e.pageClass]),
            onClick: (S) => d(g)
          }, [
            C(y.$slots, "page", {
              active: x(o) === g,
              content: g,
              disabled: i.value,
              index: x(o) - 1,
              page: g
            }, () => [
              q(D(g), 1)
            ], !0)
          ], 10, Yi)) : g === e.ellipsisText && !e.hideEllipsis ? (p(), T("span", {
            key: 1,
            class: $(["page-link ellipsis-text", e.ellipsisClass]),
            "aria-controls": e.ariaControls
          }, [
            C(y.$slots, "ellipsis-text", {}, () => [
              q(D(e.ellipsisText), 1)
            ], !0)
          ], 10, Ji)) : R("", !0)
        ], 2))), 128)),
        N("li", {
          class: $(["page-item", { disabled: i.value || x(o) === r.value }])
        }, [
          N("button", {
            role: "menuitem",
            type: "button",
            tabindex: "-1",
            class: $(["page-link next-pagination-link", e.nextClass]),
            "aria-label": e.labelNextPage,
            "aria-controls": e.ariaControls,
            onClick: h[2] || (h[2] = (g) => v())
          }, [
            C(y.$slots, "next-text", {
              disabled: i.value || x(o) === r.value,
              index: x(o),
              page: x(o) + 1
            }, () => [
              q(D(e.nextText), 1)
            ], !0)
          ], 10, Zi)
        ], 2),
        e.hideGotoEndButtons ? R("", !0) : (p(), T("li", {
          key: 1,
          class: $(["page-item", { disabled: i.value || x(o) === r.value }])
        }, [
          N("button", {
            role: "menuitem",
            type: "button",
            tabindex: "-1",
            class: $(["page-link last-pagination-link", e.lastClass]),
            "aria-label": e.labelLastPage,
            "aria-controls": e.ariaControls,
            onClick: h[3] || (h[3] = (g) => d(r.value))
          }, [
            C(y.$slots, "last-text", {
              disabled: i.value || x(o) === r.value,
              index: r.value - 1,
              page: r.value
            }, () => [
              q(D(e.lastText), 1)
            ], !0)
          ], 10, Qi)
        ], 2))
      ], 10, Ui)
    ])) : R("", !0);
  }
}, Da = /* @__PURE__ */ Ae(_i, [["__scopeId", "data-v-17ce57e3"]]), es = {
  install: (e) => {
    e.component("BPagination", Da);
  }
}, ts = ["id"], ls = { class: "popover-header" }, as = { class: "popover-body" }, Ma = {
  __name: "Popover",
  props: {
    title: {
      type: String,
      default: void 0
    },
    placement: {
      type: String,
      default: void 0
    },
    triggers: {
      type: [String, Array],
      default: () => ["hover", "focus"]
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    target: {
      type: String,
      required: !0
    },
    variant: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: void 0
    },
    customClass: {
      type: String,
      default: void 0
    },
    show: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "disabled",
    "enabled",
    "show",
    "shown",
    "hide",
    "hidden"
  ],
  setup(e, { emit: a }) {
    const t = Fe(), l = a, n = e, o = P(n.show), i = P(null), r = P(null), u = P(null);
    Te(() => {
      r.value = document.getElementById(n.target), r.value && (r.value.setAttribute("aria-describedby", h.value), n.triggers.includes("hover") && (window.matchMedia("(hover: hover)").matches ? (r.value.addEventListener("mouseenter", m), r.value.addEventListener("mouseleave", d)) : (r.value.addEventListener("click", c), document.addEventListener(
        "click",
        (g) => v(g, r)
      ))), n.triggers.includes("click") && r.value.addEventListener("click", c), n.triggers.includes("focus") && (r.value.addEventListener("focus", m), r.value.addEventListener("blur", d)));
    }), G(
      () => o.value,
      () => {
        o.value ? pe(() => {
          k();
        }) : s("hidden");
      },
      { immediate: !0 }
    ), G(
      () => n.show,
      () => {
        n.show ? o.value = !0 : o.value = !1;
      },
      { immediate: !0 }
    ), G(
      () => n.disabled,
      () => {
        n.disabled ? s("disabled") : s("enabled");
      },
      { immediate: !0 }
    ), Vl(() => {
      o.value && (o.value = !1);
    });
    function f(g, S = {}) {
      return new CustomEvent(g, {
        cancelable: !1,
        ...S
      });
    }
    function s(g, S = {}) {
      if (g) {
        const L = f(g, S);
        l(g, L);
      }
    }
    function m() {
      o.value || (o.value = !0);
    }
    function d() {
      o.value && (s("hide", { cancelable: !0 }), o.value = !1);
    }
    function c() {
      o.value = !o.value;
    }
    function v(g, S) {
      g.target.id !== S.value.id && (o.value = !1);
    }
    function k() {
      o.value && (n.title || t.default) && !n.disabled && (s("show", { cancelable: !0 }), Ct(r.value, i.value, {
        placement: n.placement || "top",
        middleware: [
          ht(8),
          yt(),
          qt({ padding: 5 }),
          Xt({ element: u.value })
        ]
      }).then(({ x: g, y: S, placement: L, middlewareData: F }) => {
        Object.assign(i.value.style, {
          left: `${g}px`,
          top: `${S}px`
        });
        const { x: M, y: V } = F.arrow, j = {
          top: "bottom",
          right: "left",
          bottom: "top",
          left: "right"
        }[L.split("-")[0]];
        Object.assign(u.value.style, {
          left: M != null ? `${M}px` : "",
          top: V != null ? `${V}px` : "",
          right: "",
          bottom: "",
          [j]: "-4px"
        });
      }), u.value.classList.add(n.placement || "top"), i.value.classList.add("show"), s("shown"));
    }
    const y = b(() => ({
      ...n.variant && { [`bg-${n.variant}`]: n.variant },
      [n.customClass]: n.customClass
    })), h = b(
      () => n.id || `popover-${Math.random().toString(36).substring(2, 11)}`
    );
    return (g, S) => (p(), I(mt, { to: "body" }, [
      o.value ? (p(), T("div", {
        key: 0,
        id: h.value,
        ref_key: "popover",
        ref: i,
        class: $(["popover fade", y.value]),
        role: "tooltip",
        tabindex: "-1"
      }, [
        N("h3", ls, [
          C(g.$slots, "title")
        ]),
        N("div", as, [
          C(g.$slots, "default", {}, () => [
            q(D(e.title), 1)
          ])
        ]),
        N("div", {
          ref_key: "popoverArrow",
          ref: u,
          class: $(["arrow", `bg-${e.variant}`])
        }, null, 2)
      ], 10, ts)) : R("", !0)
    ]));
  }
}, ns = {
  install: (e) => {
    e.component("BPopover", Ma);
  }
}, os = ["aria-valuenow", "aria-valuemax"], Ra = /* @__PURE__ */ Z({
  __name: "ProgressBar",
  props: {
    animated: { type: [Boolean, String], default: !1 },
    label: { default: void 0 },
    labelHtml: { default: void 0 },
    max: { default: void 0 },
    precision: { default: 0 },
    showProgress: { type: [Boolean, String], default: !1 },
    showValue: { type: [Boolean, String], default: !1 },
    striped: { type: [Boolean, String], default: !1 },
    value: { default: 0 },
    variant: { default: null },
    bgVariant: { default: null },
    textVariant: { default: null }
  },
  setup(e) {
    const a = e, t = Xe(zl, null), l = H(() => a.animated), n = H(() => a.showProgress), o = H(() => a.showValue), i = H(() => a.striped), r = pt(a), u = b(() => [
      r.value,
      {
        "progress-bar-animated": l.value || (t == null ? void 0 : t.animated.value),
        "progress-bar-striped": i.value || (t == null ? void 0 : t.striped.value) || l.value || (t == null ? void 0 : t.animated.value)
      }
    ]), f = Le(() => a.precision), s = Le(() => a.value), m = Le(() => a.max ?? NaN), d = Le(() => (t == null ? void 0 : t.max.value) ?? NaN), c = b(
      () => a.labelHtml !== void 0 ? a.labelHtml : o.value || t != null && t.showValue.value ? s.value.toFixed(f.value) : n.value || t != null && t.showProgress.value ? (s.value * 100 / (m.value || 100)).toFixed(
        f.value
      ) : a.label !== void 0 ? a.label : ""
    ), v = b(
      () => d.value ? `${s.value * 100 / d.value}%` : m.value ? `${s.value * 100 / m.value}%` : typeof a.value == "string" ? a.value : `${a.value}%`
    );
    return (k, y) => (p(), T("div", {
      class: $(["progress-bar", u.value]),
      role: "progressbar",
      "aria-valuenow": k.value,
      "aria-valuemin": "0",
      "aria-valuemax": k.max,
      style: He({ width: v.value })
    }, [
      C(k.$slots, "default", {}, () => [
        q(D(c.value), 1)
      ])
    ], 14, os));
  }
}), ja = /* @__PURE__ */ Z({
  __name: "Progress",
  props: {
    height: { default: void 0 },
    animated: { type: [Boolean, String], default: void 0 },
    max: { default: 100 },
    precision: { default: void 0 },
    showProgress: { type: [Boolean, String], default: void 0 },
    showValue: { type: [Boolean, String], default: void 0 },
    striped: { type: [Boolean, String], default: void 0 },
    value: { default: void 0 },
    variant: { default: void 0 },
    bgVariant: { default: void 0 },
    textVariant: { default: void 0 }
  },
  setup(e) {
    const a = e, t = H(() => a.animated), l = H(() => a.showProgress), n = H(() => a.showValue), o = H(() => a.striped);
    return vt(zl, {
      animated: t,
      max: K(() => a.max),
      showProgress: l,
      showValue: n,
      striped: o
    }), (i, r) => (p(), T("div", {
      class: "progress",
      style: He({ height: i.height })
    }, [
      C(i.$slots, "default", {}, () => [
        fe(Ra, {
          animated: i.animated,
          max: i.max,
          precision: i.precision,
          "show-progress": i.showProgress,
          "show-value": i.showValue,
          striped: i.striped,
          value: i.value,
          variant: i.variant,
          "text-variant": i.textVariant,
          "bg-variant": i.bgVariant
        }, null, 8, ["animated", "max", "precision", "show-progress", "show-value", "striped", "value", "variant", "text-variant", "bg-variant"])
      ])
    ], 4));
  }
}), is = {
  install: (e) => {
    e.component("BProgress", ja), e.component("BProgressBar", Ra);
  }
}, ss = { class: "visually-hidden" }, Ha = {
  __name: "Spinner",
  props: {
    /**
     * Text content to place in the sr-only label.
     */
    label: {
      type: String,
      default: "Loading..."
    },
    /**
     * Change the color of the spinner-border. Default is "primary".
     */
    variant: {
      type: String,
      default: "primary"
    },
    /**
     * Type of spinner. Supports "border" or "grow". By default, "border" spinner will be rendered.
     */
    type: {
      type: String,
      default: "border"
    },
    /**
     * Class override for the Spinner component.
     */
    classes: {
      type: Array,
      default: () => []
    }
  },
  setup(e) {
    const a = e, t = b(() => a.type === "grow" ? "spinner-grow" : "spinner-border"), l = b(() => `text-${a.variant}`);
    return (n, o) => (p(), T("div", {
      class: $(["primary", [...e.classes, t.value, l.value]]),
      role: "status"
    }, [
      N("span", ss, D(e.label), 1)
    ], 2));
  }
}, rs = {
  install: (e) => {
    e.component("BSpinner", Ha);
  }
}, Ze = (e) => (cn("data-v-a727ab90"), e = e(), fn(), e), us = ["id", "aria-label", "aria-busy", "aria-colcount"], ds = ["id", "aria-colindex", "aria-sort", "onClick"], cs = /* @__PURE__ */ Ze(() => /* @__PURE__ */ N("span", { class: "visually-hidden" }, "Sorted in ascending order", -1)), fs = /* @__PURE__ */ Ze(() => /* @__PURE__ */ N("span", { class: "visually-hidden" }, "Sorted in descending order", -1)), vs = { role: "rowgroup" }, ms = {
  key: 0,
  role: "row"
}, gs = ["colspan"], ps = /* @__PURE__ */ Ze(() => /* @__PURE__ */ N("div", { class: "d-flex align-items-center justify-content-center gap-2" }, [
  /* @__PURE__ */ N("span", { class: "visually-hidden" }, "Loading...")
], -1)), bs = {
  key: 1,
  role: "row"
}, ys = ["colspan"], hs = { class: "d-flex align-items-center justify-content-center gap-2" }, Bs = ["aria-colindex", "onClick"], ks = ["id", "aria-sort", "aria-colindex", "onClick"], Cs = /* @__PURE__ */ Ze(() => /* @__PURE__ */ N("span", { class: "visually-hidden" }, "Sorted in ascending order", -1)), ws = /* @__PURE__ */ Ze(() => /* @__PURE__ */ N("span", { class: "visually-hidden" }, "Sorted in descending order", -1)), Ss = {
  __name: "Table",
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    items: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: Array,
      default: () => []
    },
    perPage: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: [Number, String],
      default: 1
    },
    sortBy: {
      type: String,
      default: void 0
    },
    sortDesc: {
      type: Boolean,
      default: !1
    },
    busy: {
      type: Boolean,
      default: !1
    },
    footClone: {
      type: Boolean,
      default: !1
    },
    responsive: {
      type: Boolean,
      default: !1
    },
    hover: {
      type: Boolean,
      default: !1
    },
    striped: {
      type: Boolean,
      default: !1
    },
    bordered: {
      type: Boolean,
      default: !1
    },
    borderless: {
      type: Boolean,
      default: !1
    },
    small: {
      type: Boolean,
      default: !1
    },
    showEmpty: {
      type: Boolean,
      default: !1
    },
    emptyText: {
      type: String,
      default: "There are no records to show"
    },
    fixed: {
      type: Boolean,
      default: !1
    },
    tableVariant: {
      type: String,
      default: null
    },
    tableClass: {
      type: [String, Array, Object],
      default: null
    },
    headVariant: {
      type: String,
      default: null
    },
    footVariant: {
      type: String,
      default: null
    },
    noFooterSorting: {
      type: Boolean,
      default: !1
    },
    noProviderFiltering: {
      type: Boolean,
      default: !1
    },
    noProviderPaging: {
      type: Boolean,
      default: !1
    },
    noProviderSorting: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["headClicked", "sortChanged", "rowClicked"],
  setup(e, { expose: a, emit: t }) {
    const l = P("asc"), n = P(null), o = P(!0), i = P(null), r = P(!1), u = b(() => typeof s.items == "function"), f = t, s = e;
    dn(() => {
      te();
    }), G(
      () => s.items,
      () => {
        te();
      }
    );
    const m = b(() => {
      if (i.value) {
        const B = /* @__PURE__ */ new Set();
        return i.value.forEach((w) => {
          for (const z in w)
            Object.prototype.hasOwnProperty.call(w, z) && B.add(z);
        }), Array.from(B);
      }
      return [];
    }), d = b(() => {
      var B;
      return (B = s == null ? void 0 : s.fields) != null && B.length ? k(JSON.parse(JSON.stringify(s.fields))) : k(m.value);
    }), c = b(() => {
      var B;
      if ((B = i == null ? void 0 : i.value) != null && B.length) {
        if (V(), s.perPage === 0 || u.value && !s.noProviderPaging)
          return i.value;
        {
          const w = (s.currentPage - 1) * s.perPage, z = w + s.perPage;
          return i.value.slice(w, z);
        }
      }
      return [];
    }), v = b(() => d.value.length);
    function k(B) {
      return B != null && B.length ? B.map((w) => typeof w == "string" ? {
        key: w,
        label: w,
        sortable: !1,
        variant: null,
        class: null
      } : {
        key: w.key,
        label: w.label || w.key,
        sortable: w.sortable || !1,
        variant: w.variant || null,
        class: w.class || null
      }) : [];
    }
    const y = b(() => [
      s.hover ? "table-hover" : "",
      s.striped ? "table-striped" : "",
      s.bordered ? "table-bordered" : "",
      s.borderless ? "table-borderless" : "",
      s.fixed ? "table-fixed" : "",
      s.tableVariant ? `table-${s.tableVariant}` : "",
      s.tableClass ? s.tableClass : "",
      s.small ? "table-sm" : ""
    ]), h = b(() => s.responsive ? "table-responsive" : ""), g = b(() => s.busy || r.value);
    function S(B, w, z) {
      var A;
      return g.value || !((A = c.value) != null && A.length) ? null : n.value === B && w ? l.value === "asc" ? "descending" : "ascending" : w ? z && s.noFooterSorting ? null : "none" : null;
    }
    function L(B) {
      const w = d.value.find((z) => z.key === B);
      n.value === w.key ? l.value = l.value === "asc" ? "desc" : "asc" : (n.value = w.key, l.value = o.value && s.sortDesc ? "desc" : "asc");
    }
    function F(B) {
      L(B), i.value.sort((w, z) => {
        const A = w[n.value], U = z[n.value], le = l.value === "asc" ? "desc" : "asc";
        return typeof A == "number" && l.value === "asc" ? A - U : typeof A == "number" && l.value === "desc" ? U - A : typeof A == "string" && l.value === "asc" ? A.localeCompare(U) : typeof A == "string" && l.value === "desc" ? U.localeCompare(A) : l.value === "asc" && le === "asc" ? 0 : -1;
      });
    }
    function M(B, w, z) {
      oe(B.key, B, w, z), B.sortable && (F(B.key), O());
    }
    function V() {
      o.value && s.sortBy && n.value === null ? F(s.sortBy) : o.value = !1;
    }
    async function j() {
      if (!(!u.value || s.items === void 0 || r.value))
        try {
          r.value = !0;
          const B = await s.items({
            currentPage: s.currentPage,
            sortBy: s.sortBy,
            perPage: s.perPage
          });
          i.value = B;
        } finally {
          r.value = !1;
        }
    }
    async function W(B, w, z) {
      if (w === z)
        return;
      const A = (B === "currentPage" || B === "perPage") && s.noProviderPaging === !0, U = B === "filter" && s.noProviderFiltering === !0, le = (B === "sortBy" || B === "sortDesc") && s.noProviderSorting === !0;
      A || U || le || u.value === !0 && await j();
    }
    G(
      () => s.currentPage,
      (B, w) => {
        W("currentPage", B, w);
      }
    ), G(
      () => s.perPage,
      (B, w) => {
        W("perPage", B, w);
      }
    ), G(
      () => s.sortBy,
      (B, w) => {
        W("sortBy", B, w);
      }
    );
    async function te() {
      u.value === !0 ? await j() : i.value = s.items;
    }
    function ne(B) {
      return `table-${B}`;
    }
    function Q(B, w, z) {
      f("rowClicked", { item: B, rowIndex: w, event: z });
    }
    function oe(B, w, z, A) {
      f("headClicked", { key: B, field: w, event: z, isFooter: A });
    }
    function O() {
      f("sortChanged", {
        sortBy: s.sortBy,
        sortOrder: l.value,
        currentPage: s.currentPage,
        perPage: s.perPage,
        sortDesc: s.sortDesc,
        sortField: n.value
      });
    }
    return a({
      refresh: j
    }), (B, w) => {
      var z;
      return p(), T("div", {
        class: $(h.value)
      }, [
        v.value ? (p(), T("table", {
          key: 0,
          id: e.id,
          class: $(["table", y.value]),
          "aria-label": e.id ? `${e.id}-table` : "table",
          "aria-busy": g.value ? "true" : "false",
          "aria-colcount": d.value.length,
          role: "table"
        }, [
          N("thead", {
            class: $(e.headVariant),
            role: "rowgroup"
          }, [
            N("tr", null, [
              (p(!0), T(ee, null, se(d.value, (A, U) => (p(), T("th", {
                id: "head-" + A.key,
                key: U,
                role: "columnheader",
                scope: "col",
                class: $([
                  A.variant ? ne(A.variant) : "",
                  A.class ? A.class : ""
                ]),
                "aria-colindex": U + 1,
                "aria-sort": S(A.key, A.sortable, !1),
                onClick: (le) => M(A, le, !1)
              }, [
                N("div", null, [
                  C(B.$slots, `head(${A.key})` ? `head(${A.key})` : "head()", {
                    item: A,
                    label: A.label,
                    column: A.key
                  }, () => [
                    q(D(A.label || x(vl)(A.key)), 1)
                  ], !0),
                  cs,
                  fs
                ])
              ], 10, ds))), 128))
            ])
          ], 2),
          N("tbody", vs, [
            g.value && B.$slots["table-busy"] ? (p(), T("tr", ms, [
              N("td", {
                colspan: d.value.length,
                role: "cell",
                "aria-colindex": 1
              }, [
                C(B.$slots, "table-busy", {}, () => [
                  ps
                ], !0)
              ], 8, gs)
            ])) : e.showEmpty && !((z = c.value) != null && z.length) ? (p(), T("tr", bs, [
              N("td", {
                colspan: d.value.length,
                role: "cell",
                "aria-colindex": 1
              }, [
                C(B.$slots, "empty", {
                  emptyText: e.emptyText,
                  fields: d.value,
                  items: c.value
                }, () => [
                  N("div", hs, [
                    N("span", null, D(e.emptyText), 1)
                  ])
                ], !0)
              ], 8, ys)
            ])) : (p(!0), T(ee, { key: 2 }, se(c.value, (A, U) => (p(), T("tr", {
              key: U,
              role: "row"
            }, [
              (p(!0), T(ee, null, se(d.value, (le, Qe) => (p(), T("td", {
                key: Qe,
                role: "cell",
                class: $([
                  le.variant ? ne(le.variant) : null,
                  le.class ? le.class : ""
                ]),
                "aria-colindex": Qe + 1,
                onClick: ($t) => Q(A, U, $t)
              }, [
                C(B.$slots, `cell(${le.key})` ? `cell(${le.key})` : "cell()", {
                  item: A,
                  index: U,
                  value: A[le.key]
                }, () => [
                  q(D(A[le.key]), 1)
                ], !0)
              ], 10, Bs))), 128))
            ]))), 128))
          ]),
          e.footClone ? (p(), T("tfoot", {
            key: 0,
            class: $(e.footVariant),
            role: "rowgroup"
          }, [
            N("tr", null, [
              (p(!0), T(ee, null, se(d.value, (A, U) => (p(), T("th", {
                id: "footer-" + A.key,
                key: U,
                role: "columnfooter",
                class: $([
                  A.variant ? ne(A.variant) : "",
                  A.class ? A.class : ""
                ]),
                "aria-sort": S(A.key, A.sortable, !0),
                "aria-colindex": U + 1,
                scope: "col",
                onClick: (le) => M(A, le, !0)
              }, [
                C(B.$slots, `foot(${A.key})` ? `foot(${A.key})` : "foot()", {
                  item: A,
                  label: A.label,
                  column: A.key
                }, () => [
                  q(D(A.label || x(vl)(A.key)), 1)
                ], !0),
                Cs,
                ws
              ], 10, ks))), 128))
            ])
          ], 2)) : R("", !0)
        ], 10, us)) : R("", !0)
      ], 2);
    };
  }
}, qa = /* @__PURE__ */ Ae(Ss, [["__scopeId", "data-v-a727ab90"]]), $s = {
  install: (e) => {
    e.component("BTable", qa);
  }
}, xs = ["aria-orientation"], Vs = ["id", "aria-controls", "aria-selected", "onClick"], Ga = /* @__PURE__ */ Z({
  __name: "Tabs",
  props: {
    activeId: { default: void 0 },
    activeNavItemClass: { default: void 0 },
    activeTabClass: { default: void 0 },
    align: { default: void 0 },
    card: { type: [Boolean, String], default: !1 },
    contentClass: { default: void 0 },
    end: { type: [Boolean, String], default: !1 },
    fill: { type: [Boolean, String], default: !1 },
    id: { default: void 0 },
    inactiveNavItemClass: { default: void 0 },
    inactiveTabClass: { default: void 0 },
    justified: { type: [Boolean, String], default: !1 },
    lazy: { type: [Boolean, String], default: !1 },
    modelValue: { default: -1 },
    navClass: { default: void 0 },
    navItemClass: { default: void 0 },
    navWrapperClass: { default: void 0 },
    noFade: { type: [Boolean, String], default: !1 },
    noNavStyle: { type: [Boolean, String], default: !1 },
    pills: { type: [Boolean, String], default: !1 },
    small: { type: [Boolean, String], default: !1 },
    tag: { default: "div" },
    tabClass: { default: void 0 },
    vertical: { type: [Boolean, String], default: !1 }
  },
  emits: ["activate-tab", "update:activeId", "update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, l = a, n = ze(t, "modelValue", l, { passive: !0 }), o = ze(t, "activeId", l, { passive: !0 }), i = H(() => t.card), r = H(() => t.end), u = H(() => t.fill), f = H(() => t.justified), s = H(() => t.lazy), m = H(() => t.noFade), d = H(() => t.noNavStyle), c = H(() => t.pills), v = H(() => t.small), k = H(() => t.vertical), y = Pl(), h = P([]), g = b(
      () => h.value.map((O) => {
        const B = x(O), w = B.id === o.value;
        return {
          ...B,
          active: w,
          navItemClasses: [
            {
              active: w,
              disabled: B.disabled
            },
            w ? t.activeNavItemClass : t.inactiveNavItemClass,
            t.navItemClass,
            B.titleLinkClass
          ]
        };
      })
    ), S = K(() => !(g != null && g.value && g.value.length > 0)), L = b(() => ({
      "d-flex": k.value,
      "align-items-start": k.value
    })), F = mo(() => t.align), M = b(() => ({
      "nav-pills my-auto": c.value,
      "flex-column": k.value,
      [F.value]: t.align !== void 0,
      "nav-fill": u.value,
      "card-header-tabs": i.value,
      "nav-justified": f.value,
      "nav-tabs": !d.value && !c.value,
      small: v.value
    })), V = (O) => {
      var B;
      if (O !== void 0) {
        const w = (B = g.value[O]) == null ? void 0 : B.id;
        if (O > -1 && O < g.value.length && !g.value[O].disabled && (n.value < 0 || o.value !== w || n.value !== O)) {
          const z = new Mt("activate-tab", { cancelable: !0 });
          l("activate-tab", O, n.value, z), z.defaultPrevented || (o.value !== w && (o.value = w), n.value !== O && (n.value = O));
        }
      }
    }, j = (O, B) => {
      var w, z, A;
      V(B), B >= 0 && !g.value[B].disabled && ((w = g.value[B]) != null && w.onClick) && typeof g.value[B].onClick == "function" && ((A = (z = g.value[B]).onClick) == null || A.call(z, O));
    }, W = (O) => {
      var B, w;
      g.value.length <= 0 || (n.value = te(n.value + O, O), (w = document.getElementById((B = g.value[n.value]) == null ? void 0 : B.buttonId)) == null || w.focus());
    }, te = (O, B) => {
      let w = O, z = -1, A = -1;
      for (let U = 0; U < g.value.length; U++)
        g.value[U].disabled || (z === -1 && (z = U), A = U);
      for (; w >= z && w <= A && g.value[w].disabled; )
        w += B;
      return w < z && (w = z), w > A && (w = A), w;
    };
    G(n, (O, B) => {
      if (O === B || g.value.length <= 0)
        return;
      const w = te(O, O > B ? 1 : -1);
      pe(() => {
        V(w);
      });
    }), G(o, (O, B) => {
      const w = g.value.findIndex((z) => z.id === O);
      if (O !== B && !(g.value.length <= 0)) {
        if (w === -1) {
          V(te(0, 1));
          return;
        }
        V(w);
      }
    });
    const ne = (O) => {
      h.value.find((B) => B.value.id === O.value.id) ? h.value[h.value.findIndex((B) => B.value.id === O.value.id)] = O : h.value.push(O), h.value.sort((B, w) => {
        if (!Node || !B.value.el || !w.value.el)
          return 0;
        const z = B.value.el.compareDocumentPosition(w.value.el);
        return z & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : z & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
      });
    }, Q = (O) => {
      h.value = h.value.filter((B) => B.value.id !== O);
    };
    G(
      h,
      () => {
        oe();
      },
      { deep: !0 }
    );
    const oe = () => {
      var O;
      if (g.value.length === 0) {
        n.value = -1, o.value = void 0;
        return;
      }
      if (n.value >= 0 && !o.value && (o.value = (O = g.value[n.value]) == null ? void 0 : O.id), g.value.find((B) => B.id === o.value)) {
        V(g.value.findIndex((B) => B.id === o.value));
        return;
      }
      V(g.value.map((B) => !B.disabled).indexOf(!0));
    };
    return vt(Dl, {
      lazy: s,
      card: i,
      noFade: m,
      activeTabClass: K(() => t.activeTabClass ?? ""),
      inactiveTabClass: K(() => t.inactiveTabClass),
      tabClass: K(() => t.tabClass),
      registerTab: ne,
      unregisterTab: Q,
      activeId: o,
      activateTab: (O) => {
        const B = g.value.findIndex((w) => w.id === O);
        if (O === void 0 || B === -1) {
          V(te(0, 1));
          return;
        }
        V(B);
      }
    }), (O, B) => (p(), I(J(O.tag), {
      id: O.id,
      class: $(["tabs", L.value])
    }, {
      default: E(() => [
        fe(x(y).define, null, {
          default: E(() => [
            N("div", {
              class: $(["tab-content", O.contentClass])
            }, [
              C(O.$slots, "default"),
              S.value ? (p(), T("div", {
                key: "bv-empty-tab",
                class: $(["tab-pane active", { "card-body": x(i) }])
              }, [
                C(O.$slots, "empty")
              ], 2)) : R("", !0)
            ], 2)
          ]),
          _: 3
        }),
        x(r) ? (p(), I(x(y).reuse, { key: 0 })) : R("", !0),
        N("div", {
          class: $([
            O.navWrapperClass,
            { "card-header": x(i), "ms-auto": O.vertical && x(r) }
          ])
        }, [
          N("ul", {
            class: $(["nav", [M.value, O.navClass]]),
            role: "tablist",
            "aria-orientation": O.vertical ? "vertical" : "horizontal"
          }, [
            C(O.$slots, "tabs-start"),
            (p(!0), T(ee, null, se(g.value, (w, z) => (p(), T("li", {
              key: w.id,
              class: $(["nav-item", w.titleItemClass]),
              role: "presentation"
            }, [
              N("button", ae({
                id: w.buttonId,
                class: ["nav-link", w.navItemClasses],
                role: "tab",
                "aria-controls": w.id,
                "aria-selected": w.active,
                ref_for: !0
              }, w.titleLinkAttrs, {
                onKeydown: [
                  B[0] || (B[0] = _e(Ge((A) => W(-1), ["stop", "prevent"]), ["left"])),
                  B[1] || (B[1] = _e(Ge((A) => W(1), ["stop", "prevent"]), ["right"])),
                  B[2] || (B[2] = _e(Ge((A) => W(-999), ["stop", "prevent"]), ["page-up"])),
                  B[3] || (B[3] = _e(Ge((A) => W(999), ["stop", "prevent"]), ["page-down"]))
                ],
                onClick: Ge((A) => j(A, z), ["stop", "prevent"])
              }), [
                w.titleComponent ? (p(), I(J(w.titleComponent), { key: 0 })) : (p(), T(ee, { key: 1 }, [
                  q(D(w.title), 1)
                ], 64))
              ], 16, Vs)
            ], 2))), 128)),
            C(O.$slots, "tabs-end")
          ], 10, xs)
        ], 2),
        x(r) ? R("", !0) : (p(), I(x(y).reuse, { key: 1 }))
      ]),
      _: 3
    }, 8, ["id", "class"]));
  }
}), Wa = /* @__PURE__ */ Z({
  inheritAttrs: !1,
  __name: "Tab",
  props: {
    active: { type: [Boolean, String], default: !1 },
    buttonId: { default: void 0 },
    disabled: { type: [Boolean, String], default: !1 },
    id: { default: void 0 },
    lazy: { type: [Boolean, String], default: void 0 },
    lazyOnce: { type: [Boolean, String], default: void 0 },
    noBody: { type: [Boolean, String], default: !1 },
    tag: { default: "div" },
    title: { default: void 0 },
    titleItemClass: { default: void 0 },
    titleLinkAttrs: { default: void 0 },
    titleLinkClass: { default: void 0 }
  },
  emits: ["update:active"],
  setup(e, { emit: a }) {
    const t = e, l = Fe(), n = a, o = Xe(Dl, null), i = Ot(() => t.id, "tabpane"), r = Ot(() => t.buttonId, "tab"), u = H(() => t.active), f = H(() => t.disabled), s = H(() => t.lazyOnce ?? t.lazy), m = H(() => t.noBody), d = P(!1), c = P(null), { onClick: v, ...k } = vn(), y = b(
      () => ({
        id: i.value,
        buttonId: r.value,
        disabled: f.value,
        title: t.title,
        titleComponent: l.title,
        titleItemClass: t.titleItemClass,
        titleLinkAttrs: t.titleLinkAttrs,
        titleLinkClass: t.titleLinkClass,
        onClick: v,
        el: c.value
      })
    );
    Te(() => {
      o && (o.registerTab(y), u.value && o.activateTab(i.value));
    }), Tl(() => {
      o && o.unregisterTab(i.value);
    });
    const h = K(() => (o == null ? void 0 : o.activeId.value) === i.value), g = P(h.value), S = K(
      () => !!(o != null && o.lazy.value || s.value)
    ), L = K(() => t.lazyOnce !== void 0), F = K(() => h.value && !f.value), M = K(
      () => F.value || !S.value || S.value && L.value && d.value
    );
    G(h, (j) => {
      if (j) {
        n("update:active", !0), setTimeout(() => {
          g.value = !0;
        }, 0);
        return;
      }
      g.value = !1, n("update:active", !1);
    }), G(u, (j) => {
      if (o) {
        if (!j) {
          h.value && o.activateTab(void 0);
          return;
        }
        o.activateTab(i.value);
      }
    });
    const V = b(() => [
      {
        active: h.value,
        show: g.value,
        "card-body": (o == null ? void 0 : o.card.value) && m.value === !1,
        fade: !(o != null && o.noFade.value)
      },
      g.value ? o == null ? void 0 : o.activeTabClass : o == null ? void 0 : o.inactiveTabClass,
      o == null ? void 0 : o.tabClass
    ]);
    return G(M, (j) => {
      j && !d.value && (d.value = !0);
    }), (j, W) => (p(), I(J(j.tag), ae({
      id: x(i),
      ref_key: "el",
      ref: c,
      class: ["tab-pane", V.value],
      role: "tabpanel",
      "aria-labelledby": x(r)
    }, k), {
      default: E(() => [
        M.value ? C(j.$slots, "default", { key: 0 }) : R("", !0)
      ]),
      _: 3
    }, 16, ["id", "class", "aria-labelledby"]));
  }
}), Ts = {
  install: (e) => {
    e.component("BTabs", Ga), e.component("BTab", Wa);
  }
}, Fs = ["id", "aria-label"], As = { class: "me-auto" }, Os = {
  __name: "Toast",
  props: {
    autoHideDelay: {
      type: [Number, String],
      default: 5e3
    },
    bodyClass: {
      type: [Array, Object, String],
      default: void 0
    },
    headerClass: {
      type: [Array, Object, String],
      default: void 0
    },
    id: {
      type: String,
      default: void 0
    },
    noAutoHide: {
      type: Boolean,
      default: !1
    },
    noCloseButton: {
      type: Boolean,
      default: !1
    },
    noFade: {
      type: Boolean,
      default: !1
    },
    noHoverPause: {
      type: Boolean,
      default: !0
    },
    pos: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: void 0
    },
    toastClass: {
      type: [Array, Object, String],
      default: void 0
    },
    variant: {
      type: String,
      default: "secondary"
    },
    visible: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["shown", "show", "hidden", "hide", "change"],
  setup(e, { emit: a }) {
    const t = P(null), l = Xn(t), n = e, o = P(!1);
    let i = {};
    function r() {
      o.value = !1, f("change", { visible: !1 }), f("hidden");
    }
    function u(d) {
      o.value = d, f("shown"), n.noAutoHide || (i = vo(n.autoHideDelay, () => {
        f("hide"), r();
      }));
    }
    const f = a, s = b(() => {
      const d = n == null ? void 0 : n.variant, c = n == null ? void 0 : n.toastClass;
      return [
        "toast",
        d && `bg-${n.variant}`,
        c,
        { show: o.value, hide: !o.value }
      ];
    }), m = b(() => o.value ? "The toast is visible" : "The toast is hidden");
    return G(l, (d) => {
      n.noAutoHide || (d && !n.noHoverPause ? i.pauseTimer() : i.resumeTimer());
    }), n.visible && (f("show"), f("change", { visible: n.visible }), u(n.visible)), (d, c) => (p(), I(Et, {
      name: e.noFade ? "" : "fade"
    }, {
      default: E(() => [
        o.value ? (p(), T("div", {
          key: 0,
          id: e.id,
          ref_key: "root",
          ref: t,
          class: $(s.value),
          "aria-label": m.value,
          "aria-live": "polite",
          "aria-atomic": "true"
        }, [
          N("div", {
            class: $(["toast-header", e.headerClass])
          }, [
            C(d.$slots, "toast-title", {}, () => [
              N("strong", As, D(e.title), 1)
            ], !0),
            e.noCloseButton ? R("", !0) : (p(), T("button", {
              key: 0,
              type: "button",
              class: "btn-close",
              onClick: r
            }))
          ], 2),
          N("div", {
            class: $(["toast-body", e.bodyClass])
          }, [
            C(d.$slots, "default", {}, void 0, !0)
          ], 2)
        ], 10, Fs)) : R("", !0)
      ]),
      _: 3
    }, 8, ["name"]));
  }
}, sl = /* @__PURE__ */ Ae(Os, [["__scopeId", "data-v-29fe775c"]]), Ua = Bn(() => {
  const e = P([]);
  return {
    toasts: e,
    toast: (n, o = {}) => {
      e.value.push({
        message: n,
        options: {
          ...o,
          visible: !0,
          pos: o.pos ? o.pos : "toaster-top-right",
          // default position is top right
          variant: o.variant ? o.variant : "secondary"
          // default variant is secondary
        }
      });
    },
    hide: (n) => {
      e.value = e.value.filter((o) => o.options.id !== n);
    },
    hideAll: () => {
      e.value = [];
    }
  };
}), Is = ["id", "aria-atomic", "aria-live", "role"], Ps = {
  __name: "Toaster",
  props: {
    pos: {
      type: String,
      default: void 0
    },
    ariaAtomic: {
      type: String,
      default: "true"
    },
    ariaLive: {
      type: String,
      default: "polite"
    },
    role: {
      type: String,
      default: "alert"
    }
  },
  setup(e) {
    const a = e, t = b(() => a.pos ? a.pos : "toaster-top-right"), l = b(() => {
      const i = a.pos ? a.pos : "toaster-top-right";
      return i === "toaster-top-right" ? "top-0 end-0" : i === "toaster-top-center" ? "top-0 start-50 translate-middle-x" : i === "toaster-top-left" ? "top-0 start-0" : i === "toaster-middle-right" ? "top-50 end-0 translate-middle-y" : i === "toaster-middle-center" ? "top-50 start-50 translate-middle" : i === "toaster-middle-left" ? "top-50 start-0 translate-middle-y" : i === "toaster-bottom-left" ? "bottom-0 start-0" : i === "toaster-bottom-center" ? "bottom-0 start-50 translate-middle-x" : i === "toaster-bottom-right" ? "bottom-0 end-0" : "top-50 start-50 translate-middle";
    }), { toasts: n, hideAll: o } = Ua();
    return Tl(() => {
      o();
    }), (i, r) => (p(), I(mt, { to: "body" }, [
      N("div", {
        id: t.value,
        ref: "toaster",
        class: $(["toast-container p-3", l.value]),
        "aria-atomic": e.ariaAtomic,
        "aria-live": e.ariaLive,
        role: e.role
      }, [
        (p(!0), T(ee, null, se(x(n), (u) => (p(), T(ee, {
          key: u.options.id
        }, [
          u.options.pos === t.value ? (p(), I(sl, ae({
            key: 0,
            ref_for: !0
          }, u.options), {
            default: E(() => [
              q(D(u.message), 1)
            ]),
            _: 2
          }, 1040)) : R("", !0)
        ], 64))), 128)),
        C(i.$slots, "default", {}, void 0, !0)
      ], 10, Is)
    ]));
  }
}, Xa = /* @__PURE__ */ Ae(Ps, [["__scopeId", "data-v-d96ab560"]]), Ls = {
  install: (e) => {
    const a = Ua();
    e.component("BToast", sl), e.component("BToaster", Xa), e.config.globalProperties.$toast = a, e.provide("$toast", a);
  }
}, Es = ["id"], Ka = {
  __name: "Tooltip",
  props: {
    title: {
      type: String,
      default: void 0
    },
    placement: {
      type: String,
      default: void 0
    },
    triggers: {
      type: [String, Array],
      default: () => ["hover", "focus"]
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    target: {
      type: String,
      required: !0
    },
    variant: {
      type: String,
      default: "dark"
    },
    id: {
      type: String,
      default: void 0
    },
    customClass: {
      type: String,
      default: void 0
    },
    show: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "disabled",
    "enabled",
    "show",
    "shown",
    "hide",
    "hidden"
  ],
  setup(e, { emit: a }) {
    const t = Fe(), l = a, n = e, o = P(n.show), i = P(null), r = P(null), u = P(null);
    Te(() => {
      r.value = document.getElementById(n.target), r.value.setAttribute("aria-describedby", y.value), n.triggers.includes("hover") && (r.value.addEventListener("mouseenter", m), r.value.addEventListener("mouseleave", d)), n.triggers.includes("click") && (r.value.addEventListener("click", c), r.value.addEventListener("mouseleave", d)), n.triggers.includes("focus") && (r.value.addEventListener("focus", m), r.value.addEventListener("blur", d));
    }), G(
      () => o.value,
      () => {
        o.value ? pe(() => {
          v();
        }) : s("hidden");
      },
      { immediate: !0 }
    ), G(
      () => n.show,
      () => {
        n.show ? o.value = !0 : o.value = !1;
      },
      { immediate: !0 }
    ), G(
      () => n.disabled,
      () => {
        n.disabled ? s("disabled") : s("enabled");
      },
      { immediate: !0 }
    ), Vl(() => {
      o.value && (o.value = !1);
    });
    function f(h, g = {}) {
      return new CustomEvent(h, {
        cancelable: !1,
        ...g
      });
    }
    function s(h, g = {}) {
      if (h) {
        const S = f(h, g);
        l(h, S);
      }
    }
    function m() {
      o.value || (o.value = !0);
    }
    function d() {
      o.value && (s("hide", { cancelable: !0 }), o.value = !1);
    }
    function c() {
      o.value = !o.value;
    }
    function v() {
      o.value && (n.title || t.default) && !n.disabled && (s("show", { cancelable: !0 }), Ct(r.value, i.value, {
        placement: n.placement || "top",
        middleware: [
          ht(8),
          yt(),
          qt({ padding: 5 }),
          Xt({ element: u.value })
        ]
      }).then(({ x: h, y: g, placement: S, middlewareData: L }) => {
        Object.assign(i.value.style, {
          left: `${h}px`,
          top: `${g}px`
        });
        const { x: F, y: M } = L.arrow, V = {
          top: "bottom",
          right: "left",
          bottom: "top",
          left: "right"
        }[S.split("-")[0]];
        Object.assign(u.value.style, {
          left: F != null ? `${F}px` : "",
          top: M != null ? `${M}px` : "",
          right: "",
          bottom: "",
          [V]: "-4px"
        });
      }), i.value.classList.add("show"), s("shown"));
    }
    const k = b(() => ({
      [`bg-${n.variant}`]: n.variant,
      [n.customClass]: n.customClass
    })), y = b(
      () => n.id || `tooltip-${Math.random().toString(36).substring(2, 11)}`
    );
    return (h, g) => (p(), I(mt, { to: "body" }, [
      o.value ? (p(), T("div", {
        key: 0,
        id: y.value,
        ref_key: "tooltip",
        ref: i,
        class: $(["tooltip fade", k.value]),
        role: "tooltip",
        tabindex: "-1"
      }, [
        C(h.$slots, "default", {}, () => [
          q(D(e.title), 1)
        ]),
        N("div", {
          ref_key: "tooltipArrow",
          ref: u,
          class: $(["arrow", `bg-${e.variant}`])
        }, null, 2)
      ], 10, Es)) : R("", !0)
    ]));
  }
}, Ns = {
  install: (e) => {
    e.component("BTooltip", Ka);
  }
}, kl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BAlert: Fl,
  BAlertPlugin: bn,
  BBadge: Al,
  BBadgePlugin: hn,
  BBreadcrumb: Nl,
  BBreadcrumbItem: Dt,
  BBreadcrumbPlugin: ao,
  BButton: st,
  BButtonPlugin: no,
  BCard: _l,
  BCardBody: _t,
  BCardFooter: el,
  BCardGroup: la,
  BCardHeadFoot: wt,
  BCardHeader: Jt,
  BCardImg: Yt,
  BCardImgLazy: ea,
  BCardPlugin: Ko,
  BCardSubTitle: Qt,
  BCardText: ta,
  BCardTitle: Zt,
  BCollapse: aa,
  BCollapsePlugin: ia,
  BDropdownItem: sa,
  BDropdownPlugin: Qo,
  BForm: ra,
  BFormCheckbox: nl,
  BFormCheckboxGroup: Ca,
  BFormCheckboxPlugin: wa,
  BFormDatalist: fa,
  BFormFile: Ta,
  BFormFilePlugin: Fa,
  BFormGroup: ma,
  BFormGroupPlugin: ga,
  BFormInput: pa,
  BFormInputGroupPlugin: ha,
  BFormInputPlugin: ba,
  BFormInvalidFeedback: ua,
  BFormPlugin: va,
  BFormRadio: ol,
  BFormRadioGroup: Sa,
  BFormRadioPlugin: $a,
  BFormSelect: xa,
  BFormSelectOption: St,
  BFormSelectOptionGroup: il,
  BFormSelectPlugin: Va,
  BFormText: ca,
  BFormTextarea: Ba,
  BFormTextareaPlugin: ka,
  BFormValidFeedback: da,
  BFormsPlugin: Fi,
  BImagePlugin: Ai,
  BImg: Kt,
  BImgLazy: tl,
  BInputGroup: ya,
  BInputGroupAppend: ll,
  BInputGroupPrepend: al,
  BInputGroupText: Re,
  BLink: gt,
  BLinkPlugin: Oi,
  BModal: Aa,
  BModalPlugin: Di,
  BNavItem: Ia,
  BNavItemDropdown: Pa,
  BNavPlugin: La,
  BNavbar: Ea,
  BNavbarNav: Na,
  BNavbarPlugin: Gi,
  BNavbarToggle: za,
  BPagination: Da,
  BPaginationPlugin: es,
  BPopover: Ma,
  BPopoverPlugin: ns,
  BProgress: ja,
  BProgressPlugin: is,
  BSpinner: Ha,
  BSpinnerPlugin: rs,
  BTab: Wa,
  BTable: qa,
  BTablePlugin: $s,
  BTabs: Ga,
  BTabsPlugin: Ts,
  BToast: sl,
  BToastPlugin: Ls,
  BToaster: Xa,
  BTooltip: Ka,
  BTooltipPlugin: Ns
}, Symbol.toStringTag, { value: "Module" })), Ya = {
  mounted(e, a, t) {
    Zl(e, a, t, "tooltip");
  },
  beforeUnmount() {
    Rt("tooltip");
  }
}, zs = {
  mounted(e, a, t) {
    Zl(e, a, t, "popover");
  },
  beforeUnmount() {
    Rt("popover");
  }
}, Ft = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  VBPopover: zs,
  VBToggle: oa,
  VBTooltip: Ya
}, Symbol.toStringTag, { value: "Module" })), Rs = {
  install: (e) => {
    e.directive("BTooltip", Ya);
  }
}, js = {
  install: (e) => {
    for (const a in kl)
      e.component(a, kl[a]);
    for (const a in Ft)
      e.directive(a, Ft[a].name, a, Ft[a]);
    for (const a in Bl)
      e.use(Bl[a]);
  }
};
export {
  Fl as BAlert,
  bn as BAlertPlugin,
  Al as BBadge,
  hn as BBadgePlugin,
  Nl as BBreadcrumb,
  Dt as BBreadcrumbItem,
  ao as BBreadcrumbPlugin,
  st as BButton,
  no as BButtonPlugin,
  _l as BCard,
  _t as BCardBody,
  el as BCardFooter,
  la as BCardGroup,
  wt as BCardHeadFoot,
  Jt as BCardHeader,
  Yt as BCardImg,
  ea as BCardImgLazy,
  Ko as BCardPlugin,
  Qt as BCardSubTitle,
  ta as BCardText,
  Zt as BCardTitle,
  aa as BCollapse,
  ia as BCollapsePlugin,
  sa as BDropdownItem,
  Qo as BDropdownPlugin,
  ra as BForm,
  nl as BFormCheckbox,
  Ca as BFormCheckboxGroup,
  wa as BFormCheckboxPlugin,
  fa as BFormDatalist,
  Ta as BFormFile,
  Fa as BFormFilePlugin,
  ma as BFormGroup,
  ga as BFormGroupPlugin,
  pa as BFormInput,
  ha as BFormInputGroupPlugin,
  ba as BFormInputPlugin,
  ua as BFormInvalidFeedback,
  va as BFormPlugin,
  ol as BFormRadio,
  Sa as BFormRadioGroup,
  $a as BFormRadioPlugin,
  xa as BFormSelect,
  St as BFormSelectOption,
  il as BFormSelectOptionGroup,
  Va as BFormSelectPlugin,
  ca as BFormText,
  Ba as BFormTextarea,
  ka as BFormTextareaPlugin,
  da as BFormValidFeedback,
  Fi as BFormsPlugin,
  Ai as BImagePlugin,
  Kt as BImg,
  tl as BImgLazy,
  ya as BInputGroup,
  ll as BInputGroupAppend,
  al as BInputGroupPrepend,
  Re as BInputGroupText,
  gt as BLink,
  Oi as BLinkPlugin,
  Aa as BModal,
  Di as BModalPlugin,
  Ia as BNavItem,
  Pa as BNavItemDropdown,
  La as BNavPlugin,
  Ea as BNavbar,
  Na as BNavbarNav,
  Gi as BNavbarPlugin,
  za as BNavbarToggle,
  Da as BPagination,
  es as BPaginationPlugin,
  Ma as BPopover,
  ns as BPopoverPlugin,
  ja as BProgress,
  is as BProgressPlugin,
  Ha as BSpinner,
  rs as BSpinnerPlugin,
  Wa as BTab,
  qa as BTable,
  $s as BTablePlugin,
  Ga as BTabs,
  Ts as BTabsPlugin,
  sl as BToast,
  Ls as BToastPlugin,
  Xa as BToaster,
  Ka as BTooltip,
  Ns as BTooltipPlugin,
  kl as Components,
  Ft as Directives,
  Bl as Plugins,
  zs as VBPopover,
  oa as VBToggle,
  Zo as VBTogglePlugin,
  Ya as VBTooltip,
  Rs as VBTooltipPlugin,
  js as default,
  Oa as modalManagerPlugin
};
